if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
// 初始化缓存
if (!window.Shopify._cartCache) {
    window.Shopify._cartCache = {
        data: null,
        timestamp: 0,
        pendingRequest: null
    };
}
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      // 检查缓存，如果 500ms 内有请求，使用缓存数据
      var now = (new Date).getTime();
      if (window.Shopify._cartCache.data && (now - window.Shopify._cartCache.timestamp) < 500) {
        if((typeof callback) === 'function'){
          callback(window.Shopify._cartCache.data, "success", null);
        } else if(typeof Shopify.onCartUpdate === 'function'){
          Shopify.onCartUpdate(window.Shopify._cartCache.data);
        }
        return;
      }
      // 如果有正在进行的请求，等待它完成
      if (window.Shopify._cartCache.pendingRequest) {
        return window.Shopify._cartCache.pendingRequest.then(function(cachedCart) {
          if((typeof callback) === 'function'){
            callback(cachedCart, "success", null);
          } else if(typeof Shopify.onCartUpdate === 'function'){
            Shopify.onCartUpdate(cachedCart);
          }
        });
      }
      // 创建新的请求
      window.Shopify._cartCache.pendingRequest = jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        // 更新缓存
        window.Shopify._cartCache.data = cart;
        window.Shopify._cartCache.timestamp = (new Date).getTime();
        window.Shopify._cartCache.pendingRequest = null;
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else if(typeof Shopify.onCartUpdate === 'function'){
            Shopify.onCartUpdate(cart);
        }
      });
      return window.Shopify._cartCache.pendingRequest;
    } else {
      // 更新缓存
      window.Shopify._cartCache.data = cart;
      window.Shopify._cartCache.timestamp = (new Date).getTime();
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

(()=>{
    if (typeof Shopify === "undefined") {
        window.Shopify = {}
    }
    // 添加缓存和防抖机制，避免重复请求 cart.js
    if (!window.Shopify._cartCache) {
        window.Shopify._cartCache = {
            data: null,
            timestamp: 0,
            pendingRequest: null
        };
    }
    if (typeof Shopify.getCart === "undefined") {
        Shopify.getCart = function(callback, cart) {
            var promise = jQuery.Deferred();
            if (!cart) {
                // 检查缓存，如果 500ms 内有请求，使用缓存数据
                var now = (new Date).getTime();
                if (window.Shopify._cartCache.data && (now - window.Shopify._cartCache.timestamp) < 500) {
                    promise.resolve();
                    if (typeof callback === "function") {
                        return callback(window.Shopify._cartCache.data, "success", null)
                    } else if (typeof Shopify.onCartUpdate === "function") {
                        return Shopify.onCartUpdate(window.Shopify._cartCache.data)
                    }
                    return promise;
                }
                // 如果有正在进行的请求，等待它完成
                if (window.Shopify._cartCache.pendingRequest) {
                    return window.Shopify._cartCache.pendingRequest.then(function(cachedCart) {
                        promise.resolve();
                        if (typeof callback === "function") {
                            return callback(cachedCart, "success", null)
                        } else if (typeof Shopify.onCartUpdate === "function") {
                            return Shopify.onCartUpdate(cachedCart)
                        }
                        return promise;
                    });
                }
                // 创建新的请求
                var o = (new Date).getTime();
                window.Shopify._cartCache.pendingRequest = jQuery.ajax({
                    type: "GET",
                    url: "/cart.js?_=" + o,
                    dataType: "json",
                    async: false,
                    success: function(cart, textStatus, xhr) {
                        // 更新缓存
                        window.Shopify._cartCache.data = cart;
                        window.Shopify._cartCache.timestamp = (new Date).getTime();
                        window.Shopify._cartCache.pendingRequest = null;
                        promise.resolve();
                        if (typeof callback === "function") {
                            return callback(cart, textStatus, xhr)
                        } else if (typeof Shopify.onCartUpdate === "function") {
                            return Shopify.onCartUpdate(cart)
                        }
                    }
                }).then(function(cart) {
                    return cart;
                });
                return promise;
            } else {
                // 更新缓存
                window.Shopify._cartCache.data = cart;
                window.Shopify._cartCache.timestamp = (new Date).getTime();
                promise.resolve();
                if (typeof callback === "function") {
                    return callback(cart)
                } else if (typeof Shopify.onCartUpdate === "function") {
                    return Shopify.onCartUpdate(cart)
                }
            }
            return promise
        }
    }
    var __defProp = Object.defineProperty;
    var __defNormalProp = (obj,key,value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
    var __publicField = (obj,key,value)=>{
        __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
        return value
    }
    ;
    function rollingHash(s) {
        let ret = 0;
        let mod = 2147483647;
        let p = 307;
        let pp = 1;
        for (const i of s) {
            ret = (ret + i.charCodeAt() * pp) % mod;
            pp = pp * p % mod
        }
        return ret
    }
    function Delegate(root) {
        this.listenerMap = [{}, {}];
        if (root) {
            this.root(root)
        }
        this.handle = Delegate.prototype.handle.bind(this);
        this._removedListeners = []
    }
    function changeCurrency(currency = 'USD', money){
        let arr = money.split(',');
        let m = arr.filter((v) => v.indexOf(currency) > -1)
        if(m.length){
            let value = m[0].split(':')[1]
            return Number(value)
        }
        return 9999999
    }
    function getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    }
    Delegate.prototype.root = function(root) {
        const listenerMap = this.listenerMap;
        let eventType;
        if (this.rootElement) {
            for (eventType in listenerMap[1]) {
                if (listenerMap[1].hasOwnProperty(eventType)) {
                    this.rootElement.removeEventListener(eventType, this.handle, true)
                }
            }
            for (eventType in listenerMap[0]) {
                if (listenerMap[0].hasOwnProperty(eventType)) {
                    this.rootElement.removeEventListener(eventType, this.handle, false)
                }
            }
        }
        if (!root || !root.addEventListener) {
            if (this.rootElement) {
                delete this.rootElement
            }
            return this
        }
        this.rootElement = root;
        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.addEventListener(eventType, this.handle, true)
            }
        }
        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.addEventListener(eventType, this.handle, false)
            }
        }
        return this
    }
    ;
    Delegate.prototype.captureForType = function(eventType) {
        return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1
    }
    ;
    Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
        let root;
        let listenerMap;
        let matcher;
        let matcherParam;
        if (!eventType) {
            throw new TypeError("Invalid event type: " + eventType)
        }
        if (typeof selector === "function") {
            useCapture = handler;
            handler = selector;
            selector = null
        }
        if (useCapture === void 0) {
            useCapture = this.captureForType(eventType)
        }
        if (typeof handler !== "function") {
            throw new TypeError("Handler must be a type of Function")
        }
        root = this.rootElement;
        listenerMap = this.listenerMap[useCapture ? 1 : 0];
        if (!listenerMap[eventType]) {
            if (root) {
                root.addEventListener(eventType, this.handle, useCapture)
            }
            listenerMap[eventType] = []
        }
        if (!selector) {
            matcherParam = null;
            matcher = matchesRoot.bind(this)
        } else if (/^[a-z]+$/i.test(selector)) {
            matcherParam = selector;
            matcher = matchesTag
        } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
            matcherParam = selector.slice(1);
            matcher = matchesId
        } else {
            matcherParam = selector;
            matcher = Element.prototype.matches
        }
        listenerMap[eventType].push({
            selector: selector,
            handler: handler,
            matcher: matcher,
            matcherParam: matcherParam
        });
        return this
    }
    ;
    Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
        let i;
        let listener;
        let listenerMap;
        let listenerList;
        let singleEventType;
        if (typeof selector === "function") {
            useCapture = handler;
            handler = selector;
            selector = null
        }
        if (useCapture === void 0) {
            this.off(eventType, selector, handler, true);
            this.off(eventType, selector, handler, false);
            return this
        }
        listenerMap = this.listenerMap[useCapture ? 1 : 0];
        if (!eventType) {
            for (singleEventType in listenerMap) {
                if (listenerMap.hasOwnProperty(singleEventType)) {
                    this.off(singleEventType, selector, handler)
                }
            }
            return this
        }
        listenerList = listenerMap[eventType];
        if (!listenerList || !listenerList.length) {
            return this
        }
        for (i = listenerList.length - 1; i >= 0; i--) {
            listener = listenerList[i];
            if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
                this._removedListeners.push(listener);
                listenerList.splice(i, 1)
            }
        }
        if (!listenerList.length) {
            delete listenerMap[eventType];
            if (this.rootElement) {
                this.rootElement.removeEventListener(eventType, this.handle, useCapture)
            }
        }
        return this
    }
    ;
    Delegate.prototype.handle = function(event) {
        let i;
        let l;
        const type = event.type;
        let root;
        let phase;
        let listener;
        let returned;
        let listenerList = [];
        let target;
        const eventIgnore = "ftLabsDelegateIgnore";
        if (event[eventIgnore] === true) {
            return
        }
        target = event.target;
        if (target.nodeType === 3) {
            target = target.parentNode
        }
        if (target.correspondingUseElement) {
            target = target.correspondingUseElement
        }
        root = this.rootElement;
        phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
        switch (phase) {
        case 1:
            listenerList = this.listenerMap[1][type];
            break;
        case 2:
            if (this.listenerMap[0] && this.listenerMap[0][type]) {
                listenerList = listenerList.concat(this.listenerMap[0][type])
            }
            if (this.listenerMap[1] && this.listenerMap[1][type]) {
                listenerList = listenerList.concat(this.listenerMap[1][type])
            }
            break;
        case 3:
            listenerList = this.listenerMap[0][type];
            break
        }
        let toFire = [];
        l = listenerList.length;
        while (target && l) {
            for (i = 0; i < l; i++) {
                listener = listenerList[i];
                if (!listener) {
                    break
                }
                if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
                    toFire = []
                } else if (listener.matcher.call(target, listener.matcherParam, target)) {
                    toFire.push([event, target, listener])
                }
            }
            if (target === root) {
                break
            }
            l = listenerList.length;
            target = target.parentElement || target.parentNode;
            if (target instanceof HTMLDocument) {
                break
            }
        }
        let ret;
        for (i = 0; i < toFire.length; i++) {
            if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
                continue
            }
            returned = this.fire.apply(this, toFire[i]);
            if (returned === false) {
                toFire[i][0][eventIgnore] = true;
                toFire[i][0].preventDefault();
                ret = false;
                break
            }
        }
        return ret
    }
    ;
    Delegate.prototype.fire = function(event, target, listener) {
        return listener.handler.call(target, event, target)
    }
    ;
    function matchesTag(tagName, element) {
        return tagName.toLowerCase() === element.tagName.toLowerCase()
    }
    function matchesRoot(selector, element) {
        if (this.rootElement === window) {
            return element === document || element === document.documentElement || element === window
        }
        return this.rootElement === element
    }
    function matchesId(id, element) {
        return id === element.id
    }
    Delegate.prototype.destroy = function() {
        this.off();
        this.root()
    }
    ;
    var main_default = Delegate;
    var InputBindingManager = class {
        constructor() {
            this.delegateElement = new main_default(document.body);
            this.delegateElement.on("change", "[data-bind-value]", this._onValueChanged.bind(this))
        }
        _onValueChanged(event, target) {
            const boundElement = document.getElementById(target.getAttribute("data-bind-value"));
            if (boundElement) {
                if (target.tagName === "SELECT") {
                    target = target.options[target.selectedIndex]
                }
                boundElement.innerHTML = target.hasAttribute("title") ? target.getAttribute("title") : target.value
            }
        }
    }
    ;
    class HTMLUpdateUtility {
        /**
        * Used to swap an HTML node with a new node.
        * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
        *
        * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
        */
        static viewTransition(oldNode, newContent, scrollToppx = 0, newUrl) {
            const combosTitle = oldNode.querySelector('#main .product-meta__title')?.innerHTML;
            if(!combosTitle) return;
            // preProcessCallbacks?.forEach((callback) => callback(newContent));
            const newNodeWrapper = document.createElement('div');
            HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent);
            const newNode = newNodeWrapper.firstChild;
                const titleEles = newNode.querySelectorAll('.product-meta__title');
                const stickytitleEle = newNode.querySelector('.product-sticky-form__title');
                const addButtonEles = newNode.querySelectorAll('.product-form__add-button');
                if (titleEles.length > 0) {
                    titleEles.forEach((titleEle) => {
                        titleEle.innerHTML = combosTitle;
                    })
                    stickytitleEle.innerHTML = combosTitle;
                }
                if (addButtonEles.length > 0) {
                    addButtonEles.forEach((addButtonEle) => {
                        addButtonEle.setAttribute('data-combostitle', combosTitle);
                    }) 
                }
            
            // dedupe IDs
            const uniqueKey = Date.now();
            oldNode.querySelectorAll('[id], [form]').forEach((element) => {
                element.id && (element.id = `${element.id}-${uniqueKey}`);
                element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
            });

            oldNode.parentNode.insertBefore(newNode, oldNode);
            oldNode.style.display = 'none';
            history.replaceState(null, '', newUrl); // 不会刷新页面
            window.scrollTo({
                top: scrollToppx,
                behavior: 'instant',
            });
            // postProcessCallbacks?.forEach((callback) => callback(newNode));
            setTimeout(() => oldNode.remove(), 500);
        }

        // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        static setInnerHTML(element, html) {
            element.innerHTML = html;
            element.querySelectorAll('script').forEach((oldScriptTag) => {
                const newScriptTag = document.createElement('script');
                Array.from(oldScriptTag.attributes).forEach((attribute) => {
                    newScriptTag.setAttribute(attribute.name, attribute.value);
                });
                newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
                oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
        }
    }
    function triggerEvent(element, name, data={}) {
        element.dispatchEvent(new CustomEvent(name,{
            bubbles: true,
            detail: data
        }))
    }
    function runWhenIdle(callback, options = {}) { // 浏览器空闲时执行回调函数
        if (typeof window.requestIdleCallback === 'function') {
            return window.requestIdleCallback(callback, options);
        } else {
            return setTimeout(() => {
                callback({
                    didTimeout: true,
                    timeRemaining: () => 0
                });
            }, options.timeout || 1); // 尽快执行
        }
    }

    function triggerNonBubblingEvent(element, name, data={}) {
        element.dispatchEvent(new CustomEvent(name,{
            bubbles: false,
            detail: data
        }))
    }
    var CustomHTMLElement = class extends HTMLElement {
        constructor() {
            super();
            this._hasSectionReloaded = false;
            if (Shopify.designMode) {
                this.rootDelegate.on("shopify:section:select", event=>{
                    const parentSection = this.closest(".shopify-section");
                    if (event.target === parentSection && event.detail.load) {
                        this._hasSectionReloaded = true
                    }
                }
                )
            }
        }
        get rootDelegate() {
            return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement)
        }
        get delegate() {
            return this._delegate = this._delegate || new main_default(this)
        }
        showLoadingBar() {
            triggerEvent(document.documentElement, "theme:loading:start")
        }
        hideLoadingBar() {
            triggerEvent(document.documentElement, "theme:loading:end")
        }
        untilVisible(intersectionObserverOptions={
            rootMargin: "0px",
            threshold: .2
        }) {
            const onBecameVisible = ()=>{
                this.classList.add("became-visible");
                this.style.opacity = "1"
            }
            ;
            return new Promise(resolve=>{
                if (window.IntersectionObserver) {
                    this.intersectionObserver = new IntersectionObserver(event=>{
                        if (event[0].isIntersecting) {
                            this.intersectionObserver.disconnect();
                            requestAnimationFrame(()=>{
                                resolve();
                                onBecameVisible()
                            }
                            )
                        }
                    }
                    ,intersectionObserverOptions);
                    this.intersectionObserver.observe(this)
                } else {
                    resolve();
                    onBecameVisible()
                }
            }
            )
        }
        disconnectedCallback() {
            var _a;
            this.delegate.destroy();
            this.rootDelegate.destroy();
            (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
            delete this._delegate;
            delete this._rootDelegate
        }
    }
    ;
    var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
    var candidateSelector = candidateSelectors.join(",");
    var matches = typeof Element === "undefined" ? function() {}
    : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var getCandidates = function getCandidates2(el, includeContainer, filter) {
        var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
        if (includeContainer && matches.call(el, candidateSelector)) {
            candidates.unshift(el)
        }
        candidates = candidates.filter(filter);
        return candidates
    };
    var isContentEditable = function isContentEditable2(node) {
        return node.contentEditable === "true"
    };
    var getTabindex = function getTabindex2(node) {
        var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
        if (!isNaN(tabindexAttr)) {
            return tabindexAttr
        }
        if (isContentEditable(node)) {
            return 0
        }
        if ((node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) {
            return 0
        }
        return node.tabIndex
    };
    var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
        return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex
    };
    var isInput = function isInput2(node) {
        return node.tagName === "INPUT"
    };
    var isHiddenInput = function isHiddenInput2(node) {
        return isInput(node) && node.type === "hidden"
    };
    var isDetailsWithSummary = function isDetailsWithSummary2(node) {
        var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
            return child.tagName === "SUMMARY"
        });
        return r
    };
    var getCheckedRadio = function getCheckedRadio2(nodes, form) {
        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].checked && nodes[i].form === form) {
                return nodes[i]
            }
        }
    };
    var isTabbableRadio = function isTabbableRadio2(node) {
        if (!node.name) {
            return true
        }
        var radioScope = node.form || node.ownerDocument;
        var queryRadios = function queryRadios2(name) {
            return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]')
        };
        var radioSet;
        if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
            radioSet = queryRadios(window.CSS.escape(node.name))
        } else {
            try {
                radioSet = queryRadios(node.name)
            } catch (err) {
                console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
                return false
            }
        }
        var checked = getCheckedRadio(radioSet, node.form);
        return !checked || checked === node
    };
    var isRadio = function isRadio2(node) {
        return isInput(node) && node.type === "radio"
    };
    var isNonTabbableRadio = function isNonTabbableRadio2(node) {
        return isRadio(node) && !isTabbableRadio(node)
    };
    var isHidden = function isHidden2(node, displayCheck) {
        if (getComputedStyle(node).visibility === "hidden") {
            return true
        }
        var isDirectSummary = matches.call(node, "details>summary:first-of-type");
        var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
        if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
            return true
        }
        if (!displayCheck || displayCheck === "full") {
            while (node) {
                if (getComputedStyle(node).display === "none") {
                    return true
                }
                node = node.parentElement
            }
        } else if (displayCheck === "non-zero-area") {
            var _node$getBoundingClie = node.getBoundingClientRect()
              , width = _node$getBoundingClie.width
              , height = _node$getBoundingClie.height;
            return width === 0 && height === 0
        }
        return false
    };
    var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
        if (isInput(node) || node.tagName === "SELECT" || node.tagName === "TEXTAREA" || node.tagName === "BUTTON") {
            var parentNode = node.parentElement;
            while (parentNode) {
                if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                    for (var i = 0; i < parentNode.children.length; i++) {
                        var child = parentNode.children.item(i);
                        if (child.tagName === "LEGEND") {
                            if (child.contains(node)) {
                                return false
                            }
                            return true
                        }
                    }
                    return true
                }
                parentNode = parentNode.parentElement
            }
        }
        return false
    };
    var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
        if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
            return false
        }
        return true
    };
    var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
        if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
            return false
        }
        return true
    };
    var tabbable = function tabbable2(el, options) {
        options = options || {};
        var regularTabbables = [];
        var orderedTabbables = [];
        var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
        candidates.forEach(function(candidate, i) {
            var candidateTabindex = getTabindex(candidate);
            if (candidateTabindex === 0) {
                regularTabbables.push(candidate)
            } else {
                orderedTabbables.push({
                    documentOrder: i,
                    tabIndex: candidateTabindex,
                    node: candidate
                })
            }
        });
        var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function(a) {
            return a.node
        }).concat(regularTabbables);
        return tabbableNodes
    };
    var focusableCandidateSelector = candidateSelectors.concat("iframe").join(",");
    var isFocusable = function isFocusable2(node, options) {
        options = options || {};
        if (!node) {
            throw new Error("No node provided")
        }
        if (matches.call(node, focusableCandidateSelector) === false) {
            return false
        }
        return isNodeMatchingSelectorFocusable(options, node)
    };
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) {
                symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable
                })
            }
            keys.push.apply(keys, symbols)
        }
        return keys
    }
    function _objectSpread2(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) {
                ownKeys(Object(source), true).forEach(function(key) {
                    _defineProperty(target, key, source[key])
                })
            } else if (Object.getOwnPropertyDescriptors) {
                Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
            } else {
                ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key))
                })
            }
        }
        return target
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            })
        } else {
            obj[key] = value
        }
        return obj
    }
    var activeFocusTraps = function() {
        var trapQueue = [];
        return {
            activateTrap: function activateTrap(trap) {
                if (trapQueue.length > 0) {
                    var activeTrap = trapQueue[trapQueue.length - 1];
                    if (activeTrap !== trap) {
                        activeTrap.pause()
                    }
                }
                var trapIndex = trapQueue.indexOf(trap);
                if (trapIndex === -1) {
                    trapQueue.push(trap)
                } else {
                    trapQueue.splice(trapIndex, 1);
                    trapQueue.push(trap)
                }
            },
            deactivateTrap: function deactivateTrap(trap) {
                var trapIndex = trapQueue.indexOf(trap);
                if (trapIndex !== -1) {
                    trapQueue.splice(trapIndex, 1)
                }
                if (trapQueue.length > 0) {
                    trapQueue[trapQueue.length - 1].unpause()
                }
            }
        }
    }();
    var isSelectableInput = function isSelectableInput2(node) {
        return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function"
    };
    var isEscapeEvent = function isEscapeEvent2(e) {
        return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27
    };
    var isTabEvent = function isTabEvent2(e) {
        return e.key === "Tab" || e.keyCode === 9
    };
    var delay = function delay2(fn) {
        return setTimeout(fn, 0)
    };
    var findIndex = function findIndex2(arr, fn) {
        var idx = -1;
        arr.every(function(value, i) {
            if (fn(value)) {
                idx = i;
                return false
            }
            return true
        });
        return idx
    };
    var valueOrHandler = function valueOrHandler2(value) {
        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            params[_key - 1] = arguments[_key]
        }
        return typeof value === "function" ? value.apply(void 0, params) : value
    };
    var getActualTarget = function getActualTarget2(event) {
        return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target
    };
    var createFocusTrap = function createFocusTrap2(elements, userOptions) {
        var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
        var config = _objectSpread2({
            returnFocusOnDeactivate: true,
            escapeDeactivates: true,
            delayInitialFocus: true
        }, userOptions);
        var state = {
            containers: [],
            tabbableGroups: [],
            nodeFocusedBeforeActivation: null,
            mostRecentlyFocusedNode: null,
            active: false,
            paused: false,
            delayInitialFocusTimer: void 0
        };
        var trap;
        var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
            return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName]
        };
        var containersContain = function containersContain2(element) {
            return !!(element && state.containers.some(function(container) {
                return container.contains(element)
            }))
        };
        var getNodeForOption = function getNodeForOption2(optionName) {
            var optionValue = config[optionName];
            if (typeof optionValue === "function") {
                for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                    params[_key2 - 1] = arguments[_key2]
                }
                optionValue = optionValue.apply(void 0, params)
            }
            if (!optionValue) {
                if (optionValue === void 0 || optionValue === false) {
                    return optionValue
                }
                throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"))
            }
            var node = optionValue;
            if (typeof optionValue === "string") {
                node = doc.querySelector(optionValue);
                if (!node) {
                    throw new Error("`".concat(optionName, "` as selector refers to no known node"))
                }
            }
            return node
        };
        var getInitialFocusNode = function getInitialFocusNode2() {
            var node = getNodeForOption("initialFocus");
            if (node === false) {
                return false
            }
            if (node === void 0) {
                if (containersContain(doc.activeElement)) {
                    node = doc.activeElement
                } else {
                    var firstTabbableGroup = state.tabbableGroups[0];
                    var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                    node = firstTabbableNode || getNodeForOption("fallbackFocus")
                }
            }
            if (!node) {
                throw new Error("Your focus-trap needs to have at least one focusable element")
            }
            return node
        };
        var updateTabbableNodes = function updateTabbableNodes2() {
            state.tabbableGroups = state.containers.map(function(container) {
                var tabbableNodes = tabbable(container);
                if (tabbableNodes.length > 0) {
                    return {
                        container: container,
                        firstTabbableNode: tabbableNodes[0],
                        lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
                    }
                }
                return void 0
            }).filter(function(group) {
                return !!group
            });
            if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
                throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times")
            }
        };
        var tryFocus = function tryFocus2(node) {
            if (node === false) {
                return
            }
            if (node === doc.activeElement) {
                return
            }
            if (!node || !node.focus) {
                tryFocus2(getInitialFocusNode());
                return
            }
            node.focus({
                preventScroll: !!config.preventScroll
            });
            state.mostRecentlyFocusedNode = node;
            if (isSelectableInput(node)) {
                node.select()
            }
        };
        var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
            var node = getNodeForOption("setReturnFocus", previousActiveElement);
            return node ? node : node === false ? false : previousActiveElement
        };
        var checkPointerDown = function checkPointerDown2(e) {
            var target = getActualTarget(e);
            if (containersContain(target)) {
                return
            }
            if (valueOrHandler(config.clickOutsideDeactivates, e)) {
                trap.deactivate({
                    returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
                });
                return
            }
            if (valueOrHandler(config.allowOutsideClick, e)) {
                return
            }
            e.preventDefault()
        };
        var checkFocusIn = function checkFocusIn2(e) {
            var target = getActualTarget(e);
            var targetContained = containersContain(target);
            if (targetContained || target instanceof Document) {
                if (targetContained) {
                    state.mostRecentlyFocusedNode = target
                }
            } else {
                e.stopImmediatePropagation();
                tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode())
            }
        };
        var checkTab = function checkTab2(e) {
            var target = getActualTarget(e);
            updateTabbableNodes();
            var destinationNode = null;
            if (state.tabbableGroups.length > 0) {
                var containerIndex = findIndex(state.tabbableGroups, function(_ref) {
                    var container = _ref.container;
                    return container.contains(target)
                });
                if (containerIndex < 0) {
                    if (e.shiftKey) {
                        destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode
                    } else {
                        destinationNode = state.tabbableGroups[0].firstTabbableNode
                    }
                } else if (e.shiftKey) {
                    var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                        var firstTabbableNode = _ref2.firstTabbableNode;
                        return target === firstTabbableNode
                    });
                    if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
                        startOfGroupIndex = containerIndex
                    }
                    if (startOfGroupIndex >= 0) {
                        var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                        var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                        destinationNode = destinationGroup.lastTabbableNode
                    }
                } else {
                    var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                        var lastTabbableNode = _ref3.lastTabbableNode;
                        return target === lastTabbableNode
                    });
                    if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
                        lastOfGroupIndex = containerIndex
                    }
                    if (lastOfGroupIndex >= 0) {
                        var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                        var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                        destinationNode = _destinationGroup.firstTabbableNode
                    }
                }
            } else {
                destinationNode = getNodeForOption("fallbackFocus")
            }
            if (destinationNode) {
                e.preventDefault();
                tryFocus(destinationNode)
            }
        };
        var checkKey = function checkKey2(e) {
            if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
                e.preventDefault();
                trap.deactivate();
                return
            }
            if (isTabEvent(e)) {
                checkTab(e);
                return
            }
        };
        var checkClick = function checkClick2(e) {
            if (valueOrHandler(config.clickOutsideDeactivates, e)) {
                return
            }
            var target = getActualTarget(e);
            if (containersContain(target)) {
                return
            }
            if (valueOrHandler(config.allowOutsideClick, e)) {
                return
            }
            e.preventDefault();
            e.stopImmediatePropagation()
        };
        var addListeners = function addListeners2() {
            if (!state.active) {
                return
            }
            activeFocusTraps.activateTrap(trap);
            state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
                tryFocus(getInitialFocusNode())
            }) : tryFocus(getInitialFocusNode());
            doc.addEventListener("focusin", checkFocusIn, true);
            doc.addEventListener("mousedown", checkPointerDown, {
                capture: true,
                passive: false
            });
            doc.addEventListener("touchstart", checkPointerDown, {
                capture: true,
                passive: false
            });
            doc.addEventListener("click", checkClick, {
                capture: true,
                passive: false
            });
            doc.addEventListener("keydown", checkKey, {
                capture: true,
                passive: false
            });
            return trap
        };
        var removeListeners = function removeListeners2() {
            if (!state.active) {
                return
            }
            doc.removeEventListener("focusin", checkFocusIn, true);
            doc.removeEventListener("mousedown", checkPointerDown, true);
            doc.removeEventListener("touchstart", checkPointerDown, true);
            doc.removeEventListener("click", checkClick, true);
            doc.removeEventListener("keydown", checkKey, true);
            return trap
        };
        trap = {
            activate: function activate(activateOptions) {
                if (state.active) {
                    return this
                }
                var onActivate = getOption(activateOptions, "onActivate");
                var onPostActivate = getOption(activateOptions, "onPostActivate");
                var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
                if (!checkCanFocusTrap) {
                    updateTabbableNodes()
                }
                state.active = true;
                state.paused = false;
                state.nodeFocusedBeforeActivation = doc.activeElement;
                if (onActivate) {
                    onActivate()
                }
                var finishActivation = function finishActivation2() {
                    if (checkCanFocusTrap) {
                        updateTabbableNodes()
                    }
                    addListeners();
                    if (onPostActivate) {
                        onPostActivate()
                    }
                };
                if (checkCanFocusTrap) {
                    checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                    return this
                }
                finishActivation();
                return this
            },
            deactivate: function deactivate(deactivateOptions) {
                if (!state.active) {
                    return this
                }
                clearTimeout(state.delayInitialFocusTimer);
                state.delayInitialFocusTimer = void 0;
                removeListeners();
                state.active = false;
                state.paused = false;
                activeFocusTraps.deactivateTrap(trap);
                var onDeactivate = getOption(deactivateOptions, "onDeactivate");
                var onPostDeactivate = getOption(deactivateOptions, "onPostDeactivate");
                var checkCanReturnFocus = getOption(deactivateOptions, "checkCanReturnFocus");
                if (onDeactivate) {
                    onDeactivate()
                }
                var returnFocus = getOption(deactivateOptions, "returnFocus", "returnFocusOnDeactivate");
                var finishDeactivation = function finishDeactivation2() {
                    delay(function() {
                        if (returnFocus) {
                            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation))
                        }
                        if (onPostDeactivate) {
                            onPostDeactivate()
                        }
                    })
                };
                if (returnFocus && checkCanReturnFocus) {
                    checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                    return this
                }
                finishDeactivation();
                return this
            },
            pause: function pause() {
                if (state.paused || !state.active) {
                    return this
                }
                state.paused = true;
                removeListeners();
                return this
            },
            unpause: function unpause() {
                if (!state.paused || !state.active) {
                    return this
                }
                state.paused = false;
                updateTabbableNodes();
                addListeners();
                return this
            },
            updateContainerElements: function updateContainerElements(containerElements) {
                var elementsAsArray = [].concat(containerElements).filter(Boolean);
                state.containers = elementsAsArray.map(function(element) {
                    return typeof element === "string" ? doc.querySelector(element) : element
                });
                if (state.active) {
                    updateTabbableNodes()
                }
                return this
            }
        };
        trap.updateContainerElements(elements);
        return trap
    };
    function filterShopifyEvent(event, domElement, callback) {
        let executeCallback = false;
        if (event.type.includes("shopify:section")) {
            if (domElement.hasAttribute("section") && domElement.getAttribute("section") === event.detail.sectionId) {
                executeCallback = true
            }
        } else if (event.type.includes("shopify:block") && event.target === domElement) {
            executeCallback = true
        }
        if (executeCallback) {
            callback(event)
        }
    }
    const handleAddToCart = (items, callback, unOpenDrawer = false) => {
        fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            body: JSON.stringify({'items': items}),
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest"
            }
        }).then(async (response) => {
            const responseJson = await response.json();
            if (response.ok) {
                this.dispatchEvent(new CustomEvent("variant:added",{
                    bubbles: true,
                    detail: {
                        variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
                    }
                }));
                // 优化：只请求一次 cart.js，避免重复请求
                const cartResponse = await fetch('/cart.js');
                let cartContent = await cartResponse.json();
                await Shopify.getCart(null, cartContent); // 使用已获取的 cart 数据，避免再次请求
                let money = changeCurrency(cartContent.currency, FreeGifts.money)
                let total_price = cartContent.total_price/100
                let hasFree = false
                cartContent.items.forEach((v, k)=>{
                    if(Object.values(v.properties).length){
                        for(let o in v.properties){
                            if(o == '__free'){
                                hasFree = true;
                            }
                        }
                    }
                })
                if(total_price >= money && !hasFree){
                    colorboxFun()
                }
                const productForm = new ProductForm;
                cartContent = productForm._correctCartCount(cartContent);
                document.documentElement.dispatchEvent(new CustomEvent("cart:updated",{
                    bubbles: true,
                    detail: {
                        cart: cartContent,
                        variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0].id : responseJson.id
                    }
                }))
                const groupDiscountPopup = document.querySelector(".group-discount-popup");
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{
                    bubbles: true,
                    detail: {
                        cart: responseJson,
                        openMiniCart: window.themeVariables.settings.cartType === "drawer" && (!groupDiscountPopup || groupDiscountPopup.classList.value.search("active") < 0) && !unOpenDrawer
                    }
                }))
                callback()
            }
            this.dispatchEvent(new CustomEvent("cart-notification:show",{
                bubbles: true,
                cancelable: true,
                detail: {
                    status: response.ok ? "success" : "error",
                    error: responseJson["description"] || ""
                }
            }))
        })
    }
    var OpenableElement = class extends CustomHTMLElement {
        static get observedAttributes() {
            return ["open"]
        }
        constructor() {
            super();
            if (Shopify.designMode) {
                this.rootDelegate.on("shopify:section:select", event=>filterShopifyEvent(event, this, ()=>this.open = true));
                this.rootDelegate.on("shopify:section:deselect", event=>filterShopifyEvent(event, this, ()=>this.open = false))
            }
            if (this.hasAttribute("append-body")) {
                const existingNode = document.getElementById(this.id);
                this.removeAttribute("append-body");
                if (existingNode && existingNode !== this) {
                    existingNode.replaceWith(this.cloneNode(true));
                    this.remove()
                } else {
                    document.body.appendChild(this)
                }
            }
        }
        connectedCallback() {
            this.delegate.on("click", ".openable__overlay", ()=>this.open = false);
            this.delegate.on("click", '[data-action="close"]', event=>{
                event.stopPropagation();
                this.open = false
            }
            )
        }
        get requiresLoading() {
            return this.hasAttribute("href")
        }
        get open() {
            return this.hasAttribute("open")
        }
        set open(value) {
            if (value) {
                (async()=>{
                    await this._load();
                    this.clientWidth;
                    this.setAttribute("open", "")
                }
                )()
            } else {
                this.removeAttribute("open")
            }
        }
        get shouldTrapFocus() {
            return true
        }
        get returnFocusOnDeactivate() {
            return !this.hasAttribute("return-focus") || this.getAttribute("return-focus") === "true"
        }
        get focusTrap() {
            return this._focusTrap = this._focusTrap || createFocusTrap(this, {
                fallbackFocus: this,
                initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
                clickOutsideDeactivates: event=>!(event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id),
                allowOutsideClick: event=>event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id,
                returnFocusOnDeactivate: this.returnFocusOnDeactivate,
                onDeactivate: ()=>this.open = false,
                preventScroll: true
            })
        }
        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
            case "open":
                if (oldValue === null && newValue === "") {
                    if (this.shouldTrapFocus) {
                        setTimeout(()=>this.focusTrap.activate(), 150)
                    }
                    triggerEvent(this, "openable-element:open")
                } else if (newValue === null) {
                    if (this.shouldTrapFocus) {
                        this.focusTrap.deactivate()
                    }
                    triggerEvent(this, "openable-element:close")
                }
            }
        }
        async _load() {
            if (!this.requiresLoading) {
                return
            }
            triggerNonBubblingEvent(this, "openable-element:load:start");
            const response = await fetch(this.getAttribute("href"));
            const element = document.createElement("div");
            element.innerHTML = await response.text();
            this.innerHTML = element.querySelector(this.tagName.toLowerCase()).innerHTML;
            this.removeAttribute("href");
            triggerNonBubblingEvent(this, "openable-element:load:end")
        }
    }
    ;
    window.customElements.define("openable-element", OpenableElement);
    var CollapsibleContent = class extends OpenableElement {
        constructor() {
            super();
            this.ignoreNextTransition = this.open;
            this.addEventListener("shopify:block:select", ()=>this.open = true);
            this.addEventListener("shopify:block:deselect", ()=>this.open = false)
        }
        get animateItems() {
            return this.hasAttribute("animate-items")
        }
        attributeChangedCallback(name) {
            if (this.ignoreNextTransition) {
                return this.ignoreNextTransition = false
            }
            switch (name) {
            case "open":
                this.style.overflow = "hidden";
                const keyframes = {
                    height: ["0px", `${this.scrollHeight}px`],
                    visibility: ["hidden", "visible"]
                };
                if (this.animateItems) {
                    keyframes["opacity"] = this.open ? [0, 0] : [0, 1]
                }
                this.animate(keyframes, {
                    duration: 500,
                    direction: this.open ? "normal" : "reverse",
                    easing: "cubic-bezier(0.75, 0, 0.175, 1)"
                }).onfinish = ()=>{
                    this.style.overflow = this.open ? "visible" : "hidden"
                }
                ;
                if (this.animateItems && this.open) {
                    this.animate({
                        opacity: [0, 1],
                        transform: ["translateY(10px)", "translateY(0)"]
                    }, {
                        duration: 250,
                        delay: 250,
                        easing: "cubic-bezier(0.75, 0, 0.175, 1)"
                    })
                }
                triggerEvent(this, this.open ? "openable-element:open" : "openable-element:close")
            }
        }
    }
    ;
    window.customElements.define("collapsible-content", CollapsibleContent);
    var ConfirmButton = class extends HTMLButtonElement {
        connectedCallback() {
            this.addEventListener("click", event=>{
                if (!window.confirm(this.getAttribute("data-message") || "Are you sure you wish to do this?")) {
                    event.preventDefault()
                }
            }
            )
        }
    }
    ;
    window.customElements.define("confirm-button", ConfirmButton, {
        extends: "button"
    });
    var LoaderButtonMixin = {
        _prepareButton() {
            this.originalContent = this.innerHTML;
            this._startTransitionPromise = null;
            this.innerHTML = `
      <span class="loader-button__text">${this.innerHTML}</span>
      <span class="loader-button__loader" hidden>
        <div class="spinner">
          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </div>
      </span>
    `;
            this.textElement = this.firstElementChild;
            this.spinnerElement = this.lastElementChild;
            window.addEventListener("pagehide", ()=>this.removeAttribute("aria-busy"))
        },
        _startTransition() {
            const textAnimation = this.textElement.animate({
                opacity: [1, 0],
                transform: ["translateY(0)", "translateY(-10px)"]
            }, {
                duration: 75,
                easing: "ease",
                fill: "forwards"
            });
            this.spinnerElement.hidden = false;
            const spinnerAnimation = this.spinnerElement.animate({
                opacity: [0, 1],
                transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"]
            }, {
                duration: 75,
                delay: 75,
                easing: "ease",
                fill: "forwards"
            });
            this._startTransitionPromise = Promise.all([new Promise(resolve=>textAnimation.onfinish = ()=>resolve()), new Promise(resolve=>spinnerAnimation.onfinish = ()=>resolve())])
        },
        async _endTransition() {
            if (!this._startTransitionPromise) {
                return
            }
            await this._startTransitionPromise;
            this.spinnerElement.animate({
                opacity: [1, 0],
                transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"]
            }, {
                duration: 75,
                delay: 100,
                easing: "ease",
                fill: "forwards"
            }).onfinish = ()=>this.spinnerElement.hidden = true;
            this.textElement.animate({
                opacity: [0, 1],
                transform: ["translateY(10px)", "translateY(0)"]
            }, {
                duration: 75,
                delay: 175,
                easing: "ease",
                fill: "forwards"
            });
            this._startTransitionPromise = null
        }
    };
    var LoaderButton = class extends HTMLButtonElement {
        static get observedAttributes() {
            return ["aria-busy"]
        }
        constructor() {
            super();
            this.addEventListener("click", event=>{
                if (this.type === "submit" && this.form && this.form.checkValidity() && !this.form.hasAttribute("is")) {
                    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
                        event.preventDefault();
                        this.setAttribute("aria-busy", "true");
                        setTimeout(()=>this.form.submit(), 250)
                    } else {
                        this.setAttribute("aria-busy", "true")
                    }
                }
            }
            )
        }
        connectedCallback() {
            this._prepareButton()
        }
        disconnectedCallback() {
            this.innerHTML = this.originalContent
        }
        attributeChangedCallback(property, oldValue, newValue) {
            if (property === "aria-busy") {
                if (newValue === "true") {
                    this._startTransition()
                } else {
                    this._endTransition()
                }
            }
        }
    }
    ;
    Object.assign(LoaderButton.prototype, LoaderButtonMixin);
    window.customElements.define("loader-button", LoaderButton, {
        extends: "button"
    });
    var PagePagination = class extends CustomHTMLElement {
        connectedCallback() {
            if (this.hasAttribute("ajax")) {
                this.delegate.on("click", "a", this._onLinkClicked.bind(this))
            }
        }
        _onLinkClicked(event, target) {
            event.preventDefault();
            const url = new URL(window.location.href);
            url.searchParams.set("page", target.getAttribute("data-page"));
            triggerEvent(this, "pagination:page-changed", {
                url: url.toString()
            })
        }
    }
    ;
    window.customElements.define("page-pagination", PagePagination);
    var ToggleButton = class extends HTMLButtonElement {
        static get observedAttributes() {
            return ["aria-expanded", "aria-busy"]
        }
        constructor() {
            super();
            if (this.hasAttribute("loader")) {
                this._prepareButton()
            }
            this.addEventListener("click", this._onButtonClick.bind(this));
            this.rootDelegate = new main_default(document.documentElement)
        }
        _onButtonClick() {
            this.isExpanded = !this.isExpanded
        }
        connectedCallback() {
            document.addEventListener("openable-element:close", event=>{
                if (this.controlledElement === event.target) {
                    this.isExpanded = false;
                    event.stopPropagation()
                }
            }
            );
            document.addEventListener("openable-element:open", event=>{
                if (this.controlledElement === event.target) {
                    this.isExpanded = true;
                    event.stopPropagation();
                    // product-bundler 快速加购到捆绑栏
                    const nodeName = event.target.localName;
                    if (this.closest('product-bundler') && this.parentNode?.parentNode?.querySelector(nodeName)?.querySelector('.product-form__buy-buttons')) {
                        const quick_buy = this.parentNode?.parentNode?.querySelector(nodeName);
                        quick_buy.querySelector('.product-form__buy-buttons').querySelector('product-payment-container')?.remove();
                        quick_buy.querySelector('.product-form__quantity')?.remove();
                        quick_buy.querySelector('.product-bundle--button').style.display = 'block';
                        quick_buy.querySelector('[data-product-add-to-cart-button]').addEventListener('click', e => {
                            e.preventDefault();
                            if (this.isExpanded) {
                                const product = quick_buy.closest('product-item');
                                const id = quick_buy.querySelector('input[name="id"]').value;
                                const variant = JSON.parse(product.querySelector('[type="application/json"]').textContent).find(variant=>{
                                    return variant["id"] == id;
                                })
                                this.closest('product-bundler').addToBundle(variant, product);
                                this.closest('product-bundler').classList.add('opened');
                                this.isExpanded = false;
                                event.stopPropagation()
                            }
                        });
                    }
                }
            }
            );
            this.rootDelegate.on("openable-element:load:start", `#${this.getAttribute("aria-controls")}`, ()=>{
                if (this.classList.contains("button")) {
                    this.setAttribute("aria-busy", "true")
                } else if (this.offsetParent !== null) {
                    triggerEvent(document.documentElement, "theme:loading:start")
                }
            }
            , true);
            this.rootDelegate.on("openable-element:load:end", `#${this.getAttribute("aria-controls")}`, ()=>{
                if (this.classList.contains("button")) {
                    this.removeAttribute("aria-busy")
                } else if (this.offsetParent !== null) {
                    triggerEvent(document.documentElement, "theme:loading:end")
                }
            }
            , true)
        }
        disconnectedCallback() {
            this.rootDelegate.destroy()
        }
        get isExpanded() {
            return this.getAttribute("aria-expanded") === "true"
        }
        set isExpanded(value) {
            this.setAttribute("aria-expanded", value ? "true" : "false")
        }
        get controlledElement() {
            return document.getElementById(this.getAttribute("aria-controls"))
        }
        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
            case "aria-expanded":
                // console.log('哈哈哈1：', oldValue,newValue,this.controlledElement)

                if (oldValue === "false" && newValue === "true") {
                    this.controlledElement.open = true
                } else if (oldValue === "true" && newValue === "false") {
                    this.controlledElement.open = false
                }
                break;
            case "aria-busy":
                if (this.hasAttribute("loader")) {
                    if (newValue === "true") {
                        this._startTransition()
                    } else {
                        this._endTransition()
                    }
                }
                break
            }
        }
    }
    ;
    Object.assign(ToggleButton.prototype, LoaderButtonMixin);
    window.customElements.define("toggle-button", ToggleButton, {
        extends: "button"
    });
    var ToggleLink = class extends HTMLAnchorElement {
        static get observedAttributes() {
            return ["aria-expanded"]
        }
        constructor() {
            super();
            this.addEventListener("click", event=>{
                event.preventDefault();
                this.isExpanded = !this.isExpanded
            }
            );
            this.rootDelegate = new main_default(document.documentElement)
        }
        connectedCallback() {
            this.rootDelegate.on("openable-element:close", `#${this.getAttribute("aria-controls")}`, event=>{
                if (this.controlledElement === event.target) {
                    this.isExpanded = false
                }
            }
            , true);
            this.rootDelegate.on("openable-element:open", `#${this.getAttribute("aria-controls")}`, event=>{
                if (this.controlledElement === event.target) {
                    this.isExpanded = true
                }
            }
            , true)
        }
        disconnectedCallback() {
            this.rootDelegate.destroy()
        }
        get isExpanded() {
            return this.getAttribute("aria-expanded") === "true"
        }
        set isExpanded(value) {
            this.setAttribute("aria-expanded", value ? "true" : "false")
        }
        get controlledElement() {
            return document.querySelector(`#${this.getAttribute("aria-controls")}`)
        }
        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
            case "aria-expanded":
                if (oldValue === "false" && newValue === "true") {
                    this.controlledElement.open = true
                } else if (oldValue === "true" && newValue === "false") {
                    this.controlledElement.open = false
                }
            }
        }
    }
    ;
    window.customElements.define("toggle-link", ToggleLink, {
        extends: "a"
    });
    var PageDots = class extends CustomHTMLElement {
        connectedCallback() {
            this.buttons = Array.from(this.querySelectorAll("button"));
            this.delegate.on("mouseover", "button", (event,target)=>{
                this._dispatchEvent(this.buttons.indexOf(target))
            }
            );
            if (this.hasAttribute("animation-timer")) {
                this.delegate.on("animationend", event=>{
                    if (event.elapsedTime > 0) {
                        this._dispatchEvent((this.selectedIndex + 1 + this.buttons.length) % this.buttons.length)
                    }
                }
                )
            }
        }
        get selectedIndex() {
            return this.buttons.findIndex(button=>button.getAttribute("aria-current") === "true")
        }
        set selectedIndex(selectedIndex) {
            this.buttons.forEach((button,index)=>button.setAttribute("aria-current", selectedIndex === index ? "true" : "false"));
            if (this.hasAttribute("align-selected")) {
                const selectedItem = this.buttons[selectedIndex]
                  , windowHalfWidth = window.innerWidth / 2
                  , boundingRect = selectedItem.getBoundingClientRect()
                  , scrollableElement = this._findFirstScrollableElement(this.parentElement);
                if (scrollableElement) {
                    scrollableElement.scrollTo({
                        behavior: "smooth",
                        left: scrollableElement.scrollLeft + (boundingRect.left - windowHalfWidth) + boundingRect.width / 2
                    })
                }
            }
        }
        _dispatchEvent(index) {
            if (index !== this.selectedIndex) {
                this.dispatchEvent(new CustomEvent("page-dots:changed",{
                    bubbles: true,
                    detail: {
                        index: index
                    }
                }))
            }
        }
        _findFirstScrollableElement(item, currentDepth=0) {
            if (item === null || currentDepth > 3) {
                return null
            }
            return item.scrollWidth > item.clientWidth ? item : this._findFirstScrollableElement(item.parentElement, currentDepth + 1)
        }
    }
    ;
    window.customElements.define("page-dots", PageDots);
    var PrevNextButtons = class extends HTMLElement {
        connectedCallback() {
            this.prevButton = this.querySelector("button:first-of-type");
            this.nextButton = this.querySelector("button:last-of-type");
            this.prevButton.addEventListener("click", ()=>this.prevButton.dispatchEvent(new CustomEvent("prev-next:prev",{
                bubbles: true
            })));
            this.nextButton.addEventListener("click", ()=>this.nextButton.dispatchEvent(new CustomEvent("prev-next:next",{
                bubbles: true
            })))
        }
        set isPrevDisabled(value) {
            this.prevButton.disabled = value
        }
        set isNextDisabled(value) {
            this.nextButton.disabled = value
        }
    }
    ;
    var PrevButton = class extends HTMLButtonElement {
        connectedCallback() {
            this.addEventListener("click", ()=>this.dispatchEvent(new CustomEvent("prev-next:prev",{
                bubbles: true
            })))
        }
    }
    ;
    var NextButton = class extends HTMLButtonElement {
        connectedCallback() {
            this.addEventListener("click", ()=>this.dispatchEvent(new CustomEvent("prev-next:next",{
                bubbles: true
            })))
        }
    }
    ;
    window.customElements.define("prev-next-buttons", PrevNextButtons);
    window.customElements.define("prev-button", PrevButton, {
        extends: "button"
    });
    window.customElements.define("next-button", NextButton, {
        extends: "button"
    });
    function getStickyHeaderOffset() {
        const documentStyles = getComputedStyle(document.documentElement);
        return parseInt(documentStyles.getPropertyValue("--header-height") || 0) * parseInt(documentStyles.getPropertyValue("--enable-sticky-header") || 0) + parseInt(documentStyles.getPropertyValue("--announcement-bar-height") || 0) * parseInt(documentStyles.getPropertyValue("--enable-sticky-announcement-bar") || 0)
    }
    var SafeSticky = class extends HTMLElement {
        connectedCallback() {
            this.lastKnownY = window.scrollY;
            this.currentTop = 0;
            this.hasPendingRaf = false;
            window.addEventListener("scroll", this._checkPosition.bind(this))
        }
        get initialTopOffset() {
            return getStickyHeaderOffset() + (parseInt(this.getAttribute("offset")) || 0)
        }
        _checkPosition() {
            if (this.hasPendingRaf) {
                return
            }
            this.hasPendingRaf = true;
            requestAnimationFrame(()=>{
                let bounds = this.getBoundingClientRect()
                  , maxTop = bounds.top + window.scrollY - this.offsetTop + this.initialTopOffset
                  , minTop = this.clientHeight - window.innerHeight;
                if (window.scrollY < this.lastKnownY) {
                    this.currentTop -= window.scrollY - this.lastKnownY
                } else {
                    this.currentTop += this.lastKnownY - window.scrollY
                }
                this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTopOffset);
                this.lastKnownY = window.scrollY;
                this.style.top = `${this.currentTop}px`;
                this.hasPendingRaf = false
            }
            )
        }
    }
    ;
    window.customElements.define("safe-sticky", SafeSticky);
    function throttle(callback, delay3=15) {
        let throttleTimeout = null
          , storedEvent = null;
        const throttledEventHandler = event=>{
            storedEvent = event;
            const shouldHandleEvent = !throttleTimeout;
            if (shouldHandleEvent) {
                callback(storedEvent);
                storedEvent = null;
                throttleTimeout = setTimeout(()=>{
                    throttleTimeout = null;
                    if (storedEvent) {
                        throttledEventHandler(storedEvent)
                    }
                }
                , delay3)
            }
        }
        ;
        return throttledEventHandler
    }
    var ScrollSpy = class extends HTMLElement {
        connectedCallback() {
            this._createSvg();
            this.elementsToObserve = Array.from(this.querySelectorAll("a")).map(linkElement=>document.querySelector(linkElement.getAttribute("href")));
            this.navListItems = Array.from(this.querySelectorAll("li"));
            this.navItems = this.navListItems.map(listItem=>{
                const anchor = listItem.firstElementChild
                  , targetID = anchor && anchor.getAttribute("href").slice(1)
                  , target = document.getElementById(targetID);
                return {
                    listItem: listItem,
                    anchor: anchor,
                    target: target
                }
            }
            ).filter(item=>item.target);
            this.drawPath();
            window.addEventListener("scroll", throttle(this.markVisibleSection.bind(this), 25));
            window.addEventListener("orientationchange", ()=>{
                window.addEventListener("resize", ()=>{
                    this.drawPath();
                    this.markVisibleSection()
                }
                , {
                    once: true
                })
            }
            );
            this.markVisibleSection()
        }
        _createSvg() {
            this.navPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
            const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svgElement.insertAdjacentElement("beforeend", this.navPath);
            this.insertAdjacentElement("beforeend", svgElement);
            this.lastPathStart = this.lastPathEnd = null
        }
        drawPath() {
            let path = [], pathIndent;
            this.navItems.forEach((item,i)=>{
                const x = item.anchor.offsetLeft - 5
                  , y = item.anchor.offsetTop
                  , height = item.anchor.offsetHeight;
                if (i === 0) {
                    path.push("M", x, y, "L", x, y + height);
                    item.pathStart = 0
                } else {
                    if (pathIndent !== x) {
                        path.push("L", pathIndent, y)
                    }
                    path.push("L", x, y);
                    this.navPath.setAttribute("d", path.join(" "));
                    item.pathStart = this.navPath.getTotalLength() || 0;
                    path.push("L", x, y + height)
                }
                pathIndent = x;
                this.navPath.setAttribute("d", path.join(" "));
                item.pathEnd = this.navPath.getTotalLength()
            }
            )
        }
        syncPath() {
            const someElsAreVisible = ()=>this.querySelectorAll(".is-visible").length > 0
              , thisElIsVisible = el=>el.classList.contains("is-visible")
              , pathLength = this.navPath.getTotalLength();
            let pathStart = pathLength
              , pathEnd = 0;
            this.navItems.forEach(item=>{
                if (thisElIsVisible(item.listItem)) {
                    pathStart = Math.min(item.pathStart, pathStart);
                    pathEnd = Math.max(item.pathEnd, pathEnd)
                }
            }
            );
            if (someElsAreVisible() && pathStart < pathEnd) {
                if (pathStart !== this.lastPathStart || pathEnd !== this.lastPathEnd) {
                    const dashArray = `1 ${pathStart} ${pathEnd - pathStart} ${pathLength}`;
                    this.navPath.style.setProperty("stroke-dashoffset", "1");
                    this.navPath.style.setProperty("stroke-dasharray", dashArray);
                    this.navPath.style.setProperty("opacity", "1")
                }
            } else {
                this.navPath.style.setProperty("opacity", "0")
            }
            this.lastPathStart = pathStart;
            this.lastPathEnd = pathEnd
        }
        markVisibleSection() {
            this.navListItems.forEach(item=>item.classList.remove("is-visible"));
            for (const [index,elementToObserve] of this.elementsToObserve.entries()) {
                const boundingClientRect = elementToObserve.getBoundingClientRect();
                if (boundingClientRect.top > getStickyHeaderOffset() || index === this.elementsToObserve.length - 1) {
                    this.querySelector(`a[href="#${elementToObserve.id}"]`).parentElement.classList.add("is-visible");
                    break
                }
            }
            this.syncPath()
        }
    }
    ;
    window.customElements.define("scroll-spy", ScrollSpy);
    var template = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`;
    var Updater = class {
        constructor(targetElement) {
            this.scheduleUpdate = throttle(()=>this.update(targetElement, getComputedStyle(targetElement)));
            this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this))
        }
        start(element) {
            if (this.element) {
                this.stop()
            }
            if (element) {
                element.addEventListener("scroll", this.scheduleUpdate);
                this.resizeObserver.observe(element);
                this.element = element
            }
        }
        stop() {
            if (!this.element) {
                return
            }
            this.element.removeEventListener("scroll", this.scheduleUpdate);
            this.resizeObserver.unobserve(this.element);
            this.element = null
        }
        update(targetElement, style) {
            if (!this.element) {
                return
            }
            const maxSize = style.getPropertyValue("--scroll-shadow-size") ? parseInt(style.getPropertyValue("--scroll-shadow-size")) : 0;
            const scroll = {
                top: Math.max(this.element.scrollTop, 0),
                bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
                left: Math.max(this.element.scrollLeft, 0),
                right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0)
            };
            requestAnimationFrame(()=>{
                for (const position of ["top", "bottom", "left", "right"]) {
                    targetElement.style.setProperty(`--${position}`, `${scroll[position] > maxSize ? maxSize : scroll[position]}px`)
                }
            }
            )
        }
    }
    ;
    var ScrollShadow = class extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({
                mode: "open"
            }).innerHTML = template;
            this.updater = new Updater(this.shadowRoot.lastElementChild)
        }
        connectedCallback() {
            this.shadowRoot.querySelector("slot").addEventListener("slotchange", ()=>this.start());
            this.start()
        }
        disconnectedCallback() {
            this.updater.stop()
        }
        start() {
            this.updater.start(this.firstElementChild)
        }
    }
    ;
    if ("ResizeObserver"in window) {
        window.customElements.define("scroll-shadow", ScrollShadow)
    }
    var ShareToggleButton = class extends ToggleButton {
        _onButtonClick() {
            if (window.matchMedia(window.themeVariables.breakpoints.phone).matches && navigator.share) {
                navigator.share({
                    title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
                    url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
                })
            } else {
                super._onButtonClick()
            }
        }
    }
    ;
    window.customElements.define("share-toggle-button", ShareToggleButton, {
        extends: "button"
    });
    var NativeCarousel = class extends CustomHTMLElement {
        connectedCallback() {
            this.items = Array.from(this.querySelectorAll("native-carousel-item"));
            this.pageDotsElements = Array.from(this.querySelectorAll("page-dots"));
            this.prevNextButtonsElements = Array.from(this.querySelectorAll("prev-next-buttons"));
            if (this.items.length > 1) {
                this.addEventListener("prev-next:prev", this.prev.bind(this));
                this.addEventListener("prev-next:next", this.next.bind(this));
                this.addEventListener("page-dots:changed", event=>this.select(event.detail.index, true));
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:select", event=>this.select(event.target.index, !event.detail.load))
                }
            }
            const scrollerElement = this.items[0].parentElement;
            this.intersectionObserver = new IntersectionObserver(this._onVisibilityChanged.bind(this),{
                root: scrollerElement,
                rootMargin: `${scrollerElement.clientHeight}px 0px`,
                threshold: .8
            });
            this.items.forEach(item=>this.intersectionObserver.observe(item))
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.intersectionObserver.disconnect()
        }
        get selectedIndex() {
            return this.items.findIndex(item=>item.selected)
        }
        prev(shouldAnimate=true) {
            this.select(Math.max(this.selectedIndex - 1, 0), shouldAnimate)
        }
        next(shouldAnimate=true) {
            this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), shouldAnimate)
        }
        select(index, shouldAnimate=true) {
            const clampIndex = Math.max(0, Math.min(index, this.items.length));
            const selectedElement = this.items[clampIndex];
            this._adjustNavigationForElement(selectedElement);
            if (shouldAnimate) {
                this.items.forEach(item=>this.intersectionObserver.unobserve(item));
                setInterval(()=>{
                    this.items.forEach(item=>this.intersectionObserver.observe(item))
                }
                , 800)
            }
            this.items.forEach((item,loopIndex)=>item.selected = loopIndex === clampIndex);
            const direction = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
            selectedElement.parentElement.scrollTo({
                left: direction * (selectedElement.clientWidth * clampIndex),
                behavior: shouldAnimate ? "smooth" : "auto"
            })
        }
        _adjustNavigationForElement(selectedElement) {
            this.items.forEach(item=>item.selected = selectedElement === item);
            this.pageDotsElements.forEach(pageDot=>pageDot.selectedIndex = selectedElement.index);
            this.prevNextButtonsElements.forEach(prevNextButton=>{
                prevNextButton.isPrevDisabled = selectedElement.index === 0;
                prevNextButton.isNextDisabled = selectedElement.index === this.items.length - 1
            }
            )
        }
        _onVisibilityChanged(entries) {
            for (let entry of entries) {
                if (entry.isIntersecting) {
                    this._adjustNavigationForElement(entry.target);
                    break
                }
            }
        }
    }
    ;
    var NativeCarouselItem = class extends CustomHTMLElement {
        static get observedAttributes() {
            return ["hidden"]
        }
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        set selected(value) {
            this.hidden = !value
        }
    }
    ;
    window.customElements.define("native-carousel-item", NativeCarouselItem);
    window.customElements.define("native-carousel", NativeCarousel);
    var DragCursor = class extends HTMLElement {
        connectedCallback() {
            this.scrollableElement = this.parentElement;
            this.scrollableElement.addEventListener("mouseenter", this._onMouseEnter.bind(this));
            this.scrollableElement.addEventListener("mousemove", this._onMouseMove.bind(this));
            this.scrollableElement.addEventListener("mouseleave", this._onMouseLeave.bind(this));
            this.innerHTML = `
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
        <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" fill="rgb(var(--text-color))"/>
        <path d="M46 50L36 60l10 10M74 50l10 10-10 10" stroke="rgb(var(--section-background))" stroke-width="4"/>
      </svg>
    `
        }
        _onMouseEnter(event) {
            this.removeAttribute("hidden");
            this._positionCursor(event)
        }
        _onMouseLeave() {
            this.setAttribute("hidden", "")
        }
        _onMouseMove(event) {
            this.toggleAttribute("hidden", event.target.tagName === "BUTTON" || event.target.tagName === "A");
            this._positionCursor(event)
        }
        _positionCursor(event) {
            const elementBoundingRect = this.scrollableElement.getBoundingClientRect();
            const x = event.clientX - elementBoundingRect.x;
            const y = event.clientY - elementBoundingRect.y;
            this.style.transform = `translate(${x - this.clientWidth / 2}px, ${y - this.clientHeight / 2}px)`
        }
    }
    ;
    window.customElements.define("drag-cursor", DragCursor);
    var ScrollableContent = class extends CustomHTMLElement {
        connectedCallback() {
            if (this.draggable) {
                this._setupDraggability()
            }
            this._checkScrollability();
            window.addEventListener("resize", this._checkScrollability.bind(this));
            this.addEventListener("scroll", throttle(this._calculateProgress.bind(this), 15))
        }
        get draggable() {
            return this.hasAttribute("draggable")
        }
        _setupDraggability() {
            this.insertAdjacentHTML("afterend", '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>');
            const mediaQuery = matchMedia("(hover: none)");
            mediaQuery.addListener(this._onMediaChanges.bind(this));
            if (!mediaQuery.matches) {
                this._attachDraggableListeners()
            }
        }
        _attachDraggableListeners() {
            this.delegate.on("mousedown", this._onMouseDown.bind(this));
            this.delegate.on("mousemove", this._onMouseMove.bind(this));
            this.delegate.on("mouseup", this._onMouseUp.bind(this))
        }
        _removeDraggableListeners() {
            this.delegate.off("mousedown");
            this.delegate.off("mousemove");
            this.delegate.off("mouseup")
        }
        _checkScrollability() {
            this.classList.toggle("is-scrollable", this.scrollWidth > this.offsetWidth)
        }
        _calculateProgress() {
            const scrollLeft = this.scrollLeft * (window.themeVariables.settings.direction === "ltr" ? 1 : -1);
            const progress = Math.max(0, Math.min(1, scrollLeft / (this.scrollWidth - this.clientWidth))) * 100;
            triggerEvent(this, "scrollable-content:progress", {
                progress: progress
            })
        }
        _onMediaChanges(event) {
            if (!event.matches) {
                this._attachDraggableListeners()
            } else {
                this._removeDraggableListeners()
            }
        }
        _onMouseDown(event) {
            if (event.target && event.target.nodeName === "IMG") {
                event.preventDefault()
            }
            this.startX = event.clientX + this.scrollLeft;
            this.diffX = 0;
            this.drag = true
        }
        _onMouseMove(event) {
            if (this.drag) {
                this.diffX = this.startX - (event.clientX + this.scrollLeft);
                this.scrollLeft += this.diffX
            }
        }
        _onMouseUp() {
            this.drag = false;
            let start = 1;
            let animate = ()=>{
                let step = Math.sinh(start);
                if (step <= 0) {
                    window.cancelAnimationFrame(animate)
                } else {
                    this.scrollLeft += this.diffX * step;
                    start -= .03;
                    window.requestAnimationFrame(animate)
                }
            }
            ;
            animate()
        }
    }
    ;
    window.customElements.define("scrollable-content", ScrollableContent);
    var LoadingBar = class extends CustomHTMLElement {
        constructor() {
            super();
            this.rootDelegate.on("theme:loading:start", this.show.bind(this));
            this.rootDelegate.on("theme:loading:end", this.hide.bind(this));
            this.delegate.on("transitionend", this._onTransitionEnd.bind(this))
        }
        show() {
            this.classList.add("is-visible");
            this.style.transform = "scaleX(0.4)"
        }
        hide() {
            this.style.transform = "scaleX(1)";
            this.classList.add("is-finished")
        }
        _onTransitionEnd(event) {
            if (event.propertyName === "transform" && this.classList.contains("is-finished")) {
                this.classList.remove("is-visible");
                this.classList.remove("is-finished");
                this.style.transform = "scaleX(0)"
            }
        }
    }
    ;
    window.customElements.define("loading-bar", LoadingBar);
    var SplitLines = class extends HTMLElement {
        connectedCallback() {
            this.originalContent = this.textContent;
            this.lastWidth = window.innerWidth;
            this.hasBeenSplitted = false;
            window.addEventListener("resize", this._onResize.bind(this))
        }
        [Symbol.asyncIterator]() {
            return {
                splitPromise: this.split.bind(this),
                index: 0,
                async next() {
                    const lines = await this.splitPromise();
                    if (this.index !== lines.length) {
                        return {
                            done: false,
                            value: lines[this.index++]
                        }
                    } else {
                        return {
                            done: true
                        }
                    }
                }
            }
        }
        split(force=false) {
            if (this.childElementCount > 0 && !force) {
                return Promise.resolve(Array.from(this.children))
            }
            this.hasBeenSplitted = true;
            return new Promise(resolve=>{
                requestAnimationFrame(()=>{
                    this.innerHTML = this.originalContent.replace(/./g, "<span>$&</span>").replace(/\s/g, " ");
                    const bounds = {};
                    if (this.hasAttribute('unSetTag')) {
                        bounds[0] = this.originalContent;
                    } else {
                        Array.from(this.children).forEach(child=>{
                            const rect = parseInt(child.getBoundingClientRect().top);
                            bounds[rect] = (bounds[rect] || "") + child.textContent
                        });
                    }
                    this.innerHTML = Object.values(bounds).map(item=>`<span ${this.hasAttribute("reveal") && !force ? "reveal" : ""} ${this.hasAttribute("reveal-visibility") && !force ? "reveal-visibility" : ""} style="display: block">${item.trim()}</span>`).join("");
                    this.style.opacity = this.hasAttribute("reveal") ? 1 : null;
                    this.style.visibility = this.hasAttribute("reveal-visibility") ? "visible" : null;
                    resolve(Array.from(this.children))
                }
                )
            }
            )
        }
        async _onResize() {
            if (this.lastWidth === window.innerWidth || !this.hasBeenSplitted) {
                return
            }
            await this.split(true);
            this.dispatchEvent(new CustomEvent("split-lines:re-split",{
                bubbles: true
            }));
            this.lastWidth = window.innerWidth
        }
    }
    ;
    window.customElements.define("split-lines", SplitLines);
    var PopoverContent = class extends OpenableElement {
        connectedCallback() {
            super.connectedCallback();
            this.delegate.on("click", ".popover__overlay", ()=>this.open = false)
        }
        attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            switch (name) {
            case "open":
                document.documentElement.classList.toggle("lock-mobile", this.open)
            }
        }
    }
    ;
    window.customElements.define("popover-content", PopoverContent);
    var TabsNav = class extends HTMLElement {
        connectedCallback() {
            this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"));
            this.scrollerElement = this.querySelector(".tabs-nav__scroller");
            this.buttons.forEach(button=>button.addEventListener("click", ()=>this.selectButton(button)));
            this.addEventListener("shopify:block:select", event=>this.selectButton(event.target, !event.detail.load));
            this.positionElement = document.createElement("span");
            this.positionElement.classList.add("tabs-nav__position");
            this.buttons[0].parentElement.insertAdjacentElement("afterend", this.positionElement);
            window.addEventListener("resize", this._onWindowResized.bind(this));
            this._adjustNavigationPosition();
            if (this.hasArrows) {
                this._handleArrows()
            }
        }
        get hasArrows() {
            return this.hasAttribute("arrows")
        }
        get selectedTabIndex() {
            return this.buttons.findIndex(button=>button.getAttribute("aria-expanded") === "true")
        }
        get selectedButton() {
            return this.buttons.find(button=>button.getAttribute("aria-expanded") === "true")
        }
        selectButton(button, animate=true) {
            if (!this.buttons.includes(button) || this.selectedButton === button) {
                return
            }
            const from = document.getElementById(this.selectedButton.getAttribute("aria-controls"))
              , to = document.getElementById(button.getAttribute("aria-controls"));
            if (animate) {
                this._transitionContent(from, to)
            } else {
                from.hidden = true;
                to.hidden = false
            }
            this.selectedButton.setAttribute("aria-expanded", "false");
            button.setAttribute("aria-expanded", "true");
            triggerEvent(this, "tabs-nav:changed", {
                button: button
            });
            this._adjustNavigationPosition()
        }
        addButton(button) {
            button.addEventListener("click", ()=>this.selectButton(button));
            button.setAttribute("aria-expanded", "false");
            this.buttons[this.buttons.length - 1].insertAdjacentElement("afterend", button);
            this.buttons.push(button);
            this._adjustNavigationPosition(false)
        }
        _transitionContent(from, to) {
            from.animate({
                opacity: [1, 0]
            }, {
                duration: 250,
                easing: "ease"
            }).onfinish = ()=>{
                from.hidden = true;
                to.hidden = false;
                to.animate({
                    opacity: [0, 1]
                }, {
                    duration: 250,
                    easing: "ease"
                })
            }
        }
        _onWindowResized() {
            this._adjustNavigationPosition()
        }
        _adjustNavigationPosition(shouldAnimate=true) {
            const scale = this.selectedButton.clientWidth / this.positionElement.parentElement.clientWidth
              , translate = this.selectedButton.offsetLeft / this.positionElement.parentElement.clientWidth / scale
              , windowHalfWidth = this.scrollerElement.clientWidth / 2;
            this.scrollerElement.scrollTo({
                behavior: shouldAnimate ? "smooth" : "auto",
                left: this.selectedButton.offsetLeft - windowHalfWidth + this.selectedButton.clientWidth / 2
            });
            if (!shouldAnimate) {
                this.positionElement.style.transition = "none"
            }
            this.positionElement.style.setProperty("--scale", scale);
            this.positionElement.style.setProperty("--translate", `${translate * 100}%`);
            this.positionElement.clientWidth;
            requestAnimationFrame(()=>{
                this.positionElement.classList.add("is-initialized");
                this.positionElement.style.transition = null
            }
            )
        }
        _handleArrows() {
            const arrowsContainer = this.querySelector(".tabs-nav__arrows");
            arrowsContainer.firstElementChild.addEventListener("click", ()=>{
                this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)])
            }
            );
            arrowsContainer.lastElementChild.addEventListener("click", ()=>{
                this.selectButton(this.buttons[Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)])
            }
            )
        }
    }
    ;
    window.customElements.define("tabs-nav", TabsNav);
    var LibraryLoader = class {
        static load(libraryName) {
            const STATUS_REQUESTED = "requested"
              , STATUS_LOADED = "loaded";
            const library = this.libraries[libraryName];
            if (!library) {
                return
            }
            if (library.status === STATUS_REQUESTED) {
                return library.promise
            }
            if (library.status === STATUS_LOADED) {
                return Promise.resolve()
            }
            let promise;
            if (library.type === "script") {
                promise = new Promise((resolve,reject)=>{
                    let tag = document.createElement("script");
                    tag.id = library.tagId;
                    tag.src = library.src;
                    tag.onerror = reject;
                    tag.onload = ()=>{
                        library.status = STATUS_LOADED;
                        resolve()
                    }
                    ;
                    document.body.appendChild(tag)
                }
                )
            } else {
                promise = new Promise((resolve,reject)=>{
                    let tag = document.createElement("link");
                    tag.id = library.tagId;
                    tag.href = library.src;
                    tag.rel = "stylesheet";
                    tag.type = "text/css";
                    tag.onerror = reject;
                    tag.onload = ()=>{
                        library.status = STATUS_LOADED;
                        resolve()
                    }
                    ;
                    document.body.appendChild(tag)
                }
                )
            }
            library.promise = promise;
            library.status = STATUS_REQUESTED;
            return promise
        }
    }
    ;
    __publicField(LibraryLoader, "libraries", {
        flickity: {
            tagId: "flickity",
            src: window.themeVariables.libs.flickity,
            type: "script"
        },
        photoswipe: {
            tagId: "photoswipe",
            src: window.themeVariables.libs.photoswipe,
            type: "script"
        },
        qrCode: {
            tagId: "qrCode",
            src: window.themeVariables.libs.qrCode,
            type: "script"
        },
        modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: "link"
        }
    });
    var QrCode = class extends HTMLElement {
        async connectedCallback() {
            await LibraryLoader.load("qrCode");
            new window.QRCode(this,{
                text: this.getAttribute("identifier"),
                width: 200,
                height: 200
            })
        }
    }
    ;
    window.customElements.define("qr-code", QrCode);
    var CountrySelector = class extends HTMLSelectElement {
        connectedCallback() {
            this.provinceElement = document.getElementById(this.getAttribute("aria-owns"));
            this.addEventListener("change", this._updateProvinceVisibility.bind(this));
            if (this.hasAttribute("data-default")) {
                for (let i = 0; i !== this.options.length; ++i) {
                    if (this.options[i].text === this.getAttribute("data-default")) {
                        this.selectedIndex = i;
                        break
                    }
                }
            }
            if (this.provinceElement.hasAttribute("data-default")) {
                for (let i = 0; i !== this.provinceElement.options.length; ++i) {
                    if (this.provinceElement.options[i].text === this.provinceElement.getAttribute("data-default")) {
                        this.provinceElement.selectedIndex = i;
                        break
                    }
                }
            }
            this._updateProvinceVisibility()
        }
        _updateProvinceVisibility() {
            const selectedOption = this.options[this.selectedIndex];
            if (!selectedOption) {
                return
            }
            let provinces = JSON.parse(selectedOption.getAttribute("data-provinces") || "[]")
              , provinceSelectElement = this.provinceElement.tagName === "SELECT" ? this.provinceElement : this.provinceElement.querySelector("select");
            provinceSelectElement.innerHTML = "";
            if (provinces.length === 0) {
                this.provinceElement.hidden = true;
                return
            }
            provinces.forEach(data=>{
                provinceSelectElement.options.add(new Option(data[1],data[0]))
            }
            );
            this.provinceElement.hidden = false
        }
    }
    ;
    window.customElements.define("country-selector", CountrySelector, {
        extends: "select"
    });
    var ModalContent = class extends OpenableElement {
        connectedCallback() {
            super.connectedCallback();
            if (this.appearAfterDelay && !(this.onlyOnce && this.hasAppearedOnce)) {
                setTimeout(()=>this.open = true, this.apparitionDelay)
            }
            this.delegate.on("click", ".modal__overlay", ()=>this.open = false)
        }
        get appearAfterDelay() {
            return this.hasAttribute("apparition-delay")
        }
        get apparitionDelay() {
            return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3
        }
        get onlyOnce() {
            return this.hasAttribute("only-once")
        }
        get hasAppearedOnce() {
            return localStorage.getItem("theme:popup-appeared") !== null
        }
        attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            switch (name) {
            case "open":
                document.documentElement.classList.toggle("lock-all", this.open);
                if (this.open) {
                    localStorage.setItem("theme:popup-appeared", true)
                }
            }
        }
    }
    ;
    window.customElements.define("modal-content", ModalContent);
    var PriceRange = class extends HTMLElement {
        connectedCallback() {
            this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
            this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
            this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
            this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
            this.textInputLowerBound.addEventListener("focus", ()=>this.textInputLowerBound.select());
            this.textInputHigherBound.addEventListener("focus", ()=>this.textInputHigherBound.select());
            this.textInputLowerBound.addEventListener("change", event=>{
                event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
                this.rangeLowerBound.value = event.target.value;
                this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100}%`)
            }
            );
            this.textInputHigherBound.addEventListener("change", event=>{
                event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
                this.rangeHigherBound.value = event.target.value;
                this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100}%`)
            }
            );
            this.rangeLowerBound.addEventListener("change", event=>{
                this.textInputLowerBound.value = event.target.value;
                this.textInputLowerBound.dispatchEvent(new Event("change",{
                    bubbles: true
                }))
            }
            );
            this.rangeHigherBound.addEventListener("change", event=>{
                this.textInputHigherBound.value = event.target.value;
                this.textInputHigherBound.dispatchEvent(new Event("change",{
                    bubbles: true
                }))
            }
            );
            this.rangeLowerBound.addEventListener("input", event=>{
                triggerEvent(this, "facet:abort-loading");
                event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
                event.target.parentElement.style.setProperty("--range-min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
                this.textInputLowerBound.value = event.target.value
            }
            );
            this.rangeHigherBound.addEventListener("input", event=>{
                triggerEvent(this, "facet:abort-loading");
                event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
                event.target.parentElement.style.setProperty("--range-max", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
                this.textInputHigherBound.value = event.target.value
            }
            )
        }
    }
    ;
    window.customElements.define("price-range", PriceRange);
    var LinkBar = class extends HTMLElement {
        connectedCallback() {
            const selectedItem = this.querySelector(".link-bar__link-item--selected");
            if (selectedItem) {
                requestAnimationFrame(()=>{
                    selectedItem.style.scrollSnapAlign = "none"
                }
                )
            }
        }
    }
    ;
    window.customElements.define("link-bar", LinkBar);
    var MediaFeatures = class {
        static prefersReducedMotion() {
            return window.matchMedia("(prefers-reduced-motion: reduce)").matches
        }
        static supportsHover() {
            return window.matchMedia("(pointer: fine)").matches
        }
    }
    ;
    var FlickityCarousel = class extends CustomHTMLElement {
        constructor() {
            super();
            if (this.childElementCount === 1) {
                return
            }
            this.addEventListener("flickity:ready", this._preloadNextImage.bind(this));
            this.addEventListener("flickity:slide-changed", this._preloadNextImage.bind(this));
            this._createFlickity()
        }
        async disconnectedCallback() {
            if (this.flickity) {
                const flickityInstance = await this.flickity;
                flickityInstance.destroy()
            }
        }
        get flickityConfig() {
            return JSON.parse(this.getAttribute("flickity-config"))
        }
        get flickityInstance() {
            return this.flickity
        }
        async next() {
            (await this.flickityInstance).next()
        }
        async previous() {
            (await this.flickityInstance).previous()
        }
        async reloadCells() {
            (await this.flickityInstance).reloadCells()
        }
        async destroy() {
            (await this.flickityInstance).destroy()
        }
        async select(indexOrSelector) {
            (await this.flickityInstance).selectCell(indexOrSelector)
        }
        async setDraggable(draggable) {
            const flickityInstance = await this.flickity;
            flickityInstance.options.draggable = draggable;
            flickityInstance.updateDraggable()
        }
        async reload(select, showFilldom = false) {
            const flickityInstance = await this.flickity;
            flickityInstance.destroy();
            if (showFilldom) {
                flickityInstance.showfilldom();
            }
            if (this.flickityConfig["cellSelector"]) {
                Array.from(this.children).sort((a,b)=>parseInt(a.getAttribute("data-original-position")) > parseInt(b.getAttribute("data-original-position")) ? 1 : -1).forEach(node=>this.appendChild(node))
            }
            this._createFlickity(select)
        }
        async _createFlickity(select) {
            this.flickity = new Promise(async resolve=>{
                await LibraryLoader.load("flickity");
                await this.untilVisible({
                    rootMargin: "400px",
                    threshold: 0
                });
                const flickityInstance = new window.ThemeFlickity(this,{
                    ...this.flickityConfig,
                    ...{
                        rightToLeft: window.themeVariables.settings.direction === "rtl",
                        accessibility: MediaFeatures.supportsHover(),
                        on: {
                            ready: event=>triggerEvent(this, "flickity:ready", event),
                            change: event=>triggerEvent(this, "flickity:slide-changed", event),
                            settle: event=>triggerEvent(this, "flickity:slide-settled", event)
                        }
                    }
                });
                resolve(flickityInstance)
                flickityInstance.hidefilldom();
            }
            );
            if (this.hasAttribute("click-nav")) {
                const flickityInstance = await this.flickityInstance;
                flickityInstance.on("staticClick", this._onStaticClick.bind(this));
                this.addEventListener("mousemove", this._onMouseMove.bind(this))
            }
            // this.style.height = this.querySelector(".flickity-viewport").style.height
            if(select){
                this.select(select)
            }
        }
        async _onStaticClick(event, pointer, cellElement) {
            const flickityInstance = await this.flickityInstance
              , isVideoOrModelType = flickityInstance.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(flickityInstance.selectedElement.getAttribute("data-media-type"));
            if (!cellElement || isVideoOrModelType || window.matchMedia(window.themeVariables.breakpoints.phone).matches) {
                return
            }
            const flickityViewport = flickityInstance.viewport
              , boundingRect = flickityViewport.getBoundingClientRect()
              , halfEdge = Math.floor(boundingRect.right - boundingRect.width / 2);
            if (pointer.clientX > halfEdge) {
                flickityInstance.next()
            } else {
                flickityInstance.previous()
            }
        }
        async _onMouseMove(event) {
            const flickityInstance = await this.flickityInstance
              , isVideoOrModelType = flickityInstance.selectedElement.hasAttribute("data-media-type") && ["video", "external_video", "model"].includes(flickityInstance.selectedElement.getAttribute("data-media-type"));
            this.classList.toggle("is-hovering-right", event.offsetX > this.clientWidth / 2 && !isVideoOrModelType);
            this.classList.toggle("is-hovering-left", event.offsetX <= this.clientWidth / 2 && !isVideoOrModelType)
        }
        async _preloadNextImage() {
            var _a;
            const flickityInstance = await this.flickity;
            if (flickityInstance.selectedElement.nextElementSibling) {
                (_a = flickityInstance.selectedElement.nextElementSibling.querySelector("img")) == null ? void 0 : _a.setAttribute("loading", "eager")
            }
        }
    }
    ;
    window.customElements.define("flickity-carousel", FlickityCarousel);
    function getSiblings(element, filter, includeSelf=false) {
        let siblings = [];
        let currentElement = element;
        while (currentElement = currentElement.previousElementSibling) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement)
            }
        }
        if (includeSelf) {
            siblings.push(element)
        }
        currentElement = element;
        while (currentElement = currentElement.nextElementSibling) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement)
            }
        }
        return siblings
    }
    async function resolveAsyncIterator(target) {
        const processedTarget = [];
        if (!(target != null && typeof target[Symbol.iterator] === "function")) {
            target = [target]
        }
        for (const targetItem of target) {
            if (typeof targetItem[Symbol.asyncIterator] === "function") {
                for await(const awaitTarget of targetItem) {
                    processedTarget.push(awaitTarget)
                }
            } else {
                processedTarget.push(targetItem)
            }
        }
        return processedTarget
    }
    var FlickityControls = class extends CustomHTMLElement {
        async connectedCallback() {
            this.flickityCarousel.addEventListener("flickity:ready", this._onSlideChanged.bind(this, false));
            this.flickityCarousel.addEventListener("flickity:slide-changed", this._onSlideChanged.bind(this, true));
            this.delegate.on("click", '[data-action="prev"]', ()=>this.flickityCarousel.previous());
            this.delegate.on("click", '[data-action="next"]', ()=>this.flickityCarousel.next());
            this.delegate.on("click", '[data-action="select"]', (event,target)=>this.flickityCarousel.select(`#${target.getAttribute("aria-controls")}`))
        }
        get flickityCarousel() {
            return this._flickityCarousel = this._flickityCarousel || document.getElementById(this.getAttribute("controls"))
        }
        async _onSlideChanged(animate=true) {
            let flickityInstance = await this.flickityCarousel.flickityInstance
              , activeItems = Array.from(this.querySelectorAll(`[aria-controls="${flickityInstance.selectedElement.id}"]`));
            activeItems.forEach(activeItem=>{
                activeItem.setAttribute("aria-current", "true");
                getSiblings(activeItem).forEach(sibling=>sibling.removeAttribute("aria-current"));
                requestAnimationFrame(()=>{
                    if (activeItem.offsetParent && activeItem.offsetParent !== this) {
                        const windowHalfHeight = activeItem.offsetParent.clientHeight / 2
                        , windowHalfWidth = activeItem.offsetParent.clientWidth / 2;
                        activeItem.offsetParent.scrollTo({
                            behavior: animate ? "smooth" : "auto",
                            top: activeItem.offsetTop - windowHalfHeight + activeItem.clientHeight / 2,
                            left: activeItem.offsetLeft - windowHalfWidth + activeItem.clientWidth / 2
                        })
                    }
                })
            })
        }
    };
    window.customElements.define("flickity-controls", FlickityControls);    
    var ExternalVideo = class extends CustomHTMLElement {
        constructor() {
            super();
            this.hasLoaded = false;
            (async()=>{
                if (this.autoPlay) {
                    await this.untilVisible({
                        rootMargin: "300px",
                        threshold: 0
                    });
                    this.play()
                } else {
                    this.addEventListener("click", this.play.bind(this), {
                        once: true
                    })
                }
            }
            )()
        }
        get autoPlay() {
            return this.hasAttribute("autoplay")
        }
        get provider() {
            return this.getAttribute("provider")
        }
        async play() {
            if (!this.hasLoaded) {
                await this._setupPlayer()
            }
            if (this.provider === "youtube") {
                this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                    event: "command",
                    func: "playVideo",
                    args: ""
                }), "*")
            } else if (this.provider === "vimeo") {
                this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                    method: "play"
                }), "*")
            }
        }
        pause() {
            if (!this.hasLoaded) {
                return
            }
            if (this.provider === "youtube") {
                this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                    event: "command",
                    func: "pauseVideo",
                    args: ""
                }), "*")
            } else if (this.provider === "vimeo") {
                this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({
                    method: "pause"
                }), "*")
            }
        }
        _setupPlayer() {
            if (this._setupPromise) {
                return this._setupPromise
            }
            return this._setupPromise = new Promise(resolve=>{
                const template2 = this.querySelector("template")
                  , node = template2.content.firstElementChild.cloneNode(true);
                node.onload = ()=>{
                    this.hasLoaded = true;
                    resolve()
                }
                ;
                if (this.autoPlay) {
                    template2.replaceWith(node)
                } else {
                    this.innerHTML = "";
                    this.appendChild(node)
                }
            }
            )
        }
    }
    ;
    window.customElements.define("external-video", ExternalVideo);
    var ProductLoader = class {
        static load(productHandle) {
            if (!productHandle) {
                return
            }
            if (this.loadedProducts[productHandle]) {
                return this.loadedProducts[productHandle]
            }
            this.loadedProducts[productHandle] = new Promise(async resolve=>{
                const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/products/${productHandle}.js`);
                const responseAsJson = await response.json();
                resolve(responseAsJson)
            }
            );
            return this.loadedProducts[productHandle]
        }
    }
    ;
    __publicField(ProductLoader, "loadedProducts", {});
    var ModelMedia = class extends HTMLElement {
        constructor() {
            super();
            LibraryLoader.load("modelViewerUiStyles");
            window.Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this._setupShopifyXr.bind(this)
            }, {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: ()=>{
                    this.modelUi = new window.Shopify.ModelViewerUI(this.firstElementChild,{
                        focusOnPlay: false
                    });
                    const modelViewer = this.querySelector("model-viewer");
                    modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", ()=>{
                        modelViewer.dispatchEvent(new CustomEvent("model:played",{
                            bubbles: true
                        }))
                    }
                    );
                    modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", ()=>{
                        modelViewer.dispatchEvent(new CustomEvent("model:paused",{
                            bubbles: true
                        }))
                    }
                    )
                }
            }])
        }
        disconnectedCallback() {
            var _a;
            (_a = this.modelUi) == null ? void 0 : _a.destroy()
        }
        play() {
            if (this.modelUi) {
                this.modelUi.play()
            }
        }
        pause() {
            if (this.modelUi) {
                this.modelUi.pause()
            }
        }
        async _setupShopifyXr() {
            if (!window.ShopifyXR) {
                document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this))
            } else {
                const product = await ProductLoader.load(this.getAttribute("product-handle"));
                const models = product["media"].filter(media=>media["media_type"] === "model");
                window.ShopifyXR.addModels(models);
                window.ShopifyXR.setupXRElements()
            }
        }
    }
    ;
    window.customElements.define("model-media", ModelMedia);
    var NativeVideo = class extends HTMLElement {
        constructor() {
            super();
            this.hasLoaded = false;
            if (this.autoPlay) {
                this.play()
            } else {
                this.addEventListener("click", this.play.bind(this), {
                    once: true
                })
            }
        }
        get autoPlay() {
            return this.hasAttribute("autoplay")
        }
        play() {
            if (!this.hasLoaded) {
                this._replaceContent()
            }
            this.querySelector("video").play()
        }
        pause() {
            if (this.hasLoaded) {
                this.querySelector("video").pause()
            }
        }
        _replaceContent() {
            const node = this.querySelector("template").content.firstElementChild.cloneNode(true);
            this.innerHTML = "";
            this.appendChild(node);
            this.firstElementChild.addEventListener("play", ()=>{
                this.dispatchEvent(new CustomEvent("video:played",{
                    bubbles: true
                }))
            }
            );
            this.firstElementChild.addEventListener("pause", ()=>{
                this.dispatchEvent(new CustomEvent("video:paused",{
                    bubbles: true
                }))
            }
            );
            this.hasLoaded = true
        }
    }
    ;
    window.customElements.define("native-video", NativeVideo);
    var ComboBox = class extends OpenableElement {
        connectedCallback() {
            super.connectedCallback();
            this.options = Array.from(this.querySelectorAll('[role="option"]'));
            this.delegate.on("click", '[role="option"]', this._onValueClicked.bind(this));
            this.delegate.on("keydown", '[role="listbox"]', this._onKeyDown.bind(this));
            this.delegate.on("change", "select", this._onValueChanged.bind(this));
            this.delegate.on("click", ".combo-box__overlay", ()=>this.open = false);
            if (this.hasAttribute("fit-toggle")) {
                const maxWidth = Math.max(...this.options.map(item=>item.clientWidth))
                  , control = document.querySelector(`[aria-controls="${this.id}"]`);
                if (control) {
                    control.style.setProperty("--largest-option-width", `${maxWidth + 2}px`)
                }
            }
        }
        get nativeSelect() {
            return this.querySelector("select")
        }
        set selectedValue(value) {
            this.options.forEach(option=>{
                option.setAttribute("aria-selected", option.getAttribute("value") === value ? "true" : "false")
            }
            )
        }
        attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            switch (name) {
            case "open":
                if (this.open) {
                    const boundingRect = this.getBoundingClientRect();
                    this.classList.toggle("combo-box--top", boundingRect.top >= window.innerHeight / 2 * 1.5);
                    setTimeout(()=>this.focusTrap.activate(), 150)
                } else {
                    this.focusTrap.deactivate();
                    setTimeout(()=>this.classList.remove("combo-box--top"), 200)
                }
                document.documentElement.classList.toggle("lock-mobile", this.open)
            }
        }
        _onValueClicked(event, target) {
            this.selectedValue = target.value;
            this.nativeSelect.value = target.value;
            this.nativeSelect.dispatchEvent(new Event("change",{
                bubbles: true
            }));
            this.open = false
        }
        _onValueChanged(event, target) {
            Array.from(this.nativeSelect.options).forEach(option=>option.toggleAttribute("selected", target.value === option.value));
            this.selectedValue = target.value
        }
        _onKeyDown(event) {
            var _a, _b;
            if (event.key === "ArrowDown" || event.key === "ArrowUp") {
                event.preventDefault();
                if (event.key === "ArrowDown") {
                    (_a = document.activeElement.nextElementSibling) == null ? void 0 : _a.focus()
                } else {
                    (_b = document.activeElement.previousElementSibling) == null ? void 0 : _b.focus()
                }
            }
        }
    }
    ;
    window.customElements.define("combo-box", ComboBox);
    var QuantitySelector = class extends CustomHTMLElement {
        connectedCallback() {
            this.inputElement = this.querySelector("input");
            this.delegate.on("click", "button:first-child", ()=>this.inputElement.quantity = this.inputElement.quantity - 1);
            this.delegate.on("click", "button:last-child", ()=>this.inputElement.quantity = this.inputElement.quantity + 1)
        }
    }
    ;
    window.customElements.define("quantity-selector", QuantitySelector);
    var InputNumber = class extends HTMLInputElement {
        connectedCallback() {
            this.addEventListener("input", this._onValueInput.bind(this));
            this.addEventListener("change", this._onValueChanged.bind(this));
            this.addEventListener("keydown", this._onKeyDown.bind(this))
        }
        get quantity() {
            return parseInt(this.value)
        }
        set quantity(quantity) {
            const isNumeric = (typeof quantity === "number" || typeof quantity === "string" && quantity.trim() !== "") && !isNaN(quantity);
            if (quantity === "") {
                return
            }
            if (!isNumeric || quantity < 0) {
                quantity = parseInt(quantity) || 1
            }
            this.value = Math.max(this.min || 1, Math.min(quantity, this.max || Number.MAX_VALUE)).toString();
            this.size = Math.max(this.value.length + 1, 2)
        }
        _onValueInput() {
            this.quantity = this.value
        }
        _onValueChanged() {
            if (this.value === "") {
                this.quantity = 1
            }
        }
        _onKeyDown(event) {
            event.stopPropagation();
            if (event.key === "ArrowUp") {
                this.quantity = this.quantity + 1
            } else if (event.key === "ArrowDown") {
                this.quantity = this.quantity - 1
            }
        }
    }
    ;
    window.customElements.define("input-number", InputNumber, {
        extends: "input"
    });
    var AnnouncementBar = class extends CustomHTMLElement {
        async connectedCallback() {
            await customElements.whenDefined("announcement-bar-item");
            this.items = Array.from(this.querySelectorAll("announcement-bar-item"));
            this.hasPendingTransition = false;
            this.delegate.on("click", '[data-action="prev"]', this.previous.bind(this));
            this.delegate.on("click", '[data-action="next"]', this.next.bind(this));
            if (this.autoPlay) {
                this.delegate.on("announcement-bar:content:open", this._pausePlayer.bind(this));
                this.delegate.on("announcement-bar:content:close", this._startPlayer.bind(this))
            }
            if (window.ResizeObserver) {
                this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this));
                this.resizeObserver.observe(this)
            }
            if (this.autoPlay) {
                this._startPlayer()
            }
            if (Shopify.designMode) {
                this.delegate.on("shopify:block:select", event=>this.select(event.target.index, false))
            }
        }
        get autoPlay() {
            return this.hasAttribute("auto-play")
        }
        get selectedIndex() {
            return this.items.findIndex(item=>item.selected)
        }
        previous() {
            this.select((this.selectedIndex - 1 + this.items.length) % this.items.length)
        }
        next() {
            this.select((this.selectedIndex + 1 + this.items.length) % this.items.length)
        }
        async select(index, animate=true) {
            if (this.selectedIndex === index || this.hasPendingTransition) {
                return
            }
            if (this.autoPlay) {
                this._pausePlayer()
            }
            this.hasPendingTransition = true;
            await this.items[this.selectedIndex].deselect(animate);
            await this.items[index].select(animate);
            this.hasPendingTransition = false;
            if (this.autoPlay) {
                this._startPlayer()
            }
        }
        _pausePlayer() {
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
        }
        _startPlayer() {
            this._pausePlayer(); // 确保先清除旧的 interval
            this._interval = setInterval(this.next.bind(this), parseInt(this.getAttribute("cycle-speed")) * 1e3)
        }
        _updateCustomProperties(entries) {
            entries.forEach(entry=>{
                if (entry.target === this) {
                    const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
                    document.documentElement.style.setProperty("--announcement-bar-height", `${height}px`)
                }
            }
            )
        }
    }
    ;
    window.customElements.define("announcement-bar", AnnouncementBar);
    var AnnouncementBarItem = class extends CustomHTMLElement {
        connectedCallback() {
            if (this.hasContent) {
                this.contentElement = this.querySelector(".announcement-bar__content");
                this.delegate.on("click", '[data-action="open-content"]', this.openContent.bind(this));
                this.delegate.on("click", '[data-action="close-content"]', this.closeContent.bind(this));
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:select", this.openContent.bind(this));
                    this.addEventListener("shopify:block:deselect", this.closeContent.bind(this))
                }
            }
        }
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get hasContent() {
            return this.hasAttribute("has-content")
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        get focusTrap() {
            return this._trapFocus = this._trapFocus || createFocusTrap(this.contentElement.querySelector(".announcement-bar__content-inner"), {
                fallbackFocus: this,
                clickOutsideDeactivates: event=>!(event.target.tagName === "BUTTON"),
                allowOutsideClick: event=>event.target.tagName === "BUTTON",
                onDeactivate: this.closeContent.bind(this),
                preventScroll: true
            })
        }
        async select(animate=true) {
            this.removeAttribute("hidden");
            await new Promise(resolve=>{
                this.animate({
                    transform: ["translateY(8px)", "translateY(0)"],
                    opacity: [0, 1]
                }, {
                    duration: animate ? 150 : 0,
                    easing: "ease-in-out"
                }).onfinish = resolve
            }
            )
        }
        async deselect(animate=true) {
            await this.closeContent();
            await new Promise(resolve=>{
                this.animate({
                    transform: ["translateY(0)", "translateY(-8px)"],
                    opacity: [1, 0]
                }, {
                    duration: animate ? 150 : 0,
                    easing: "ease-in-out"
                }).onfinish = resolve
            }
            );
            this.setAttribute("hidden", "")
        }
        async openContent() {
            if (this.hasContent) {
                this.contentElement.addEventListener("transitionend", ()=>this.focusTrap.activate(), {
                    once: true
                });
                this.contentElement.removeAttribute("hidden");
                document.documentElement.classList.add("lock-all");
                this.dispatchEvent(new CustomEvent("announcement-bar:content:open",{
                    bubbles: true
                }))
            }
        }
        async closeContent() {
            if (!this.hasContent || this.contentElement.hasAttribute("hidden")) {
                return Promise.resolve()
            }
            await new Promise(resolve=>{
                this.contentElement.addEventListener("transitionend", ()=>resolve(), {
                    once: true
                });
                this.contentElement.setAttribute("hidden", "");
                this.focusTrap.deactivate();
                document.documentElement.classList.remove("lock-all");
                this.dispatchEvent(new CustomEvent("announcement-bar:content:close",{
                    bubbles: true
                }))
            }
            )
        }
    }
    ;
    window.customElements.define("announcement-bar-item", AnnouncementBarItem);
    var SearchPage = class extends HTMLElement {
        connectedCallback() {
            this.facetToolbar = document.getElementById("mobile-facet-toolbar");
            this.tabsNav = document.getElementById("search-tabs-nav");
            this.tabsNav.addEventListener("tabs-nav:changed", this._onCategoryChanged.bind(this));
            this._completeSearch()
        }
        get terms() {
            return this.getAttribute("terms")
        }
        get completeFor() {
            return JSON.parse(this.getAttribute("complete-for")).filter(item=>!(item === ""))
        }
        async _completeSearch() {
            const promisesList = [];
            this.completeFor.forEach(item=>{
                promisesList.push(fetch(`${window.themeVariables.routes.searchUrl}?section_id=${this.getAttribute("section-id")}&q=${this.terms}&type=${item}&options[prefix]=last&options[unavailable_products]=${window.themeVariables.settings.searchUnavailableProducts}`))
            }
            );
            const responses = await Promise.all(promisesList);
            await Promise.all(responses.map(async response=>{
                const div = document.createElement("div");
                div.innerHTML = await response.text();
                const categoryResultDiv = div.querySelector(".main-search__category-result")
                  , tabNavItem = div.querySelector("#search-tabs-nav .tabs-nav__item");
                if (categoryResultDiv) {
                    categoryResultDiv.setAttribute("hidden", "");
                    this.insertAdjacentElement("beforeend", categoryResultDiv);
                    this.tabsNav.addButton(tabNavItem)
                }
            }
            ))
        }
        _onCategoryChanged(event) {
            const button = event.detail.button;
            this.facetToolbar.classList.toggle("is-collapsed", button.getAttribute("data-type") !== "product")
        }
    }
    ;
    window.customElements.define("search-page", SearchPage);
    var CookieBar = class extends CustomHTMLElement {
        connectedCallback() {
            if (window.Shopify && window.Shopify.designMode) {
                this.rootDelegate.on("shopify:section:select", event=>filterShopifyEvent(event, this, ()=>this.open = true));
                this.rootDelegate.on("shopify:section:deselect", event=>filterShopifyEvent(event, this, ()=>this.open = false))
            }
            this.delegate.on("click", '[data-action~="accept-policy"]', this._acceptPolicy.bind(this));
            this.delegate.on("click", '[data-action~="decline-policy"]', this._declinePolicy.bind(this));
            window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1",
                onLoad: this._onCookieBarSetup.bind(this)
            }])
        }
        set open(value) {
            this.toggleAttribute("hidden", !value)
        }
        _onCookieBarSetup() {
            if (window.Shopify.customerPrivacy.shouldShowGDPRBanner()) {
                this.open = true
            }
        }
        _acceptPolicy() {
            window.Shopify.customerPrivacy.setTrackingConsent(true, ()=>this.open = false)
        }
        _declinePolicy() {
            window.Shopify.customerPrivacy.setTrackingConsent(false, ()=>this.open = false)
        }
    }
    ;
    window.customElements.define("cookie-bar", CookieBar);
    var ProductRecommendations = class extends HTMLElement {
        async connectedCallback() {
            if (!this.hasAttribute("use-automatic-recommendations")) {
                return
            }
            const response = await fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}`);
            const div = document.createElement("div");
            div.innerHTML = await response.text();
            const productRecommendationsElement = div.querySelector("product-recommendations");
            if (productRecommendationsElement.hasChildNodes()) {
                this.innerHTML = productRecommendationsElement.innerHTML
            }
        }
        get productId() {
            return this.getAttribute("product-id")
        }
        get sectionId() {
            return this.getAttribute("section-id")
        }
        get recommendationsCount() {
            return parseInt(this.getAttribute("recommendations-count") || 4)
        }
    }
    ;
    window.customElements.define("product-recommendations", ProductRecommendations);
    var RecentlyViewedProducts = class extends HTMLElement {
        async connectedCallback() {
            if (this.searchQueryString === "") {
                return
            }
            const response = await fetch(`${window.themeVariables.routes.searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`);
            const div = document.createElement("div");
            div.innerHTML = await response.text();
            const recentlyViewedProductsElement = div.querySelector("recently-viewed-products");
            if (recentlyViewedProductsElement.hasChildNodes()) {
                this.innerHTML = recentlyViewedProductsElement.innerHTML
            }
        }
        get searchQueryString() {
            const items = JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]");
            if (this.hasAttribute("exclude-product-id") && items.includes(parseInt(this.getAttribute("exclude-product-id")))) {
                items.splice(items.indexOf(parseInt(this.getAttribute("exclude-product-id"))), 1)
            }
            return items.map(item=>"id:" + item).slice(0, this.productsCount).join(" OR ")
        }
        get sectionId() {
            return this.getAttribute("section-id")
        }
        get productsCount() {
            return this.getAttribute("products-count") || 4
        }
    }
    ;
    window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
    function getSizedMediaUrl(media, size) {
        let src = typeof media === "string" ? media : media["preview_image"] ? media["preview_image"]["src"] : media["url"];
        if (size === null) {
            return src
        }
        if (size === "master") {
            return src.replace(/http(s)?:/, "")
        }
        const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
        if (match) {
            const prefix = src.split(match[0]);
            const suffix = match[0];
            return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
        } else {
            return null
        }
    }
    function getMediaSrcset(media, sizeList) {
        let srcset = []
          , supportedSizes = typeof media === "string" ? sizeList : getSupportedSizes(media, sizeList);
        supportedSizes.forEach(supportedSize=>{
            srcset.push(`${getSizedMediaUrl(media, supportedSize + "x")} ${supportedSize}w`)
        }
        );
        return srcset.join(",")
    }
    function getSupportedSizes(media, desiredSizes) {
        let supportedSizes = []
          , mediaWidth = media["preview_image"]["width"];
        desiredSizes.forEach(width=>{
            if (mediaWidth >= width) {
                supportedSizes.push(width)
            }
        }
        );
        return supportedSizes
    }
    function imageLoaded(image) {
        return new Promise(resolve=>{
            if (!image || image.tagName !== "IMG" || image.complete) {
                resolve()
            } else {
                image.onload = ()=>resolve()
            }
        }
        )
    }
    var CustomAnimation = class {
        constructor(effect) {
            this._effect = effect;
            this._playState = "idle";
            this._finished = Promise.resolve()
        }
        get finished() {
            return this._finished
        }
        get animationEffects() {
            return this._effect instanceof CustomKeyframeEffect ? [this._effect] : this._effect.animationEffects
        }
        cancel() {
            this.animationEffects.forEach(animationEffect=>animationEffect.cancel())
        }
        finish() {
            this.animationEffects.forEach(animationEffect=>animationEffect.finish())
        }
        play() {
            this._playState = "running";
            this._effect.play();
            this._finished = this._effect.finished;
            this._finished.then(()=>{
                this._playState = "finished"
            }
            , rejection=>{
                this._playState = "idle"
            }
            )
        }
    }
    ;
    var CustomKeyframeEffect = class {
        constructor(target, keyframes, options={}) {
            if (!target) {
                return
            }
            if ("Animation"in window) {
                this._animation = new Animation(new KeyframeEffect(target,keyframes,options))
            } else {
                options["fill"] = "forwards";
                this._animation = target.animate(keyframes, options);
                this._animation.pause()
            }
            this._animation.addEventListener("finish", ()=>{
                target.style.opacity = keyframes.hasOwnProperty("opacity") ? keyframes["opacity"][keyframes["opacity"].length - 1] : null;
                target.style.visibility = keyframes.hasOwnProperty("visibility") ? keyframes["visibility"][keyframes["visibility"].length - 1] : null
            }
            )
        }
        get finished() {
            if (!this._animation) {
                return Promise.resolve()
            }
            return this._animation.finished ? this._animation.finished : new Promise(resolve=>this._animation.onfinish = resolve)
        }
        play() {
            if (this._animation) {
                this._animation.startTime = null;
                this._animation.play()
            }
        }
        cancel() {
            if (this._animation) {
                this._animation.cancel()
            }
        }
        finish() {
            if (this._animation) {
                this._animation.finish()
            }
        }
    }
    ;
    var GroupEffect = class {
        constructor(childrenEffects) {
            this._childrenEffects = childrenEffects;
            this._finished = Promise.resolve()
        }
        get finished() {
            return this._finished
        }
        get animationEffects() {
            return this._childrenEffects.flatMap(effect=>{
                return effect instanceof CustomKeyframeEffect ? effect : effect.animationEffects
            }
            )
        }
    }
    ;
    var ParallelEffect = class extends GroupEffect {
        play() {
            const promises = [];
            for (const effect of this._childrenEffects) {
                effect.play();
                promises.push(effect.finished)
            }
            this._finished = Promise.all(promises)
        }
    }
    ;
    var SequenceEffect = class extends GroupEffect {
        play() {
            this._finished = new Promise(async(resolve,reject)=>{
                try {
                    for (const effect of this._childrenEffects) {
                        effect.play();
                        await effect.finished
                    }
                    resolve()
                } catch (exception) {
                    reject()
                }
            }
            )
        }
    }
    ;
    var SlideshowItem = class extends HTMLElement {
        async connectedCallback() {
            this._pendingAnimations = [];
            this.addEventListener("split-lines:re-split", event=>{
                Array.from(event.target.children).forEach(line=>line.style.visibility = this.selected ? "visible" : "hidden")
            }
            );
            if (MediaFeatures.prefersReducedMotion()) {
                this.setAttribute("reveal-visibility", "");
                Array.from(this.querySelectorAll("[reveal], [reveal-visibility]")).forEach(item=>{
                    item.removeAttribute("reveal");
                    item.removeAttribute("reveal-visibility")
                }
                )
            }
        }
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        async transitionToLeave(transitionType, shouldAnimate=true) {
            if (transitionType !== "reveal") {
                this.setAttribute("hidden", "")
            }
            this._pendingAnimations.forEach(animation2=>animation2.cancel());
            this._pendingAnimations = [];
            let animation = null
              , textElements = await resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper"))
              , imageElements = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
            switch (transitionType) {
            case "sweep":
                animation = new CustomAnimation(new SequenceEffect([new CustomKeyframeEffect(this,{
                    visibility: ["visible", "hidden"]
                },{
                    duration: 500
                }), new ParallelEffect(textElements.map(item=>{
                    return new CustomKeyframeEffect(item,{
                        opacity: [1, 0],
                        visibility: ["visible", "hidden"]
                    })
                }
                ))]));
                break;
            case "fade":
                animation = new CustomAnimation(new CustomKeyframeEffect(this,{
                    opacity: [1, 0],
                    visibility: ["visible", "hidden"]
                },{
                    duration: 250,
                    easing: "ease-in-out"
                }));
                break;
            case "reveal":
                animation = new CustomAnimation(new SequenceEffect([new ParallelEffect(textElements.reverse().map(item=>{
                    return new CustomKeyframeEffect(item,{
                        opacity: [1, 0],
                        visibility: ["visible", "hidden"]
                    },{
                        duration: 250,
                        easing: "ease-in-out"
                    })
                }
                )), new ParallelEffect(imageElements.map(item=>{
                    if (!item.classList.contains("slideshow__image-wrapper--secondary")) {
                        return new CustomKeyframeEffect(item,{
                            visibility: ["visible", "hidden"],
                            clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"]
                        },{
                            duration: 450,
                            easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)"
                        })
                    } else {
                        return new CustomKeyframeEffect(item,{
                            visibility: ["visible", "hidden"],
                            clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"]
                        },{
                            duration: 450,
                            easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)"
                        })
                    }
                }
                ))]));
                break
            }
            await this._executeAnimation(animation, shouldAnimate);
            if (transitionType === "reveal") {
                this.setAttribute("hidden", "")
            }
        }
        async transitionToEnter(transitionType, shouldAnimate=true, reverseDirection=false) {
            this.removeAttribute("hidden");
            await this._untilReady();
            if (this.hasAttribute('initially-visible')) {
              this.style.visibility = 'visible';
              this.removeAttribute('initially-visible');
              return Promise.resolve();
            }
            let animation = null
              , textElements = await resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper"))
              , imageElements = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
            switch (transitionType) {
            case "sweep":
                animation = new CustomAnimation(new SequenceEffect([new CustomKeyframeEffect(this,{
                    visibility: ["hidden", "visible"],
                    clipPath: reverseDirection ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"] : ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
                },{
                    duration: 500,
                    easing: "cubic-bezier(1, 0, 0, 1)"
                }), new ParallelEffect(textElements.map((item,index)=>{
                    return new CustomKeyframeEffect(item,{
                        opacity: [0, 1],
                        visibility: ["hidden", "visible"],
                        clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                        transform: ["translateY(100%)", "translateY(0)"]
                    },{
                        duration: 450,
                        delay: 100 * index,
                        easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                    })
                }
                ))]));
                break;
            case "fade":
                animation = new CustomAnimation(new CustomKeyframeEffect(this,{
                    opacity: [0, 1],
                    visibility: ["hidden", "visible"]
                },{
                    duration: 250,
                    easing: "ease-in-out"
                }));
                break;
            case "reveal":
                animation = new CustomAnimation(new SequenceEffect([new ParallelEffect(imageElements.map(item=>{
                    if (!item.classList.contains("slideshow__image-wrapper--secondary")) {
                        return new CustomKeyframeEffect(item,{
                            visibility: ["hidden", "visible"],
                            clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
                        },{
                            duration: 450,
                            delay: 100,
                            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                        })
                    } else {
                        return new CustomKeyframeEffect(item,{
                            visibility: ["hidden", "visible"],
                            clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"]
                        },{
                            duration: 450,
                            delay: 100,
                            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                        })
                    }
                }
                )), new ParallelEffect(textElements.map((item,index)=>{
                    return new CustomKeyframeEffect(item,{
                        opacity: [0, 1],
                        visibility: ["hidden", "visible"],
                        clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                        transform: ["translateY(100%)", "translateY(0)"]
                    },{
                        duration: 450,
                        delay: 100 * index,
                        easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                    })
                }
                ))]));
                break
            }
            return this._executeAnimation(animation, shouldAnimate)
        }
        async _executeAnimation(animation, shouldAnimate) {
            this._pendingAnimations.push(animation);
            shouldAnimate ? animation.play() : animation.finish();
            return animation.finished
        }
        async _untilReady() {
            return Promise.all(this._getVisibleImages().map(image=>imageLoaded(image)))
        }
        _preloadImages() {
            this._getVisibleImages().forEach(image=>{
                image.setAttribute("loading", "eager")
            }
            )
        }
        _getVisibleImages() {
            return Array.from(this.querySelectorAll("img")).filter(image=>{
                return getComputedStyle(image.parentElement).display !== "none"
            }
            )
        }
    }
    ;
    window.customElements.define("slide-show-item", SlideshowItem);
    var VerticalScrollBlockerMixin = {
        _blockVerticalScroll(threshold=18) {
            this.addEventListener("touchstart", event=>{
                this.firstTouchClientX = event.touches[0].clientX
            }
            );
            this.addEventListener("touchmove", event=>{
                const touchClientX = event.touches[0].clientX - this.firstTouchClientX;
                if (Math.abs(touchClientX) > threshold) {
                    event.preventDefault()
                }
            }
            , {
                passive: false
            })
        }
    };
    var Slideshow = class extends CustomHTMLElement {
        connectedCallback() {
            this.items = Array.from(this.querySelectorAll("slide-show-item"));
            this.pageDots = this.querySelector("page-dots");
            this.isTransitioning = false;
            if (this.items.length > 1) {
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this));
                    this.addEventListener("shopify:block:select", event=>{
                        this.pausePlayer();
                        this.intersectionObserver.disconnect();
                        if (!(!event.detail.load && event.target.selected)) {
                            this.select(event.target.index, !event.detail.load)
                        }
                    }
                    )
                }
                this.addEventListener("swiperight", this.previous.bind(this));
                this.addEventListener("swipeleft", this.next.bind(this));
                this.addEventListener("page-dots:changed", event=>this.select(event.detail.index));
                this._blockVerticalScroll()
            }
            this._setupVisibility()
        }
        get selectedIndex() {
            return this.items.findIndex(item=>item.selected)
        }
        get transitionType() {
            return MediaFeatures.prefersReducedMotion() ? "fade" : this.getAttribute("transition-type")
        }
        async _setupVisibility() {
            await this.untilVisible();
            await this.items[this.selectedIndex].transitionToEnter(this.transitionType).catch(error=>{}
            );
            this.startPlayer()
        }
        previous() {
            this.select((this.selectedIndex - 1 + this.items.length) % this.items.length, true, true)
        }
        next() {
            this.select((this.selectedIndex + 1 + this.items.length) % this.items.length, true, false)
        }
        async select(index, shouldTransition=true, reverseDirection=false) {
            if (this.transitionType === "reveal" && this.isTransitioning) {
                return
            }
            this.isTransitioning = true;
            const previousItem = this.items[this.selectedIndex]
              , newItem = this.items[index];
            this.items[(newItem.index + 1) % this.items.length]._preloadImages();
            if (previousItem && previousItem !== newItem) {
                if (this.transitionType !== "reveal") {
                    previousItem.transitionToLeave(this.transitionType, shouldTransition)
                } else {
                    await previousItem.transitionToLeave(this.transitionType, shouldTransition)
                }
            }
            if (this.pageDots) {
                this.pageDots.selectedIndex = newItem.index
            }
            await newItem.transitionToEnter(this.transitionType, shouldTransition, reverseDirection).catch(error=>{}
            );
            this.isTransitioning = false
        }
        pausePlayer() {
            this.style.setProperty("--section-animation-play-state", "paused")
        }
        startPlayer() {
            if (this.hasAttribute("auto-play")) {
                this.style.setProperty("--section-animation-play-state", "running")
            }
        }
    }
    ;
    Object.assign(Slideshow.prototype, VerticalScrollBlockerMixin);
    window.customElements.define("slide-show", Slideshow);
    var ImageWithTextItem = class extends HTMLElement {
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        get hasAttachedImage() {
            return this.hasAttribute("attached-image")
        }
        async transitionToEnter(shouldAnimate=true) {
            this.removeAttribute("hidden");
            const textWrapper = this.querySelector(".image-with-text__text-wrapper")
              , headings = await resolveAsyncIterator(this.querySelectorAll(".image-with-text__content split-lines"));
            const animation = new CustomAnimation(new SequenceEffect([new ParallelEffect(headings.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, .2, 1],
                    transform: ["translateY(100%)", "translateY(0)"],
                    clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
                },{
                    duration: 350,
                    delay: 120 * index,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                })
            }
            )), new CustomKeyframeEffect(textWrapper,{
                opacity: [0, 1]
            },{
                duration: 300
            })]));
            shouldAnimate ? animation.play() : animation.finish();
            return animation.finished
        }
        async transitionToLeave(shouldAnimate=true) {
            const elements = await resolveAsyncIterator(this.querySelectorAll(".image-with-text__text-wrapper, .image-with-text__content split-lines"));
            const animation = new CustomAnimation(new ParallelEffect(elements.map(item=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [1, 0]
                },{
                    duration: 200
                })
            }
            )));
            shouldAnimate ? animation.play() : animation.finish();
            await animation.finished;
            this.setAttribute("hidden", "")
        }
    }
    ;
    window.customElements.define("image-with-text-item", ImageWithTextItem);
    var ImageWithText = class extends CustomHTMLElement {
        connectedCallback() {
            this.items = Array.from(this.querySelectorAll("image-with-text-item"));
            this.imageItems = Array.from(this.querySelectorAll(".image-with-text__image"));
            this.pageDots = this.querySelector("page-dots");
            this.hasPendingTransition = false;
            if (this.items.length > 1) {
                this.addEventListener("page-dots:changed", event=>this.select(event.detail.index));
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this));
                    this.addEventListener("shopify:block:select", event=>{
                        this.intersectionObserver.disconnect();
                        this.pausePlayer();
                        this.select(event.target.index, !event.detail.load)
                    }
                    )
                }
            }
            this._setupVisibility()
        }
        async _setupVisibility() {
            await this.untilVisible();
            if (this.hasAttribute("reveal-on-scroll")) {
                await this.transitionImage(this.selectedIndex);
                this.select(this.selectedIndex)
            }
            this.startPlayer()
        }
        get selectedIndex() {
            return this.items.findIndex(item=>item.selected)
        }
        async select(index, shouldAnimate=true) {
            if (this.hasPendingTransition) {
                return
            }
            this.hasPendingTransition = true;
            if (this.items[index].hasAttachedImage || !shouldAnimate) {
                await this.transitionImage(index, shouldAnimate)
            }
            if (this.selectedIndex !== index) {
                await this.items[this.selectedIndex].transitionToLeave(shouldAnimate)
            }
            if (this.pageDots) {
                this.pageDots.selectedIndex = index
            }
            await this.items[index].transitionToEnter(shouldAnimate);
            this.hasPendingTransition = false
        }
        async transitionImage(index, shouldAnimate=true) {
            const activeImage = this.imageItems.find(item=>!item.hasAttribute("hidden"))
              , nextImage = this.imageItems.find(item=>item.id === this.items[index].getAttribute("attached-image")) || activeImage;
            activeImage.setAttribute("hidden", "");
            nextImage.removeAttribute("hidden");
            await imageLoaded(nextImage);
            const animation = new CustomAnimation(new CustomKeyframeEffect(nextImage,{
                visibility: ["hidden", "visible"],
                clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
            },{
                duration: 600,
                easing: "cubic-bezier(1, 0, 0, 1)"
            }));
            shouldAnimate ? animation.play() : animation.finish()
        }
        pausePlayer() {
            this.style.setProperty("--section-animation-play-state", "paused")
        }
        startPlayer() {
            this.style.setProperty("--section-animation-play-state", "running")
        }
    }
    ;
    window.customElements.define("image-with-text", ImageWithText);
    var TestimonialItem = class extends CustomHTMLElement {
        connectedCallback() {
            this.addEventListener("split-lines:re-split", event=>{
                Array.from(event.target.children).forEach(line=>line.style.visibility = this.selected ? "visible" : "hidden")
            }
            )
        }
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        async transitionToLeave(shouldAnimate=true) {
            const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author"))
              , animation = new CustomAnimation(new ParallelEffect(textLines.reverse().map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    visibility: ["visible", "hidden"],
                    clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                    transform: ["translateY(0)", "translateY(100%)"]
                },{
                    duration: 350,
                    delay: 60 * index,
                    easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)"
                })
            }
            )));
            shouldAnimate ? animation.play() : animation.finish();
            await animation.finished;
            this.setAttribute("hidden", "")
        }
        async transitionToEnter(shouldAnimate=true) {
            const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author"))
              , animation = new CustomAnimation(new ParallelEffect(textLines.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    visibility: ["hidden", "visible"],
                    clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
                    transform: ["translateY(100%)", "translateY(0)"]
                },{
                    duration: 550,
                    delay: 120 * index,
                    easing: "cubic-bezier(0.23, 1, 0.32, 1)"
                })
            }
            )));
            this.removeAttribute("hidden");
            shouldAnimate ? animation.play() : animation.finish();
            return animation.finished
        }
    }
    ;
    window.customElements.define("testimonial-item", TestimonialItem);
    var TestimonialList = class extends CustomHTMLElement {
        connectedCallback() {
            this.items = Array.from(this.querySelectorAll("testimonial-item"));
            this.pageDots = this.querySelector("page-dots");
            this.hasPendingTransition = false;
            if (this.items.length > 1) {
                this.addEventListener("swiperight", this.previous.bind(this));
                this.addEventListener("swipeleft", this.next.bind(this));
                this.addEventListener("prev-next:prev", this.previous.bind(this));
                this.addEventListener("prev-next:next", this.next.bind(this));
                this.addEventListener("page-dots:changed", event=>this.select(event.detail.index));
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:select", event=>{
                        var _a;
                        (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
                        if (event.detail.load || !event.target.selected) {
                            this.select(event.target.index, !event.detail.load)
                        }
                    }
                    )
                }
                this._blockVerticalScroll()
            }
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
        }
        get selectedIndex() {
            return this.items.findIndex(item=>item.selected)
        }
        async _setupVisibility() {
            await this.untilVisible();
            this.items[this.selectedIndex].transitionToEnter()
        }
        previous() {
            this.select((this.selectedIndex - 1 + this.items.length) % this.items.length)
        }
        next() {
            this.select((this.selectedIndex + 1 + this.items.length) % this.items.length)
        }
        async select(index, shouldAnimate=true) {
            if (this.hasPendingTransition) {
                return
            }
            this.hasPendingTransition = true;
            await this.items[this.selectedIndex].transitionToLeave(shouldAnimate);
            if (this.pageDots) {
                this.pageDots.selectedIndex = index
            }
            await this.items[index].transitionToEnter(shouldAnimate);
            this.hasPendingTransition = false
        }
    }
    ;
    Object.assign(TestimonialList.prototype, VerticalScrollBlockerMixin);
    window.customElements.define("testimonial-list", TestimonialList);
    var ShopTheLookItem = class extends HTMLElement {
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        async transitionToLeave(shouldAnimate=true) {
            this.setAttribute("hidden", "");
            const animation = new CustomAnimation(new CustomKeyframeEffect(this,{
                visibility: ["visible", "hidden"]
            },{
                duration: 500
            }));
            shouldAnimate ? animation.play() : animation.finish();
            return animation.finished
        }
        async transitionToEnter(shouldAnimate=true) {
            this.removeAttribute("hidden");
            const dots = Array.from(this.querySelectorAll(".shop-the-look__dot"));
            dots.forEach(dot=>dot.style.opacity = 0);
            const animation = new CustomAnimation(new SequenceEffect([new ParallelEffect(Array.from(this.querySelectorAll(".shop-the-look__image")).map(item=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [1, 1]
                },{
                    duration: 0
                })
            }
            )), new CustomKeyframeEffect(this,{
                visibility: ["hidden", "visible"],
                zIndex: [0, 1],
                clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
            },{
                duration: 500,
                easing: "cubic-bezier(1, 0, 0, 1)"
            }), new ParallelEffect(dots.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, 1],
                    transform: ["scale(0)", "scale(1)"]
                },{
                    duration: 120,
                    delay: 75 * index,
                    easing: "ease-in-out"
                })
            }
            ))]));
            shouldAnimate ? animation.play() : animation.finish();
            await animation.finished;
            if (window.matchMedia(window.themeVariables.breakpoints.tabletAndUp).matches) {
                const firstPopover = this.querySelector(".shop-the-look__product-wrapper .shop-the-look__dot");
                firstPopover == null ? void 0 : firstPopover.setAttribute("aria-expanded", "true")
            }
        }
    }
    ;
    window.customElements.define("shop-the-look-item", ShopTheLookItem);
    var ShopTheLookNav = class extends CustomHTMLElement {
        connectedCallback() {
            this.shopTheLook = this.closest("shop-the-look");
            this.delegate.on("click", '[data-action="prev"]', ()=>this.shopTheLook.previous());
            this.delegate.on("click", '[data-action="next"]', ()=>this.shopTheLook.next())
        }
        transitionToIndex(index, shouldAnimate=true) {
            const indexElements = Array.from(this.querySelectorAll(".shop-the-look__counter-page-transition"))
              , currentElement = indexElements.find(item=>!item.hasAttribute("hidden"))
              , nextElement = indexElements[index];
            currentElement.animate({
                transform: ["translateY(0)", "translateY(-100%)"]
            }, {
                duration: shouldAnimate ? 1e3 : 0,
                easing: "cubic-bezier(1, 0, 0, 1)"
            }).onfinish = ()=>currentElement.setAttribute("hidden", "");
            nextElement.removeAttribute("hidden");
            nextElement.animate({
                transform: ["translateY(100%)", "translateY(0)"]
            }, {
                duration: shouldAnimate ? 1e3 : 0,
                easing: "cubic-bezier(1, 0, 0, 1)"
            })
        }
    }
    ;
    window.customElements.define("shop-the-look-nav", ShopTheLookNav);
    var ShopTheLook = class extends CustomHTMLElement {
        connectedCallback() {
            this.lookItems = Array.from(this.querySelectorAll("shop-the-look-item"));
            this.nav = this.querySelector("shop-the-look-nav");
            this.hasPendingTransition = false;
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
            if (this.lookItems.length > 1 && Shopify.designMode) {
                this.addEventListener("shopify:block:select", async event=>{
                    this.intersectionObserver.disconnect();
                    await this.select(event.target.index, !event.detail.load);
                    this.nav.animate({
                        opacity: [0, 1],
                        transform: ["translateY(30px)", "translateY(0)"]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        easing: "ease-in-out"
                    })
                }
                )
            }
        }
        get selectedIndex() {
            return this.lookItems.findIndex(item=>item.selected)
        }
        async _setupVisibility() {
            await this.untilVisible();
            const images = Array.from(this.lookItems[this.selectedIndex].querySelectorAll(".shop-the-look__image"));
            for (let image of images) {
                if (image.offsetParent !== null) {
                    await imageLoaded(image)
                }
            }
            await this.lookItems[this.selectedIndex].transitionToEnter();
            if (this.nav) {
                this.nav.animate({
                    opacity: [0, 1],
                    transform: ["translateY(30px)", "translateY(0)"]
                }, {
                    duration: 150,
                    fill: "forwards",
                    easing: "ease-in-out"
                })
            }
        }
        previous() {
            this.select((this.selectedIndex - 1 + this.lookItems.length) % this.lookItems.length)
        }
        next() {
            this.select((this.selectedIndex + 1 + this.lookItems.length) % this.lookItems.length)
        }
        async select(index, animate=true) {
            const currentLook = this.lookItems[this.selectedIndex]
              , nextLook = this.lookItems[index];
            if (this.hasPendingTransition) {
                return
            }
            this.hasPendingTransition = true;
            if (currentLook !== nextLook) {
                this.nav.transitionToIndex(index, animate);
                currentLook.transitionToLeave()
            }
            nextLook.transitionToEnter(animate);
            this.hasPendingTransition = false
        }
    }
    ;
    window.customElements.define("shop-the-look", ShopTheLook);
    var CollectionList = class extends CustomHTMLElement {
        async connectedCallback() {
            this.items = Array.from(this.querySelectorAll(".list-collections__item"));
            if (this.hasAttribute("scrollable")) {
                this.scroller = this.querySelector(".list-collections__scroller");
                this.addEventListener("prev-next:prev", this.previous.bind(this));
                this.addEventListener("prev-next:next", this.next.bind(this));
                this.addEventListener("shopify:block:select", event=>event.target.scrollIntoView({
                    block: "nearest",
                    inline: "center",
                    behavior: event.detail.load ? "auto" : "smooth"
                }))
            }
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
        }
        async _setupVisibility() {
            await this.untilVisible();
            const prefersReducedMotion = MediaFeatures.prefersReducedMotion();
            const animation = new CustomAnimation(new ParallelEffect(this.items.map((item,index)=>{
                return new SequenceEffect([new CustomKeyframeEffect(item.querySelector(".list-collections__item-image"),{
                    opacity: [0, 1],
                    transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"]
                },{
                    duration: 250,
                    delay: prefersReducedMotion ? 0 : 150 * index,
                    easing: "cubic-bezier(0.65, 0, 0.35, 1)"
                }), new ParallelEffect(Array.from(item.querySelectorAll(".list-collections__item-info [reveal]")).map((textItem,subIndex)=>{
                    return new CustomKeyframeEffect(textItem,{
                        opacity: [0, 1],
                        clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"],
                        transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"]
                    },{
                        duration: 200,
                        delay: prefersReducedMotion ? 0 : 150 * index + 150 * subIndex,
                        easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                    })
                }
                ))])
            }
            )));
            this._hasSectionReloaded ? animation.finish() : animation.play()
        }
        previous() {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
            this.scroller.scrollBy({
                left: -this.items[0].clientWidth * directionFlip,
                behavior: "smooth"
            })
        }
        next() {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
            this.scroller.scrollBy({
                left: this.items[0].clientWidth * directionFlip,
                behavior: "smooth"
            })
        }
    }
    ;
    window.customElements.define("collection-list", CollectionList);
    var ProductList = class extends CustomHTMLElement {
        constructor() {
            super();
            this.productListInner = this.querySelector(".product-list__inner");
            this.productItems = Array.from(this.querySelectorAll("product-item"))
            const toppingProducts = getQueryString('sort_by');
            if (toppingProducts && this.productItems.length) {
                const toppingProductsArray = toppingProducts.split(',');
                let index = 0;
                toppingProductsArray.forEach((item) => {
                    const productItem = this.productItems.find((val) => +val.getAttribute('productitemid') === +item);
                    if (productItem) {
                        this.productListInner.removeChild(productItem);
                        this.productListInner.insertBefore(productItem, this.productListInner.querySelectorAll('product-item')[index]);
                        index++;
                    }
                });
            }
            this.productListInner.style.display = 'grid';
        }
        connectedCallback() {
            this.addEventListener("prev-next:prev", this.previous.bind(this));
            this.addEventListener("prev-next:next", this.next.bind(this));
            if (!this.hidden && this.staggerApparition) {
                this._staggerProductsApparition()
            }
        }
        get staggerApparition() {
            return this.hasAttribute("stagger-apparition")
        }
        get apparitionAnimation() {
            return this._animation = this._animation || new CustomAnimation(new ParallelEffect(this.productItems.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, 1],
                    transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
                },{
                    duration: 600,
                    delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
                    easing: "ease"
                })
            }
            )))
        }
        previous(event) {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1
              , columnGap = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
            event.target.nextElementSibling.removeAttribute("disabled");
            event.target.toggleAttribute("disabled", this.productListInner.scrollLeft * directionFlip - (this.productListInner.clientWidth + columnGap) <= 0);
            this.productListInner.scrollBy({
                left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
                behavior: "smooth"
            })
        }
        next(event) {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1
              , columnGap = parseInt(getComputedStyle(this).getPropertyValue("--product-list-column-gap"));
            event.target.previousElementSibling.removeAttribute("disabled");
            event.target.toggleAttribute("disabled", this.productListInner.scrollLeft * directionFlip + (this.productListInner.clientWidth + columnGap) * 2 >= this.productListInner.scrollWidth);
            this.productListInner.scrollBy({
                left: (this.productListInner.clientWidth + columnGap) * directionFlip,
                behavior: "smooth"
            })
        }
        attributeChangedCallback(name) {
            var _a, _b;
            if (!this.staggerApparition) {
                return
            }
            switch (name) {
            case "hidden":
                if (!this.hidden) {
                    this.productListInner.scrollLeft = 0;
                    this.productListInner.parentElement.scrollLeft = 0;
                    (_a = this.querySelector(".prev-next-button--prev")) == null ? void 0 : _a.setAttribute("disabled", "");
                    (_b = this.querySelector(".prev-next-button--next")) == null ? void 0 : _b.removeAttribute("disabled");
                    this._staggerProductsApparition()
                } else {
                    // this.apparitionAnimation.finish()
                }
            }
        }
        async _staggerProductsApparition() {
            this.productItems.forEach(item=>item.style.opacity = 0);
            await this.untilVisible({
                threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0
            });
            // this.apparitionAnimation.play()
        }
    }
    ;
    __publicField(ProductList, "observedAttributes", ["hidden"]);
    window.customElements.define("product-list", ProductList);
    var LogoList = class extends CustomHTMLElement {
        async connectedCallback() {
            this.items = Array.from(this.querySelectorAll(".logo-list__item"));
            this.logoListScrollable = this.querySelector(".logo-list__list");
            if (this.items.length > 1) {
                this.addEventListener("prev-next:prev", this.previous.bind(this));
                this.addEventListener("prev-next:next", this.next.bind(this))
            }
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
        }
        async _setupVisibility() {
            await this.untilVisible();
            const animation = new CustomAnimation(new ParallelEffect(this.items.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, 1],
                    transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : "30px"})`, "translateY(0)"]
                },{
                    duration: 300,
                    delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index,
                    easing: "ease"
                })
            }
            )));
            this._hasSectionReloaded ? animation.finish() : animation.play()
        }
        previous(event) {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
            event.target.nextElementSibling.removeAttribute("disabled");
            event.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * directionFlip - (this.logoListScrollable.clientWidth + 24) <= 0);
            this.logoListScrollable.scrollBy({
                left: -(this.logoListScrollable.clientWidth + 24) * directionFlip,
                behavior: "smooth"
            })
        }
        next(event) {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1;
            event.target.previousElementSibling.removeAttribute("disabled");
            event.target.toggleAttribute("disabled", this.logoListScrollable.scrollLeft * directionFlip + (this.logoListScrollable.clientWidth + 24) * 2 >= this.logoListScrollable.scrollWidth);
            this.logoListScrollable.scrollBy({
                left: (this.logoListScrollable.clientWidth + 24) * directionFlip,
                behavior: "smooth"
            })
        }
    }
    ;
    window.customElements.define("logo-list", LogoList);
    var BlogPostNavigation = class extends HTMLElement {
        connectedCallback() {
            window.addEventListener("scroll", throttle(this._updateProgressBar.bind(this), 15))
        }
        get hasNextArticle() {
            return this.hasAttribute("has-next-article")
        }
        _updateProgressBar() {
            const stickyHeaderOffset = getStickyHeaderOffset()
              , marginCompensation = window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? 40 : 80
              , articleNavBoundingBox = this.getBoundingClientRect()
              , articleMainPartBoundingBox = this.parentElement.getBoundingClientRect()
              , difference = articleMainPartBoundingBox.bottom - (articleNavBoundingBox.bottom - marginCompensation)
              , progress = Math.max(-1 * (difference / (articleMainPartBoundingBox.height + marginCompensation) - 1), 0);
            this.classList.toggle("is-visible", articleMainPartBoundingBox.top < stickyHeaderOffset && articleMainPartBoundingBox.bottom > stickyHeaderOffset + this.clientHeight - marginCompensation);
            if (this.hasNextArticle) {
                if (progress > .8) {
                    this.classList.add("article__nav--show-next")
                } else {
                    this.classList.remove("article__nav--show-next")
                }
            }
            this.style.setProperty("--transform", `${progress}`)
        }
    }
    ;
    window.customElements.define("blog-post-navigation", BlogPostNavigation);
    var MultiColumn = class extends CustomHTMLElement {
        connectedCallback() {
            if (!this.hasAttribute("stack")) {
                this.multiColumnInner = this.querySelector(".multi-column__inner");
                this.addEventListener("prev-next:prev", this.previous.bind(this));
                this.addEventListener("prev-next:next", this.next.bind(this));
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:select", event=>{
                        event.target.scrollIntoView({
                            inline: "center",
                            block: "nearest",
                            behavior: event.detail.load ? "auto" : "smooth"
                        })
                    }
                    )
                }
            }
            if (this.hasAttribute("stagger-apparition")) {
                this._setupVisibility()
            }
        }
        async _setupVisibility() {
            await this.untilVisible({
                threshold: Math.min(50 / this.clientHeight, 1)
            });
            const prefersReducedMotion = MediaFeatures.prefersReducedMotion();
            const animation = new CustomAnimation(new ParallelEffect(Array.from(this.querySelectorAll(".multi-column__item")).map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, 1],
                    transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
                },{
                    duration: 600,
                    delay: prefersReducedMotion ? 0 : 100 * index,
                    easing: "ease"
                })
            }
            )));
            this._hasSectionReloaded ? animation.finish() : animation.play()
        }
        previous(event) {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1
              , columnGap = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
            event.target.nextElementSibling.removeAttribute("disabled");
            event.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * directionFlip - (this.multiColumnInner.clientWidth + columnGap) <= 0);
            this.multiColumnInner.scrollBy({
                left: -(this.multiColumnInner.clientWidth + columnGap) * directionFlip,
                behavior: "smooth"
            })
        }
        next(event) {
            const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1
              , columnGap = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
            event.target.previousElementSibling.removeAttribute("disabled");
            event.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * directionFlip + (this.multiColumnInner.clientWidth + columnGap) * 2 >= this.multiColumnInner.scrollWidth);
            this.multiColumnInner.scrollBy({
                left: (this.multiColumnInner.clientWidth + columnGap) * directionFlip,
                behavior: "smooth"
            })
        }
    }
    ;
    window.customElements.define("multi-column", MultiColumn);
    var GalleryList = class extends HTMLElement {
        connectedCallback() {
            this.listItems = Array.from(this.querySelectorAll("gallery-item"));
            this.scrollBarElement = this.querySelector(".gallery__progress-bar");
            this.listWrapperElement = this.querySelector(".gallery__list-wrapper");
            if (this.listItems.length > 1) {
                this.addEventListener("scrollable-content:progress", this._updateProgressBar.bind(this));
                this.addEventListener("prev-next:prev", this.previous.bind(this));
                this.addEventListener("prev-next:next", this.next.bind(this));
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:select", event=>this.select(event.target.index, !event.detail.load))
                }
            }
        }
        previous() {
            this.select([...this.listItems].reverse().find(item=>item.isOnLeftHalfPartOfScreen).index)
        }
        next() {
            this.select(this.listItems.findIndex(item=>item.isOnRightHalfPartOfScreen))
        }
        select(index, animate=true) {
            const boundingRect = this.listItems[index].getBoundingClientRect();
            this.listWrapperElement.scrollBy({
                behavior: animate ? "smooth" : "auto",
                left: Math.floor(boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2)
            })
        }
        _updateProgressBar(event) {
            var _a;
            (_a = this.scrollBarElement) == null ? void 0 : _a.style.setProperty("--transform", `${event.detail.progress}%`)
        }
    }
    ;
    window.customElements.define("gallery-list", GalleryList);
    var GalleryItem = class extends HTMLElement {
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get isOnRightHalfPartOfScreen() {
            if (window.themeVariables.settings.direction === "ltr") {
                return this.getBoundingClientRect().left > window.innerWidth / 2
            } else {
                return this.getBoundingClientRect().right < window.innerWidth / 2
            }
        }
        get isOnLeftHalfPartOfScreen() {
            if (window.themeVariables.settings.direction === "ltr") {
                return this.getBoundingClientRect().right < window.innerWidth / 2
            } else {
                return this.getBoundingClientRect().left > window.innerWidth / 2
            }
        }
    }
    ;
    window.customElements.define("gallery-item", GalleryItem);
    var ImageWithTextOverlay = class extends CustomHTMLElement {
        connectedCallback() {
            if (this.hasAttribute("parallax") && !MediaFeatures.prefersReducedMotion()) {
                this._hasPendingRaF = false;
                this._onScrollListener = this._onScroll.bind(this);
                window.addEventListener("scroll", this._onScrollListener)
            }
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            if (this._onScrollListener) {
                window.removeEventListener("scroll", this._onScrollListener)
            }
        }
        async _setupVisibility() {
            await this.untilVisible();
            const image = this.querySelector(".image-overlay__image")
              , headings = await resolveAsyncIterator(this.querySelectorAll("split-lines"))
              , prefersReducedMotion = MediaFeatures.prefersReducedMotion();
            await imageLoaded(image);
            const innerEffect = [new CustomKeyframeEffect(image,{
                opacity: [0, 1],
                transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"]
            },{
                duration: 500,
                easing: "cubic-bezier(0.65, 0, 0.35, 1)"
            }), new ParallelEffect(headings.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, .2, 1],
                    transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"],
                    clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
                },{
                    duration: 300,
                    delay: prefersReducedMotion ? 0 : 120 * index,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                })
            }
            )), new CustomKeyframeEffect(this.querySelector(".image-overlay__text-container"),{
                opacity: [0, 1]
            },{
                duration: 300
            })];
            const animation = prefersReducedMotion ? new CustomAnimation(new ParallelEffect(innerEffect)) : new CustomAnimation(new SequenceEffect(innerEffect));
            this._hasSectionReloaded ? animation.finish() : animation.play()
        }
        _onScroll() {
            if (this._hasPendingRaF) {
                return
            }
            this._hasPendingRaF = true;
            requestAnimationFrame(()=>{
                const boundingRect = this.getBoundingClientRect()
                  , speedFactor = 3
                  , contentElement = this.querySelector(".image-overlay__content-wrapper")
                  , imageElement = this.querySelector(".image-overlay__image")
                  , boundingRectBottom = boundingRect.bottom
                  , boundingRectHeight = boundingRect.height
                  , stickyHeaderOffset = getStickyHeaderOffset();
                if (contentElement) {
                    contentElement.style.opacity = Math.max(1 - speedFactor * (1 - Math.min(boundingRectBottom / boundingRectHeight, 1)), 0).toString()
                }
                if (imageElement) {
                    imageElement.style.transform = `translateY(${100 - Math.max(1 - (1 - Math.min(boundingRectBottom / (boundingRectHeight + stickyHeaderOffset), 1)), 0) * 100}px)`
                }
                this._hasPendingRaF = false
            }
            )
        }
    }
    ;
    window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);
    var ImageWithTextBlock = class extends CustomHTMLElement {
        async connectedCallback() {
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
        }
        async _setupVisibility() {
            await this.untilVisible();
            const images = Array.from(this.querySelectorAll(".image-with-text-block__image[reveal]"))
              , headings = await resolveAsyncIterator(this.querySelectorAll("split-lines"))
              , prefersReducedMotion = MediaFeatures.prefersReducedMotion();
            for (const image of images) {
                if (image.offsetParent !== null) {
                    await imageLoaded(image)
                }
            }
            const innerEffect = [new ParallelEffect(images.map(item=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, 1],
                    transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"]
                },{
                    duration: 500,
                    easing: "cubic-bezier(0.65, 0, 0.35, 1)"
                })
            }
            )), new CustomKeyframeEffect(this.querySelector(".image-with-text-block__content"),{
                opacity: [0, 1],
                transform: [`translateY(${prefersReducedMotion ? 0 : "60px"})`, "translateY(0)"]
            },{
                duration: 150,
                easing: "ease-in-out"
            }), new ParallelEffect(headings.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    opacity: [0, .2, 1],
                    transform: [`translateY(${prefersReducedMotion ? 0 : "100%"})`, "translateY(0)"],
                    clipPath: [`inset(${prefersReducedMotion ? "0 0 0 0" : "0 0 100% 0"})`, "inset(0 0 0 0)"]
                },{
                    duration: 300,
                    delay: prefersReducedMotion ? 0 : 120 * index,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                })
            }
            )), new CustomKeyframeEffect(this.querySelector(".image-with-text-block__text-container"),{
                opacity: [0, 1]
            },{
                duration: 300
            })];
            const animation = prefersReducedMotion ? new CustomAnimation(new ParallelEffect(innerEffect)) : new CustomAnimation(new SequenceEffect(innerEffect));
            this._hasSectionReloaded ? animation.finish() : animation.play()
        }
    }
    ;
    window.customElements.define("image-with-text-block", ImageWithTextBlock);
    var ArticleList = class extends CustomHTMLElement {
        async connectedCallback() {
            this.articleItems = Array.from(this.querySelectorAll(".article-item"));
            if (this.staggerApparition) {
                await this.untilVisible({
                    threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0
                });
                const animation = new CustomAnimation(new ParallelEffect(this.articleItems.map((item,index)=>{
                    return new CustomKeyframeEffect(item,{
                        opacity: [0, 1],
                        transform: [`translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
                    },{
                        duration: 600,
                        delay: MediaFeatures.prefersReducedMotion() ? 0 : 100 * index - Math.min(3 * index * index, 100 * index),
                        easing: "ease"
                    })
                }
                )));
                this._hasSectionReloaded ? animation.finish() : animation.play()
            }
        }
        get staggerApparition() {
            return this.hasAttribute("stagger-apparition")
        }
    }
    ;
    window.customElements.define("article-list", ArticleList);
    var BlogPostHeader = class extends HTMLElement {
        async connectedCallback() {
            const image = this.querySelector(".article__image");
            if (MediaFeatures.prefersReducedMotion()) {
                image.removeAttribute("reveal")
            } else {
                await imageLoaded(image);
                image.animate({
                    opacity: [0, 1],
                    transform: ["scale(1.1)", "scale(1)"]
                }, {
                    duration: 500,
                    fill: "forwards",
                    easing: "cubic-bezier(0.65, 0, 0.35, 1)"
                })
            }
        }
    }
    ;
    window.customElements.define("blog-post-header", BlogPostHeader);
    var PredictiveSearchInput = class extends HTMLInputElement {
        connectedCallback() {
            this.addEventListener("click", ()=>document.getElementById(this.getAttribute("aria-controls")).open = true)
        }
    }
    ;
    window.customElements.define("predictive-search-input", PredictiveSearchInput, {
        extends: "input"
    });
    var DrawerContent = class extends OpenableElement {
        connectedCallback() {
            super.connectedCallback();
            if (!this.open) {
                this.setAttribute("aria-hidden", "true");
            }
            if (this.hasAttribute("reverse-breakpoint")) {
                this.originalDirection = this.classList.contains("drawer--from-left") ? "left" : "right";
                const matchMedia2 = window.matchMedia(this.getAttribute("reverse-breakpoint"));
                matchMedia2.addListener(this._checkReverseOpeningDirection.bind(this));
                this._checkReverseOpeningDirection(matchMedia2)
            }
            this.delegate.on("click", ".drawer__overlay", ()=>this.open = false)
            if (this.id.includes('size-chart-drawer') && (document.documentElement.clientWidth || document.body.clientWidth) > 767 && this.parentNode.className.includes('product__info')) {
                this.closest('.container').append(this.cloneNode(true));
                this.parentNode.removeChild(this);
            }
        }
        attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            switch (name) {
            case "open":
                document.documentElement.classList.toggle("lock-all", this.open);
                if (this.open) {
                    this.removeAttribute("aria-hidden");
                } else {
                    this.setAttribute("aria-hidden", "true");
                }
                break;
            }
        }
        _checkReverseOpeningDirection(match) {
            this.classList.remove("drawer--from-left");
            if (this.originalDirection === "left" && !match.matches || this.originalDirection !== "left" && match.matches) {
                this.classList.add("drawer--from-left")
            }
        }
    }
    ;
    window.customElements.define("drawer-content", DrawerContent);
    var PredictiveSearchDrawer = class extends DrawerContent {
        connectedCallback() {
            super.connectedCallback();
            this.inputElement = this.querySelector('[name="q"]');
            this.drawerContentElement = this.querySelector(".drawer__content");
            this.drawerFooterElement = this.querySelector(".drawer__footer");
            this.loadingStateElement = this.querySelector(".predictive-search__loading-state");
            this.resultsElement = this.querySelector(".predictive-search__results");
            this.menuListElement = this.querySelector(".predictive-search__menu-list");
            this.delegate.on("input", '[name="q"]', this._debounce(this._onSearch.bind(this), 200));
            this.delegate.on("click", '[data-action="reset-search"]', this._startNewSearch.bind(this))
        }
        async _onSearch(event, target) {
            if (event.key === "Enter") {
                return
            }
            if (this.abortController) {
                this.abortController.abort()
            }
            this.drawerContentElement.classList.remove("drawer__content--center");
            this.drawerFooterElement.hidden = true;
            if (target.value === "") {
                this.loadingStateElement.hidden = true;
                this.resultsElement.hidden = true;
                this.menuListElement ? this.menuListElement.hidden = false : ""
            } else {
                this.drawerContentElement.classList.add("drawer__content--center");
                this.loadingStateElement.hidden = false;
                this.resultsElement.hidden = true;
                this.menuListElement ? this.menuListElement.hidden = true : "";
                let searchResults = {};
                try {
                    this.abortController = new AbortController;
                    if (this._supportPredictiveApi()) {
                        searchResults = await this._doPredictiveSearch(target.value)
                    } else {
                        searchResults = await this._doLiquidSearch(target.value)
                    }
                } catch (e) {
                    if (e.name === "AbortError") {
                        return
                    }
                }
                this.loadingStateElement.hidden = true;
                this.resultsElement.hidden = false;
                this.menuListElement ? this.menuListElement.hidden = true : "";
                if (searchResults.hasResults) {
                    this.drawerFooterElement.hidden = false;
                    this.drawerContentElement.classList.remove("drawer__content--center")
                }
                this.resultsElement.innerHTML = searchResults.html
            }
        }
        async _doPredictiveSearch(term) {
            const response = await fetch(`${window.themeVariables.routes.predictiveSearchUrl}?q=${term}&resources[limit]=10&resources[type]=${window.themeVariables.settings.searchMode}&resources[options[unavailable_products]]=${window.themeVariables.settings.searchUnavailableProducts}&resources[options[fields]]=title,body,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`, {
                signal: this.abortController.signal
            });
            const div = document.createElement("div");
            div.innerHTML = await response.text();
            return {
                hasResults: div.querySelector(".predictive-search__results-categories") !== null,
                html: div.firstElementChild.innerHTML
            }
        }
        async _doLiquidSearch(term) {
            let promises = []
              , supportedTypes = window.themeVariables.settings.searchMode.split(",").filter(item=>item !== "collection");
            supportedTypes.forEach(searchType=>{
                promises.push(fetch(`${window.themeVariables.routes.searchUrl}?section_id=predictive-search-compatibility&q=${term}&type=${searchType}&options[unavailable_products]=${window.themeVariables.settings.searchUnavailableProducts}&options[prefix]=last`, {
                    signal: this.abortController.signal
                }))
            }
            );
            let results = await Promise.all(promises)
              , resultsByCategories = {};
            for (const [index,value] of results.entries()) {
                const resultAsText = await value.text();
                const fakeDiv = document.createElement("div");
                fakeDiv.innerHTML = resultAsText;
                fakeDiv.innerHTML = fakeDiv.firstElementChild.innerHTML;
                if (fakeDiv.childElementCount > 0) {
                    resultsByCategories[supportedTypes[index]] = fakeDiv.innerHTML
                }
            }
            if (Object.keys(resultsByCategories).length > 0) {
                const entries = Object.entries(resultsByCategories)
                  , keys = Object.keys(resultsByCategories);
                let html = `
        <tabs-nav class="tabs-nav tabs-nav--edge2edge tabs-nav--narrow tabs-nav--no-border">
          <scrollable-content class="tabs-nav__scroller hide-scrollbar">
            <div class="tabs-nav__scroller-inner">
              <div class="tabs-nav__item-list">
      `;
                for (let[type,value] of entries) {
                    html += `
          <button type="button" class="tabs-nav__item heading heading--small" aria-expanded="${type === keys[0] ? "true" : "false"}" aria-controls="predictive-search-${type}">
            ${window.themeVariables.strings["search" + type.charAt(0).toUpperCase() + type.slice(1) + "s"]}
          </button>
        `
                }
                html += `
              </div>
            </div>
          </scrollable-content>
        </tabs-nav>
      `;
                html += '<div class="predictive-search__results-categories">';
                for (let[type,value] of entries) {
                    html += `
          <div class="predictive-search__results-categories-item" ${type !== keys[0] ? "hidden" : ""} id="predictive-search-${type}">
            ${value}
          </div>
        `
                }
                html += "</div>";
                return {
                    hasResults: true,
                    html: html
                }
            } else {
                return {
                    hasResults: false,
                    html: `
        <p class="text--large">${window.themeVariables.strings.searchNoResults}</p>
          <div class="button-wrapper">
            <button type="button" data-action="reset-search" class="button button--primary">${window.themeVariables.strings.searchNewSearch}</button>
          </div>
        `
                }
            }
        }
        _startNewSearch() {
            this.inputElement.value = "";
            this.inputElement.focus();
            const event = new Event("input",{
                bubbles: true,
                cancelable: true
            });
            this.inputElement.dispatchEvent(event)
        }
        _supportPredictiveApi() {
            const shopifyFeatureRequests = JSON.parse(document.getElementById("shopify-features").innerHTML);
            return shopifyFeatureRequests["predictiveSearch"]
        }
        _debounce(fn, delay3) {
            let timer = null;
            return (...args)=>{
                clearTimeout(timer);
                timer = setTimeout(()=>{
                    fn.apply(this, args)
                }
                , delay3)
            }
        }
    }
    ;
    window.customElements.define("predictive-search-drawer", PredictiveSearchDrawer);
    var Timeline = class extends HTMLElement {
        connectedCallback() {
            this.prevNextButtons = this.querySelector("prev-next-buttons");
            this.pageDots = this.querySelector("page-dots");
            this.scrollBarElement = this.querySelector(".timeline__progress-bar");
            this.listWrapperElement = this.querySelector(".timeline__list-wrapper");
            this.listItemElements = Array.from(this.querySelectorAll(".timeline__item"));
            this.isScrolling = false;
            if (this.listItemElements.length > 1) {
                this.addEventListener("prev-next:prev", this.previous.bind(this));
                this.addEventListener("prev-next:next", this.next.bind(this));
                this.addEventListener("page-dots:changed", event=>this.select(event.detail.index));
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:select", event=>{
                        this.select([...event.target.parentNode.children].indexOf(event.target), !event.detail.load)
                    }
                    )
                }
                this.itemIntersectionObserver = new IntersectionObserver(this._onItemObserved.bind(this),{
                    threshold: .4
                });
                const mediaQuery = window.matchMedia(window.themeVariables.breakpoints.pocket);
                mediaQuery.addListener(this._onMediaChanged.bind(this));
                this._onMediaChanged(mediaQuery)
            }
        }
        get selectedIndex() {
            return this.listItemElements.findIndex(item=>!item.hasAttribute("hidden"))
        }
        previous() {
            this.select(Math.max(0, this.selectedIndex - 1))
        }
        next() {
            this.select(Math.min(this.selectedIndex + 1, this.listItemElements.length - 1))
        }
        select(index, animate=true) {
            const listItemElement = this.listItemElements[index]
              , boundingRect = listItemElement.getBoundingClientRect();
            if (animate) {
                this.isScrolling = true;
                setTimeout(()=>this.isScrolling = false, 800)
            }
            if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                this.listWrapperElement.scrollTo({
                    behavior: animate ? "smooth" : "auto",
                    left: this.listItemElements[0].clientWidth * index
                })
            } else {
                this.listWrapperElement.scrollBy({
                    behavior: animate ? "smooth" : "auto",
                    left: Math.floor(boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2)
                })
            }
            this._onItemSelected(index)
        }
        _onItemSelected(index) {
            var _a;
            const listItemElement = this.listItemElements[index];
            listItemElement.removeAttribute("hidden", "false");
            getSiblings(listItemElement).forEach(item=>item.setAttribute("hidden", ""));
            this.prevNextButtons.isPrevDisabled = index === 0;
            this.prevNextButtons.isNextDisabled = index === this.listItemElements.length - 1;
            this.pageDots.selectedIndex = index;
            (_a = this.scrollBarElement) == null ? void 0 : _a.style.setProperty("--transform", `${100 / (this.listItemElements.length - 1) * index}%`)
        }
        _onItemObserved(entries) {
            if (this.isScrolling) {
                return
            }
            entries.forEach(entry=>{
                if (entry.isIntersecting) {
                    this._onItemSelected([...entry.target.parentNode.children].indexOf(entry.target))
                }
            }
            )
        }
        _onMediaChanged(event) {
            if (event.matches) {
                this.listItemElements.forEach(item=>this.itemIntersectionObserver.observe(item))
            } else {
                this.listItemElements.forEach(item=>this.itemIntersectionObserver.unobserve(item))
            }
        }
    }
    ;
    window.customElements.define("time-line", Timeline);
    var PressList = class extends CustomHTMLElement {
        connectedCallback() {
            this.pressItemsWrapper = this.querySelector(".press-list__wrapper");
            this.pressItems = Array.from(this.querySelectorAll("press-item"));
            this.pageDots = this.querySelector("page-dots");
            if (this.pressItems.length > 1) {
                if (Shopify.designMode) {
                    this.addEventListener("shopify:block:select", event=>{
                        var _a;
                        (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
                        if (event.detail.load || !event.target.selected) {
                            this.select(event.target.index, !event.detail.load)
                        }
                    }
                    )
                }
                this.pressItemsWrapper.addEventListener("swiperight", this.previous.bind(this));
                this.pressItemsWrapper.addEventListener("swipeleft", this.next.bind(this));
                this.addEventListener("page-dots:changed", event=>this.select(event.detail.index));
                this._blockVerticalScroll()
            }
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
        }
        async _setupVisibility() {
            await this.untilVisible();
            this.pressItems[this.selectedIndex].transitionToEnter()
        }
        get selectedIndex() {
            return this.pressItems.findIndex(item=>item.selected)
        }
        previous() {
            this.select((this.selectedIndex - 1 + this.pressItems.length) % this.pressItems.length)
        }
        next() {
            this.select((this.selectedIndex + 1 + this.pressItems.length) % this.pressItems.length)
        }
        async select(index, shouldAnimate=true) {
            const previousItem = this.pressItems[this.selectedIndex]
              , newItem = this.pressItems[index];
            await previousItem.transitionToLeave(shouldAnimate);
            this.pageDots.selectedIndex = index;
            await newItem.transitionToEnter(shouldAnimate)
        }
    }
    ;
    Object.assign(PressList.prototype, VerticalScrollBlockerMixin);
    window.customElements.define("press-list", PressList);
    var PressItem = class extends HTMLElement {
        connectedCallback() {
            this.addEventListener("split-lines:re-split", event=>{
                Array.from(event.target.children).forEach(line=>line.style.visibility = this.selected ? "visible" : "hidden")
            }
            )
        }
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        async transitionToLeave(shouldAnimate=true) {
            const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines"))
              , animation = new CustomAnimation(new ParallelEffect(textLines.reverse().map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    visibility: ["visible", "hidden"],
                    clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                    // transform: ["translateY(0)", "translateY(100%)"]
                },{
                    // duration: 350,
                    // delay: 60 * index,
                    easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)"
                })
            }
            )));
            shouldAnimate ? animation.play() : animation.finish();
            await animation.finished;
            this.setAttribute("hidden", "")
        }
        async transitionToEnter(shouldAnimate=true) {
            this.removeAttribute("hidden");
            const textLines = await resolveAsyncIterator(this.querySelectorAll("split-lines, .testimonial__author"))
              , animation = new CustomAnimation(new ParallelEffect(textLines.map((item,index)=>{
                return new CustomKeyframeEffect(item,{
                    visibility: ["hidden", "visible"],
                    clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
                    // transform: ["translateY(100%)", "translateY(0)"]
                },{
                    // duration: 550,
                    // delay: 120 * index,
                    easing: "cubic-bezier(0.23, 1, 0.32, 1)"
                })
            }
            )));
            shouldAnimate ? animation.play() : animation.finish();
            return animation.finished
        }
    }
    ;
    window.customElements.define("press-item", PressItem);
    var DesktopNavigation = class extends CustomHTMLElement {
        connectedCallback() {
            this.openingTimeout = null;
            this.currentMegaMenu = null;
            this.delegate.on("mouseenter", ".has-dropdown", (event,target)=>{
                if (event.target === target && event.relatedTarget !== null) {
                    this.openDropdown(target)
                }
            }
            , true);
            this.delegate.on("keydown", "desktop-navigation", (event)=>{
                const tg = event.target;
                if (event.key === 'ArrowDown' && tg.parentElement.classList.contains('has-dropdown')) {
                    event.preventDefault();
                    this.openDropdown(tg.parentElement);
                }
                if (event.key === 'Escape' && tg.closest('.header__linklist-item').classList.contains('has-dropdown')) {
                    this.closeDropdown(tg.closest('.header__linklist-item'));
                    tg.closest('.header__linklist-item').querySelector('a').focus();
                }
                if (event.key === 'Tab' 
                    && tg.closest('.header__linklist-item').classList.contains('has-dropdown')
                    && tg.closest('.mega-menu')
                    && !tg.closest('.mega-menu').getAttribute('hidden')
                    && tg.closest('.mega-menu').querySelectorAll('a')[tg.closest('.mega-menu').querySelectorAll('a').length - 1] === tg) {
                    this.closeDropdown(tg.closest('.header__linklist-item'));
                }
            })
            this.delegate.on("click", ".header__linklist-link[aria-expanded], .nav-dropdown__link[aria-expanded]", (event,target)=>{
                if (window.matchMedia("(hover: hover)").matches || target.getAttribute("aria-expanded") === "true") {
                    return
                }
                event.preventDefault();
                this.openDropdown(target.parentElement)
            }
            );
            this.delegate.on("shopify:block:select", event=>this.openDropdown(event.target.parentElement));
            this.delegate.on("shopify:block:deselect", event=>this.closeDropdown(event.target.parentElement))
        }
        openDropdown(parentElement) {
            const menuItem = parentElement.querySelector("[aria-controls]")
              , dropdown = parentElement.querySelector(`#${menuItem.getAttribute("aria-controls")}`);
            this.currentMegaMenu = dropdown.classList.contains("mega-menu") ? dropdown : null;
            let openingTimeout = setTimeout(()=>{
                if (menuItem.getAttribute("aria-expanded") === "true") {
                    return
                }
                menuItem.setAttribute("aria-expanded", "true");
                dropdown.removeAttribute("hidden");
                if (dropdown.classList.contains("mega-menu") && !MediaFeatures.prefersReducedMotion()) {
                    const items = Array.from(dropdown.querySelectorAll(".mega-menu__column, .mega-menu__image-push"));
                    items.forEach(item=>{
                        item.getAnimations().forEach(animation2=>animation2.cancel());
                        item.style.opacity = 0
                    }
                    );
                    const animation = new CustomAnimation(new ParallelEffect(items.map((item,index)=>{
                        return new CustomKeyframeEffect(item,{
                            opacity: [0, 1]
                        },{
                            easing: "cubic-bezier(0.65, 0, 0.35, 1)"
                        })
                    }
                    )));
                    animation.play()
                }
                const leaveListener = event=>{
                    if (event.relatedTarget !== null) {
                        this.closeDropdown(parentElement);
                        parentElement.removeEventListener("mouseleave", leaveListener)
                    }
                }
                ;
                parentElement.addEventListener("mouseleave", leaveListener);
                openingTimeout = null;
                this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:open",{
                    bubbles: true
                }))
            }
            , 100);
            parentElement.addEventListener("mouseleave", ()=>{
                if (openingTimeout) {
                    clearTimeout(openingTimeout)
                }
            }
            , {
                once: true
            })
        }
        closeDropdown(parentElement) {
            const menuItem = parentElement.querySelector("[aria-controls]")
              , dropdown = parentElement.querySelector(`#${menuItem.getAttribute("aria-controls")}`);
            requestAnimationFrame(()=>{
                dropdown.classList.add("is-closing");
                menuItem.setAttribute("aria-expanded", "false");
                setTimeout(()=>{
                    dropdown.setAttribute("hidden", "");
                    clearTimeout(this.openingTimeout);
                    dropdown.classList.remove("is-closing")
                }
                , dropdown.classList.contains("mega-menu") && this.currentMegaMenu !== dropdown ? 250 : 0);
                this.dispatchEvent(new CustomEvent("desktop-nav:dropdown:close",{
                    bubbles: true
                }))
            }
            )
        }
    }
    ;
    window.customElements.define("desktop-navigation", DesktopNavigation);
    var MobileNavigation = class extends DrawerContent {
        get apparitionAnimation() {
            if (this._apparitionAnimation) {
                return this._apparitionAnimation
            }
            if (!MediaFeatures.prefersReducedMotion()) {
                const navItems = Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"]'))
                  , effects = [];
                effects.push(new ParallelEffect(navItems.map((item,index)=>{
                    return new CustomKeyframeEffect(item,{
                        opacity: [0, 1],
                        transform: ["translateX(-40px)", "translateX(0)"]
                    },{
                        duration: 300,
                        delay: 300 + 120 * index - Math.min(2 * index * index, 120 * index),
                        easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                    })
                }
                )));
                const bottomBar = this.querySelector(".drawer__footer");
                if (bottomBar) {
                    effects.push(new CustomKeyframeEffect(bottomBar,{
                        opacity: [0, 1],
                        transform: ["translateY(100%)", "translateY(0)"]
                    },{
                        duration: 300,
                        delay: 500 + Math.max(125 * navItems.length - 25 * navItems.length, 25),
                        easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                    }))
                }
                return this._apparitionAnimation = new CustomAnimation(new ParallelEffect(effects))
            }
        }
        attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            switch (name) {
            case "open":
                if (this.open && this.apparitionAnimation) {
                    // Array.from(this.querySelectorAll('.mobile-nav__item[data-level="1"], .drawer__footer')).forEach(item=>item.style.opacity = 0);
                    // this.apparitionAnimation.play()
                }
                triggerEvent(this, this.open ? "mobile-nav:open" : "mobile-nav:close")
            }
        }
    }
    ;
    window.customElements.define("mobile-navigation", MobileNavigation);
    var StoreHeader = class extends CustomHTMLElement {
        connectedCallback() {
            if (window.ResizeObserver) {
                this.resizeObserver = new ResizeObserver(this._updateCustomProperties.bind(this));
                this.resizeObserver.observe(this);
                this.resizeObserver.observe(this.querySelector(".header__wrapper"))
            }
            if (this.isTransparent) {
                this.isTransparencyDetectionLocked = false;
                this.delegate.on("desktop-nav:dropdown:open", ()=>this.lockTransparency = true);
                this.delegate.on("desktop-nav:dropdown:close", ()=>this.lockTransparency = false);
                this.rootDelegate.on("mobile-nav:open", ()=>this.lockTransparency = true);
                this.rootDelegate.on("mobile-nav:close", ()=>this.lockTransparency = false);
                this.delegate.on("mouseenter", this._checkTransparentHeader.bind(this), true);
                this.delegate.on("mouseleave", this._checkTransparentHeader.bind(this));
                if (this.isSticky) {
                    this._checkTransparentHeader();
                    this._onWindowScrollListener = throttle(this._checkTransparentHeader.bind(this), 100);
                    window.addEventListener("scroll", this._onWindowScrollListener)
                }
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            if (window.ResizeObserver) {
                this.resizeObserver.disconnect()
            }
            if (this.isTransparent && this.isSticky) {
                window.removeEventListener("scroll", this._onWindowScrollListener)
            }
        }
        get isSticky() {
            return this.hasAttribute("sticky")
        }
        get isTransparent() {
            return this.hasAttribute("transparent")
        }
        get transparentHeaderThreshold() {
            return 25
        }
        set lockTransparency(value) {
            this.isTransparencyDetectionLocked = value;
            this._checkTransparentHeader()
        }
        _updateCustomProperties(entries) {
            entries.forEach(entry=>{
                if (entry.target === this) {
                    const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
                    document.documentElement.style.setProperty("--header-height", `${height}px`)
                }
                if (entry.target.classList.contains("header__wrapper")) {
                    const heightWithoutNav = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
                    document.documentElement.style.setProperty("--header-height-without-bottom-nav", `${heightWithoutNav}px`)
                }
            }
            )
        }
        _checkTransparentHeader(event) {
            var iconBlue = document.getElementsByClassName('iconBlue');
            var iconWhite = document.getElementsByClassName('iconWhite');
            if (this.isTransparencyDetectionLocked || window.scrollY > this.transparentHeaderThreshold || event && event.type === "mouseenter") {
                for (var i = 0; i < iconBlue.length; i++) {
                    iconBlue[i].style.display = 'inline-block';
                }
                for (var i = 0; i < iconWhite.length; i++) {
                    iconWhite[i].style.display = 'none';
                }

                this.classList.remove("header--transparent")
            } else {
                for (var i = 0; i < iconBlue.length; i++) {
                    iconBlue[i].style.display = 'none';
                }
                for (var i = 0; i < iconWhite.length; i++) {
                    iconWhite[i].style.display = 'inline-block';
                }
                this.classList.add("header--transparent")
            }
        }
    }
    ;
    window.customElements.define("store-header", StoreHeader);
    
    // js/custom-element/section/product/gift-card-recipient.js
    var GiftCardRecipient = class extends HTMLElement {
    connectedCallback() {
        const properties = Array.from(this.querySelectorAll('[name*="properties"]')), checkboxPropertyName = "properties[__shopify_send_gift_card_to_recipient]";
        this.recipientCheckbox = properties.find((input) => input.name === checkboxPropertyName);
        this.recipientOtherProperties = properties.filter((input) => input.name !== checkboxPropertyName);
        this.recipientFieldsContainer = this.querySelector(".gift-card-recipient__fields");
        this.recipientCheckbox?.addEventListener("change", this._synchronizeProperties.bind(this));
        this.offsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');
        if (this.offsetProperty) {
        this.offsetProperty.value = (/* @__PURE__ */ new Date()).getTimezoneOffset().toString();
        }
        this.recipientSendOnProperty = this.querySelector('[name="properties[Send on]"]');
        const minDate = /* @__PURE__ */ new Date();
        const maxDate = /* @__PURE__ */ new Date();
        maxDate.setDate(minDate.getDate() + 90);
        this.recipientSendOnProperty?.setAttribute("min", this._formatDate(minDate));
        this.recipientSendOnProperty?.setAttribute("max", this._formatDate(maxDate));
        this._synchronizeProperties();
    }
    _synchronizeProperties() {
        this.recipientOtherProperties.forEach((property) => property.disabled = !this.recipientCheckbox.checked);
        this.recipientFieldsContainer.classList.toggle("js:hidden", !this.recipientCheckbox.checked);
    }
    _formatDate(date) {
        const offset = date.getTimezoneOffset();
        const offsetDate = new Date(date.getTime() - offset * 60 * 1e3);
        return offsetDate.toISOString().split("T")[0];
    }
    };
    if (!window.customElements.get("gift-card-recipient")) {
    window.customElements.define("gift-card-recipient", GiftCardRecipient);
    }
    var PhotoSwipeUi = class {
        constructor(pswp) {
            this.photoSwipeInstance = pswp;
            this.delegate = new main_default(this.photoSwipeInstance.scrollWrap);
            this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
            this.pswpUi = this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui");
            this.delegate.on("click", '[data-action="pswp-close"]', this._close.bind(this));
            this.delegate.on("click", '[data-action="pswp-prev"]', this._goToPrev.bind(this));
            this.delegate.on("click", '[data-action="pswp-next"]', this._goToNext.bind(this));
            this.delegate.on("click", '[data-action="pswp-move-to"]', this._moveTo.bind(this));
            this.photoSwipeInstance.listen("close", this._onPswpClosed.bind(this));
            this.photoSwipeInstance.listen("doubleTap", this._onPswpDoubleTap.bind(this));
            this.photoSwipeInstance.listen("beforeChange", this._onPswpBeforeChange.bind(this));
            this.photoSwipeInstance.listen("initialZoomInEnd", this._onPswpInitialZoomInEnd.bind(this));
            this.photoSwipeInstance.listen("initialZoomOut", this._onPswpInitialZoomOut.bind(this));
            this.photoSwipeInstance.listen("parseVerticalMargin", this._onPswpParseVerticalMargin.bind(this));
            this.delegate.on("pswpTap", ".pswp__img", this._onPswpTap.bind(this))
        }
        init() {
            const prevNextButtons = this.pswpUi.querySelector(".pswp__prev-next-buttons")
              , dotsNavWrapper = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
            if (this.photoSwipeInstance.items.length <= 1) {
                prevNextButtons.style.display = "none";
                dotsNavWrapper.style.display = "none";
                return
            }
            prevNextButtons.style.display = "";
            dotsNavWrapper.style.display = "";
            let dotsNavHtml = "";
            this.photoSwipeInstance.items.forEach((item,index)=>{
                dotsNavHtml += `
        <button class="dots-nav__item tap-area" ${index === 0 ? 'aria-current="true"' : ""} data-action="pswp-move-to">
          <span class="visually-hidden">Go to slide ${index}</span>
        </button>
      `
            }
            );
            dotsNavWrapper.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML = dotsNavHtml
        }
        _close() {
            this.photoSwipeInstance.close()
        }
        _goToPrev() {
            this.photoSwipeInstance.prev()
        }
        _goToNext() {
            this.photoSwipeInstance.next()
        }
        _moveTo(event, target) {
            this.photoSwipeInstance.goTo([...target.parentNode.children].indexOf(target))
        }
        _onPswpClosed() {
            this.delegate.off("pswpTap")
        }
        _onPswpDoubleTap(point) {
            const initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;
            if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
                this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333)
            } else {
                this.photoSwipeInstance.zoomTo(initialZoomLevel < .7 ? 1 : this.maxSpreadZoom, point, 333)
            }
        }
        _onPswpTap(event) {
            if (event.detail.pointerType === "mouse") {
                this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint)
            }
        }
        _onPswpBeforeChange() {
            if (this.photoSwipeInstance.items.length <= 1) {
                return
            }
            const activeDot = this.photoSwipeInstance.scrollWrap.querySelector(`.dots-nav__item:nth-child(${this.photoSwipeInstance.getCurrentIndex() + 1})`);
            activeDot.setAttribute("aria-current", "true");
            getSiblings(activeDot).forEach(item=>item.removeAttribute("aria-current"))
        }
        _onPswpInitialZoomInEnd() {
            var _a;
            (_a = this.pswpUi) == null ? void 0 : _a.classList.remove("pswp__ui--hidden")
        }
        _onPswpInitialZoomOut() {
            var _a;
            (_a = this.pswpUi) == null ? void 0 : _a.classList.add("pswp__ui--hidden")
        }
        _onPswpParseVerticalMargin(item) {
            item.vGap.bottom = this.photoSwipeInstance.items.length <= 1 || window.matchMedia(window.themeVariables.breakpoints.lapAndUp).matches ? 0 : 60
        }
    }
    ;
    var ProductImageZoom = class extends OpenableElement {
        connectedCallback() {
            super.connectedCallback();
            this.mediaElement = this.closest(".product__media");
            this.maxSpreadZoom = window.themeVariables.settings.mobileZoomFactor || 2;
            LibraryLoader.load("photoswipe")
        }
        disconnectedCallback() {
            var _a;
            super.disconnectedCallback();
            (_a = this.photoSwipeInstance) == null ? void 0 : _a.destroy()
        }
        async attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            switch (name) {
            case "open":
                if (this.open) {
                    await LibraryLoader.load("photoswipe");
                    this._openPhotoSwipe()
                }
            }
        }
        async _openPhotoSwipe() {
            const items = await this._buildItems();
            this.photoSwipeInstance = new window.ThemePhotoSwipe(this,PhotoSwipeUi,items,{
                index: items.findIndex(item=>item.selected),
                maxSpreadZoom: this.maxSpreadZoom,
                loop: false,
                allowPanToNext: false,
                closeOnScroll: false,
                closeOnVerticalDrag: MediaFeatures.supportsHover(),
                showHideOpacity: true,
                arrowKeys: true,
                history: false,
                getThumbBoundsFn: ()=>{
                    const thumbnail = this.mediaElement.querySelector(".product__media-item.is-selected")
                      , pageYScroll = window.pageYOffset || document.documentElement.scrollTop
                      , rect = thumbnail.getBoundingClientRect();
                    return {
                        x: rect.left,
                        y: rect.top + pageYScroll,
                        w: rect.width
                    }
                }
                ,
                getDoubleTapZoom: (isMouseClick,item)=>{
                    if (isMouseClick) {
                        return item.w > item.h ? 1.6 : 1
                    } else {
                        return item.initialZoomLevel < .7 ? 1 : 1.33
                    }
                }
            });
            let lastWidth = null;
            this.photoSwipeInstance.updateSize = new Proxy(this.photoSwipeInstance.updateSize,{
                apply: (target,thisArg,argArray)=>{
                    if (lastWidth !== window.innerWidth) {
                        target(arguments);
                        lastWidth = window.innerWidth
                    }
                }
            });
            this.photoSwipeInstance.listen("close", ()=>{
                this.open = false
            }
            );
            this.photoSwipeInstance.init()
        }
        async _buildItems() {
            const activeImages = Array.from(this.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)'))
              , product = await ProductLoader.load(this.getAttribute("product-handle"));
            return Promise.resolve(activeImages.map(item=>{
                const matchedMedia = product["media"].find(media=>media.id === parseInt(item.getAttribute("data-media-id")))
                  , supportedSizes = getSupportedSizes(matchedMedia, [200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600, 1800, 2e3, 2200, 2400, 2600, 2800, 3e3])
                  , desiredWidth = Math.min(supportedSizes[supportedSizes.length - 1], window.innerWidth);
                return {
                    selected: item.classList.contains("is-selected"),
                    src: getSizedMediaUrl(matchedMedia, `${Math.ceil(Math.min(desiredWidth * window.devicePixelRatio * this.maxSpreadZoom, 3e3))}x`),
                    msrc: item.firstElementChild.currentSrc,
                    originalMedia: matchedMedia,
                    w: desiredWidth,
                    h: parseInt(desiredWidth / matchedMedia["aspect_ratio"])
                }
            }
            ))
        }
    }
    ;
    window.customElements.define("product-image-zoom", ProductImageZoom);
    var ProductInventory = class extends HTMLElement {
        connectedCallback() {
            var _a;
            const scriptTag = this.querySelector("script");
            if (!scriptTag) {
                return
            }
            this.inventories = JSON.parse(scriptTag.innerHTML);
            (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this))
        }
        _onVariantChanged(event) {
            var _a;
            (_a = this.querySelector("span")) == null ? void 0 : _a.remove();
            if (event.detail.variant && this.inventories[event.detail.variant["id"]] !== "") {
                this.hidden = false;
                this.insertAdjacentHTML("afterbegin", this.inventories[event.detail.variant["id"]])
            } else {
                this.hidden = true
            }
        }
    }
    ;
    window.customElements.define("product-inventory", ProductInventory);
    var PaymentContainer = class extends HTMLElement {
        connectedCallback() {
            var _a;
            (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
            if (Shopify.designMode && Shopify.PaymentButton) {
                Shopify.PaymentButton.init()
            }
        }
        _onVariantChanged(event) {
            const addToCartBtn = event.target.querySelector("#AddToCart");
            if (addToCartBtn && addToCartBtn.dataset.thisBundle) {
                this._updateBundleSelectedVariants(addToCartBtn, event)
            }
            this._updateAddToCartButton(event.detail.variant);
            this._updateDynamicCheckoutButton(event.detail.variant)
        }
        _updateBundleSelectedVariants(addToCartBtn, event) {
            let selectedVariants = JSON.parse(addToCartBtn.dataset.bundleSelectedVariants.replace(/'/g, '"').replace(/,}/, "}"));
            selectedVariants[event.detail.productHandle] = event.detail.variant.id;
            addToCartBtn.setAttribute("data-bundle-selected-variants", JSON.stringify(selectedVariants))
        }
        _updateAddToCartButton(variant) {
            let addToCartButtonElement = this.querySelector("[data-product-add-to-cart-button]");
            if (!addToCartButtonElement) {
                return
            }
            let addToCartButtonText = "";
            addToCartButtonElement.classList.remove("button--primary", "button--secondary", "button--ternary");
            if (!variant) {
                addToCartButtonElement.setAttribute("disabled", "disabled");
                addToCartButtonElement.classList.add("button--ternary");
                addToCartButtonText = window.themeVariables.strings.productFormUnavailable
            } else {
                if (variant["available"]) {
                    addToCartButtonElement.removeAttribute("disabled");
                    addToCartButtonElement.classList.add(addToCartButtonElement.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary");
                    addToCartButtonText = addToCartButtonElement.getAttribute("data-button-content")
                } else {
                    addToCartButtonElement.setAttribute("disabled", "disabled");
                    addToCartButtonElement.classList.add("button--ternary");
                    addToCartButtonText = window.themeVariables.strings.productFormSoldOut
                }
            }
            if (addToCartButtonElement.getAttribute("is") === "loader-button" && addToCartButtonElement.firstElementChild) {
                addToCartButtonElement.firstElementChild.innerHTML = addToCartButtonText
            } else {
                addToCartButtonElement.innerHTML = addToCartButtonText
            }
        }
        _updateDynamicCheckoutButton(variant) {
            let paymentButtonElement = this.querySelector(".shopify-payment-button");
            if (!paymentButtonElement) {
                return
            }
            paymentButtonElement.style.display = !variant || !variant["available"] ? "none" : "block"
        }
    }
    ;
    window.customElements.define("product-payment-container", PaymentContainer);
    var PaymentTerms = class extends CustomHTMLElement {
        connectedCallback() {
            var _a;
            (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this))
        }
        _onVariantChanged(event) {
            const variant = event.detail.variant;
            if (variant) {
                const idElement = this.querySelector('[name="id"]');
                idElement.value = variant["id"];
                idElement.dispatchEvent(new Event("change",{
                    bubbles: true
                }))
            }
        }
    }
    ;
    window.customElements.define("product-payment-terms", PaymentTerms);
    var SinglePWPAddon = class extends HTMLElement {
        connectedCallback() {
            document.addEventListener("single-pwp-addon:appended", e=>this._load.bind(this)(e, true))
        }
        async _load(event, open) {
            const {singlePwpPromo, singlePwpItem} = event?.detail || {};
            if (!singlePwpItem || !singlePwpPromo || this.dataset.key !== singlePwpItem.key)
                return;
            const url = this.getAttribute("href");
            const html = await fetch(url, {
                credentials: "same-origin",
                method: "GET"
            }).then(r=>r.text());
            this.innerHTML = html;
            if (singlePwpPromo) {
                this.querySelectorAll("[data-product-add-to-cart-button]").forEach(button=>{
                    button.setAttribute("data-addon", true);
                    button.setAttribute("data-promo-id", singlePwpPromo.id);
                    button.setAttribute("data-promo-issued-count", singlePwpPromo.issued_count);
                    button.setAttribute("data-promo-quantity", singlePwpPromo.quantity);
                    button.setAttribute("data-promo-addon", singlePwpPromo.add_on)
                }
                );
                this.querySelectorAll(".quantity-selector__input").forEach(input=>{
                    input.setAttribute("max", singlePwpPromo.issued_count)
                }
                )
            }
            if (open) {
                document.dispatchEvent(new CustomEvent("single-pwp:open"))
            }
        }
    }
    ;
    window.customElements.define("single-pwp-addon", SinglePWPAddon);
    var SinglePWP = class extends HTMLElement {
        connectedCallback() {
            this._initEvents.bind(this)();
            document.addEventListener("cart:updated", e=>this._load.bind(this)(e));
            document.addEventListener("single-pwp:open", this._open.bind(this));
            document.addEventListener("single-pwp:update-attributes", e=>this._updateAttributes.bind(this)(e.detail.variant, e.detail.singlePwpPromo))
        }
        async _load(event) {
            if (!event.detail || event.detail.cartNote) {
                return
            }
            const {variant, cart} = event.detail;
            let singlePwpItem = null;
            let singlePwpPromo = null;
            cart.items.forEach(item=>{
                if (item.id === variant && item.properties && item.properties.__promo) {
                    item.properties.__promo.forEach(promo=>{
                        if (promo.rule === "single-pwp" && promo.issued_count > 0) {
                            singlePwpPromo = promo;
                            return singlePwpItem = item
                        }
                    }
                    )
                }
            }
            );
            if (!singlePwpItem || !singlePwpPromo) {
                return this._close.bind(this)()
            }
            const addons = cart.items.filter(item=>item.properties && item.properties.__add_on && item.properties.__add_on.rule.id === singlePwpPromo.id);
            if (addons.length && addons[0].quantity >= singlePwpPromo.issued_count) {
                return this._close.bind(this)()
            }
            const url = "/cart?view=single-pwp";
            const html = await fetch(url, {
                credentials: "same-origin",
                method: "GET"
            }).then(r=>r.text());
            this.innerHTML = html;
            this._updateAttributes.bind(this)(variant, singlePwpPromo);
            if (this.querySelector("single-pwp-addon")) {
                document.dispatchEvent(new CustomEvent("single-pwp-addon:appended",{
                    bubbles: true,
                    detail: {
                        ...event.detail,
                        singlePwpItem: singlePwpItem,
                        singlePwpPromo: singlePwpPromo
                    }
                }))
            }
        }
        _updateAttributes(variant, singlePwpPromo) {
            this.setAttribute("data-single-pwp-id", variant);
            this.setAttribute("data-promo-id", singlePwpPromo.id);
            this.setAttribute("data-promo-issued-count", singlePwpPromo.issued_count);
            this.setAttribute("data-promo-quantity", singlePwpPromo.quantity);
            this.setAttribute("data-promo-addon", singlePwpPromo.add_on);
            this._initEvents.bind(this)()
        }
        _open() {
            this.classList.add("open");
            this._initEvents.bind(this)()
        }
        _close() {
            this.classList.remove("open")
        }
        _initEvents() {
            const closeButtons = this.querySelectorAll('[data-action="close-single-pwp-popup"]');
            closeButtons.forEach(button=>{
                button.addEventListener("click", this._close.bind(this))
            }
            )
        }
    }
    ;
    window.customElements.define("single-pwp", SinglePWP);
    document.addEventListener("DOMContentLoaded", function() {
        document.addEventListener("cart:updated", e=>{
            addOrRemoveSingleGwpAddon(e.detail)
        }
        );
        async function addOrRemoveSingleGwpAddon(data) {
            const {cart, variant, addedGwpAddon} = data || {};
            if (addedGwpAddon || !cart || !variant)
                return;
            let singleGwpItem = null;
            let singleGwpPromo = null;
            cart.items.forEach(item=>{
                if (item.id === variant && item.properties && item.properties.__promo) {
                    item.properties.__promo.forEach(promo=>{
                        if (promo.rule === "single-gwp" && promo.issued_count > 0) {
                            singleGwpPromo = promo;
                            singleGwpItem = item;
                            return
                        }
                    }
                    )
                }
            }
            );
            if (!singleGwpPromo)
                return;
            const addonProduct = await fetch(`/products/${singleGwpPromo.add_on}.js`, {
                method: "GET",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            });
            const addonProductJson = await addonProduct.json();
            const addonVariant = addonProductJson?.variants[0]?.id;
            if (!addonVariant)
                return;
            const existingAddon = cart.items.filter(item=>item.id === addonVariant);
            let existingQty = 0;
            existingAddon.forEach(addon=>{
                existingQty += addon.quantity
            }
            );
            const qtyToAdd = singleGwpPromo.issued_count - existingQty;
            if (qtyToAdd === 0)
                return;
            let response = null;
            if (qtyToAdd > 0) {
                const body = {
                    items: [{
                        id: addonVariant,
                        quantity: qtyToAdd,
                        properties: {
                            __add_on: {
                                rule: {
                                    id: singleGwpPromo.id,
                                    add_on: singleGwpPromo.add_on,
                                    quantity: singleGwpPromo.quantity,
                                    rule: "single-gwp"
                                },
                                add_on: singleGwpPromo.add_on
                            }
                        }
                    }],
                    sections: ["mini-cart", "main-cart"]
                };
                response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                    method: "POST",
                    body: JSON.stringify(body),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    }
                })
            }
            if (qtyToAdd < 0) {
                response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
                    body: JSON.stringify({
                        id: addonVariant,
                        quantity: Math.abs(qtyToAdd),
                        sections: ["mini-cart", "main-cart"]
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
            }
            if (!response)
                return;
            const responseJson = await response.json();
            const productForm = new ProductForm;
            if (response.ok) {
                this.dispatchEvent(new CustomEvent("variant:added",{
                    bubbles: true,
                    detail: {
                        variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
                    }
                }));
                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async response2=>{
                    let cartContent = await response2.json();
                    cartContent = productForm._correctCartCount(cartContent);
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated",{
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0].id : responseJson.id,
                            addedGwpAddon: true
                        }
                    }))
                }
                );
                const groupDiscountPopup = document.querySelector(".group-discount-popup");
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{
                    bubbles: true,
                    detail: {
                        cart: responseJson,
                        openMiniCart: window.themeVariables.settings.cartType === "drawer" && productForm.closest(".drawer") === null && (!groupDiscountPopup || groupDiscountPopup.classList.value.search("active") < 0)
                    }
                }))
            }
            this.dispatchEvent(new CustomEvent("cart-notification:show",{
                bubbles: true,
                cancelable: true,
                detail: {
                    status: response.ok ? "success" : "error",
                    error: responseJson["description"] || ""
                }
            }))
        }

      // cookie隐私政策添加条款
      // let cookieTextEle = document.querySelector('.shopify-pc__banner__body')
      // setCookieClause()
      // if(!cookieTextEle){
      //   setTimeout(()=>{
      //     cookieTextEle = document.querySelector('.shopify-pc__banner__body')
      //     setCookieClause()
      //   }, 400)
      // }
      // function setCookieClause(){ // 添加条款
      //   if(!cookieTextEle) return;
      //   const pElement = cookieTextEle.querySelector('p');
      //   const acceptElement = document.querySelector('#shopify-pc__banner__btn-accept');
      //   if(!acceptElement){
      //     return console.log('cookie error')
      //   }
      //    // 检查滚动位置的定时器ID
      //   const intervalId = setInterval(() => {
      //     if (window.scrollY >= 1200) {
      //       acceptElement.click();
      //       clearInterval(intervalId);
      //     }
      //   }, 1000);
      //   const aElement = document.createElement('a');
      //   const spanElement = document.createElement('span');
      //   const imgElement = document.createElement('img');
      //   imgElement.src= "https://cdn.shopify.com/s/files/1/0261/7058/9218/files/guanbi4.png?v=1729509124";
        
      //   Object.assign(imgElement.style, {
      //       width:'22px',
      //       height:'22px',
      //       position: 'absolute',
      //       top: '38px',
      //       right: '8vw'
      //   });
      //   function updateStyles() {
      //       const windowWidth = window.innerWidth;
      //       if (windowWidth <= 800) {
      //           imgElement.style.top = '0'; 
      //           imgElement.style.right = '-25px'; 
      //       }
      //   }
      //   updateStyles();
      //   window.addEventListener('resize', updateStyles);
      //   aElement.href = 'https://www.shapellx.com/pages/terms-of-service'; 
      //   aElement.textContent = 'Terms of Service.'; 
      //   aElement.target = '_blank'; 
      //   spanElement.textContent = ' and '; 
      //   pElement.appendChild(spanElement);
      //   pElement.appendChild(aElement);
      //   acceptElement.appendChild(imgElement);
      // }
      
    });
    var ProductForm = class extends HTMLFormElement {
        connectedCallback() {
            this.id.disabled = false;
            this.isAddonForm = !!this.closest("single-pwp-addon");
            this.isColorbox = !!this.closest("#colorbox");
            if (!this.isAddonForm && !this.isColorbox && (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart")) {
                return
            }
            this.addEventListener("submit", this._onSubmit.bind(this))
        }
        _addBundleToCart(addToCartBtn) {
            const mainProductVariant = addToCartBtn.dataset.bundleMainId;
            const selectedVariants = JSON.parse(addToCartBtn.dataset.bundleSelectedVariants.replace(/'/g, '"').replace(/,}/, "}"));
            const keyMapping = JSON.parse(addToCartBtn.dataset.bundleKeyMapping.replace(/'/g, '"').replace(/,}/, "}"));
            const productHandles = Object.keys(selectedVariants);
            const variants = Object.values(selectedVariants);
            const items = [];
            let key = "";
            variants.forEach((variant,idx)=>{
                const collectionHandle = keyMapping[productHandles[idx]];
                key += `${collectionHandle}:${variant}`;
                if (idx < variants.length - 1) {
                    key += "|"
                }
            }
            );
            variants.forEach((variant,idx)=>{
                const collectionHandle = keyMapping[productHandles[idx]];
                const item = {
                    id: variant,
                    quantity: 1,
                    properties: {
                        __bundle: {
                            key: key,
                            rule: "bundle",
                            set: collectionHandle
                        },
                        __sortKey: rollingHash(key)
                    }
                };
                items.push(item)
            }
            );
            items.push({
                id: mainProductVariant,
                quantity: 1,
                properties: {
                    __bundle: {
                        key: key,
                        rule: "bundle"
                    },
                    __sortKey: rollingHash(key) - 1
                }
            });
            const data = {
                items: items,
                sections: ["mini-cart", "main-cart"]
            };
            
            return fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
        }
        _newAddBundleToCart(addToCartBtn, variantIdsStr){
            const variantIds = variantIdsStr.split(',').map(e=>String(e).trim()).filter(e=>e);

            const productvariant = addToCartBtn.dataset.productvariant;
            const bundlevariantstr = addToCartBtn.dataset.bundlevariantstr;
            
            // 验证必要的数据
            if (!productvariant) {
                console.error('Bundle: Missing productvariant');
                return Promise.reject(new Error('Missing productvariant'));
            }
            
            if (!variantIds || variantIds.length === 0) {
                console.error('Bundle: Missing or empty variantIds');
                return Promise.reject(new Error('Missing variantIds'));
            }
            const invalidVariantIds = variantIds.filter(id => !/^\d+$/.test(id));
            if (invalidVariantIds.length > 0) {
                console.error('Bundle: Invalid variantIds format', { invalidVariantIds, variantIdsStr });
                return Promise.reject(new Error('Invalid variantIds'));
            }
            if (!/^\d+$/.test(String(productvariant).trim())) {
                console.error('Bundle: Invalid productvariant format', { productvariant });
                return Promise.reject(new Error('Invalid productvariant'));
            }

            // 安全地获取价格数组
            const bundlepricesStr = (addToCartBtn.dataset.bundleprices || '').split(',').filter(e => e);
            
            // 验证价格数组长度是否匹配
            if (bundlepricesStr.length !== variantIds.length) {
                console.warn('Bundle: Price array length mismatch', {
                    variantIdsCount: variantIds.length,
                    pricesCount: bundlepricesStr.length
                });
            }

            // 构建子产品数据，使用 map 的 index 参数而不是 indexOf（避免重复 variant_id 的问题）
            const bundleChildren = variantIds.map((variant_id, index) => {
                const price = bundlepricesStr[index] || '0';
                return {
                    variant_id: variant_id, // variant_id 已在上面做过格式校验
                    quantity: 1, // 默认数量为1，如果需要支持不同数量，需要从其他地方获取
                    price: price.trim() // 价格
                };
            });

            // 验证构建的数据
            const invalidChildren = bundleChildren.filter(c => !c.variant_id);
            if (invalidChildren.length > 0) {
                console.error('Bundle: Invalid children data', { invalidChildren });
                return Promise.reject(new Error('Invalid children data'));
            }

            // 添加父产品
            const items = [{
                id: productvariant,
                quantity: 1,
                properties: {
                    '__bundle_children': JSON.stringify(bundleChildren),
                    '__bundlevariantstr': bundlevariantstr || ''
                }
            }];

            const data = {
                items: items,
                sections: ["mini-cart", "main-cart"]
            };

            console.log('Bundle: Adding to cart', {
                productvariant,
                childrenCount: bundleChildren.length,
                bundleChildren
            });

            return fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            }).then(response => {
                if (!response.ok) {
                    console.error('Bundle: Cart add failed', response.status, response.statusText);
                    return Promise.reject(new Error(`Cart add failed: ${response.status}`));
                }
                return response;
            }).catch(error => {
                console.error('Bundle: Error adding to cart', error);
                return Promise.reject(error);
            });
        }
        _correctCartCount(cartContent) {
            let cartCount = cartContent.item_count;
            cartContent?.items?.forEach(item=>{
                if (item.properties && item.properties["__bundle"] && item.properties["__bundle"]?.rule === "bundle" && !item.properties["__bundle"].set) {
                    cartCount -= item.quantity
                }
            }
            );
            cartContent.item_count = cartCount;
            return cartContent
        }
        combosAddToCart(addToCartBtn, formDataObj){ // 组合商品
            const combostitle = addToCartBtn.dataset.combostitle;
            const item = {
                id: Number(formDataObj.id),
                quantity: Number(formDataObj.quantity),
                properties:{
                    __combos_title: combostitle,
                }
            };
            const body = {
                items: [item],
                sections: ["mini-cart", "main-cart"]
            };
            return fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                body: JSON.stringify(body),
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
        }
        async _onSubmit(event) {

            event.preventDefault();
            if (!this.checkValidity()) {
                this.reportValidity();
                return
            }
            if (event.target.closest('#single__details')) {
                let unSelected = null;
                event.target.closest('.product-form').querySelectorAll('.product-form__option-selector').forEach((item) => {
                    const inputs = item.querySelectorAll('.block-swatch__radio');
                    if (inputs.length && !Array.from(inputs).some((input) => input.checked === true)) {
                        unSelected = item;
                    } else if (item.querySelector('.block-swatch-list')) {
                        item.querySelector('.block-swatch-list').classList.remove('block-swatch-list-required');
                    }
                })
                if (unSelected) {
                    if (unSelected.querySelector('.block-swatch-list')) {
                        unSelected.querySelector('.block-swatch-list').classList.add('block-swatch-list-required');
                    }
                    unSelected.scrollIntoView({ behavior: "smooth", block: 'center' });
                    return;
                }
            }
            const submitButtons = Array.from(this.elements).filter(button=>button.type === "submit");
            submitButtons.forEach(submitButton=>{
                submitButton.setAttribute("disabled", "disabled");
                submitButton.setAttribute("aria-busy", "true")
            }
            );
            var addToCartBtn = event.target.querySelector("#AddToCart");
            var isFree = $(event.target).find('#AddToCart-qb').length;
            var isThreeToCart = event.submitter.id === 'AddThreeToCart';
            if(isFree){//添加赠品
                let cart_items = await jQuery.getJSON('/cart.js');
                let money = changeCurrency(cart_items.currency, FreeGifts.money)
                let total_price = cart_items.total_price/100
                let hasFree = false;
                cart_items.items.forEach((v, k)=>{
                    if(Object.values(v.properties).length){
                        for(let o in v.properties){
                            if(o == '__free'){
                                hasFree = true;
                            }
                        }
                    }
                })
                if(total_price < money || hasFree){
                    $.colorbox.close();
                    location.reload();
                    return;
                }
                addToCartBtn = event.target.querySelector("#AddToCart-qb");
            }
            const isBundle = !!addToCartBtn.dataset.thisBundle;
            const bundleVariantids = addToCartBtn.dataset.bundlevariantid;
            const isAddon = !!addToCartBtn.dataset.addon;
            const hasBundleDataAttribute = addToCartBtn.hasAttribute("data-bundlevariantid");
            const hasBundleChildrenConfig = Array.isArray(window.bundleChildProducts) && window.bundleChildProducts.length > 0;
            const shouldUseNewBundleFlow = hasBundleDataAttribute && hasBundleChildrenConfig;
            // const combosProductUrl = this.closest('.product-form')?.querySelector('input[name^="option"]:checked, select[name^="option"]')?.dataset.productUrl;
            let response = null;
            const productForm = new FormData(this);
            productForm.append("sections", ["mini-cart", "main-cart"]);
            productForm.delete("option1");
            productForm.delete("option2");
            productForm.delete("option3");
            if (isThreeToCart) { // 添加三件商品按钮
                productForm.append("quantity", 3);
            }
            let formDataObj = {};
            productForm.forEach((val,key)=>{
                formDataObj[key] = val
            });
            if (shouldUseNewBundleFlow && !bundleVariantids) {
                console.error('Bundle: bundleVariantids missing, stop submit to avoid fallback normal add', {
                    hasBundleDataAttribute,
                    hasBundleChildrenConfig,
                    productvariant: addToCartBtn.dataset.productvariant,
                    bundleMatchReady: addToCartBtn.dataset.bundleMatchReady
                });
                submitButtons.forEach(submitButton=>{
                    submitButton.removeAttribute("disabled");
                    submitButton.removeAttribute("aria-busy")
                }
                );
                this.dispatchEvent(new CustomEvent("cart-notification:show",{
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        status: "error",
                        error: "Please select all bundle options before adding to cart."
                    }
                }));
                return;
            }
            if(bundleVariantids){
                response = await this._newAddBundleToCart(addToCartBtn, bundleVariantids)
                // response = await this.combosAddToCart(addToCartBtn, formDataObj);
            }else if (isBundle) {
                response = await this._addBundleToCart(addToCartBtn);
            } else {
                // console.log('获取formDataObj：', formDataObj)
                const item = {
                    id: Number(formDataObj.id),
                    quantity: isFree ? 1 : Number(formDataObj.quantity)
                };
                if (isAddon) {
                    const addonData = addToCartBtn.dataset;
                    const properties = {
                        __add_on: {
                            rule: {
                                id: addonData.promoId,
                                add_on: addonData.promoAddon,
                                quantity: addonData.promoQuantity,
                                rule: "single-pwp"
                            },
                            add_on: addonData.promoAddon
                        }
                    };
                    item.properties = properties
                }
                if(isFree){
                    const properties = {
                        __free: {
                            rule: "free",
                        },
                    }
                    item.properties = properties
                }
                const body = {
                    items: [item],
                    sections: ["mini-cart", "main-cart"]
                };
                response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                    body: productForm,
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                        // "Content-Type": "application/json",
                        // "Accept": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    }
                })
            }
            submitButtons.forEach(submitButton=>{
                submitButton.removeAttribute("disabled");
                submitButton.removeAttribute("aria-busy")
            }
            );
            if (this.isAddonForm && window.themeVariables.settings.pageType === "cart") {
                location.reload()
            }
            const responseJson = await response.json();
            if (response.ok) {
                this.dispatchEvent(new CustomEvent("variant:added",{
                    bubbles: true,
                    detail: {
                        variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
                    }
                }));
                await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async response2=>{  
                     await Shopify.getCart();
                    let cartContent = await response2.json();
                    await fetch('/cart.js').then(async scaRes => {
                      cartContent = await scaRes.json();
                    })
                    let money = changeCurrency(cartContent.currency, FreeGifts.money)
                    let total_price = cartContent.total_price/100
                    let hasFree = false
                    cartContent.items.forEach((v, k)=>{
                        if(Object.values(v.properties).length){
                            for(let o in v.properties){
                                if(o == '__free'){
                                    hasFree = true;
                                }
                            }
                        }
                    })
                    if(total_price >= money && !isFree && !hasFree){
                        colorboxFun()
                    }
                    if(isFree){
                        $.colorbox.close();
                    }
                    cartContent = this._correctCartCount(cartContent);
                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated",{
                        bubbles: true,
                        detail: {
                            cart: cartContent,
                            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0].id : responseJson.id
                        }
                    }))
                }
                );
                const groupDiscountPopup = document.querySelector(".group-discount-popup");
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{
                    bubbles: true,
                    detail: {
                        cart: responseJson,
                        openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null && (!groupDiscountPopup || groupDiscountPopup.classList.value.search("active") < 0)
                    }
                }))
            }
            this.dispatchEvent(new CustomEvent("cart-notification:show",{
                bubbles: true,
                cancelable: true,
                detail: {
                    status: response.ok ? "success" : "error",
                    error: responseJson["description"] || ""
                }
            }))
        }
    }
    ;
    window.customElements.define("product-form", ProductForm, {
        extends: "form"
    });
    var ProductMedia = class extends CustomHTMLElement {
        async connectedCallback() {
            var _a;
            this.firstUpdate = true;
            this.mainCarousel = this.querySelector("flickity-carousel");
            if (this.mainCarousel.childElementCount === 1) {
                return
            }
            this.isNewProductSlider = this.closest('.shopify-section--main-product');
            this.selectedVariantMediaId = null;
            this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]");
            this.zoomButton = this.querySelector(".product__zoom-button");
            this.product = await ProductLoader.load(this.getAttribute("product-handle"));
            this.colorImgSwitch = this.product.tags.includes('Color Switch');
            this.styleAndColorImgSwitch = this.product.tags.includes('Style And Color Switch');
            if (this.hasAttribute("reveal-on-scroll")) {
                this._setupVisibility()
            }
            (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
            this.mainCarousel.addEventListener("model:played", ()=>this.mainCarousel.setDraggable(false));
            this.mainCarousel.addEventListener("model:paused", ()=>this.mainCarousel.setDraggable(true));
            this.mainCarousel.addEventListener("video:played", ()=>this.mainCarousel.setDraggable(false));
            this.mainCarousel.addEventListener("video:paused", ()=>this.mainCarousel.setDraggable(true));
            this.mainCarousel.addEventListener("flickity:ready", this._onFlickityReady.bind(this));
            this.mainCarousel.addEventListener("flickity:slide-changed", this._onFlickityChanged.bind(this));
            this.mainCarousel.addEventListener("flickity:slide-settled", this._onFlickitySettled.bind(this));
            this._onFlickityReady()
        }
        get thumbnailsPosition() {
            return window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? "bottom" : this.getAttribute("thumbnails-position")
        }
        async _setupVisibility() {
            // await this.untilVisible();
            const flickityInstance = await this.mainCarousel.flickityInstance
              , image = flickityInstance ? flickityInstance.selectedElement.querySelector("img") : this.querySelector(".product__media-image-wrapper img")
              , prefersReducedMotion = MediaFeatures.prefersReducedMotion();
            await imageLoaded(image);
            // 产品图渐入动画设置
            // const animation = new CustomAnimation(new ParallelEffect([new CustomKeyframeEffect(image,{
            //     opacity: [0, 1],
            //     transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"]
            // },{
            //     duration: 500,
            //     easing: "cubic-bezier(0.65, 0, 0.35, 1)"
            // }), new ParallelEffect(Array.from(this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")).map((item,index)=>{
            //     return new CustomKeyframeEffect(item,{
            //         opacity: [0, 1],
            //         transform: this.thumbnailsPosition === "left" ? [`translateY(${prefersReducedMotion ? 0 : "40px"})`, "translateY(0)"] : [`translateX(${prefersReducedMotion ? 0 : "50px"})`, "translateX(0)"]
            //     },{
            //         duration: 250,
            //         delay: prefersReducedMotion ? 0 : 100 * index,
            //         easing: "cubic-bezier(0.75, 0, 0.175, 1)"
            //     })
            // }
            // ))]));
            // console.log('当前产品数据：', this.product)
            const animation = new CustomAnimation(new ParallelEffect([])); // 取消产品缩略小图渐入动画
            let tags = this.product?.tags
            let isTag = (tags && tags.length > 0) ? tags.includes('tag-banner-all') : false
            if (!isTag || this.colorImgSwitch) {
                this.updateVariantImage(this.product)
            }
            this._hasSectionReloaded ? animation.finish() : animation.play()
            
        }
        newProductImgSlide(variant, detail) {
            const isMobile = (document.documentElement.clientWidth || document.body.clientWidth) < 767;
            var productSlide = this.querySelectorAll("[data-product-slide]");
            if (!isMobile) {
                // 修复：size改变时不滚动，避免影响用户体验
               
                if (detail ? detail.colorChange : true) {
                    setTimeout(() => {
                        var varianted = variant || {}
                        for (let i = 0; i < this.product?.variants?.length; i++) {
                            let v = this.product.variants[i]
                            if (!variant && v.id == variandId) {
                                varianted = v;
                            }
                        };
                        // 检查 featured_media 是否存在
                        if (!varianted.featured_media || !varianted.featured_media.id) {
                            return; // 如果没有媒体，直接返回
                        }
                        const media_id = varianted.featured_media.id;
                        let currImg = null;
                        for (let i = 0; i < productSlide.length; i++) {
                            if (productSlide[i].getAttribute('data-media-id') === `${media_id}`) {
                                currImg = productSlide[i];
                            }
                        }
                        if (currImg) {
                            const react = currImg.getBoundingClientRect();
                            window.scrollTo({
                                top: react.top + window.pageYOffset - 100,
                                behavior: 'smooth',
                            });
                        }
                    }, 0);
                }
            }
        }
        async _onVariantChanged(event) {
           
            let tags = this.product.tags
            const variant = event.detail.variant;
            if (variant.option3 && this.colorImgSwitch && !event.detail.colorChange && !event.detail.sizeChange) {
                return;
            }
            let isTag = (tags && tags.length > 0) ? tags.includes('tag-banner-all') : false
            // 修复：size改变时不滚动，避免影响用户体验

            if (this.isNewProductSlider && (this.colorImgSwitch || (!event.detail.sizeChange && !event.detail.colorChange) || (!isTag && event.detail.colorChange && this.product.options.length === 2)) && window.innerWidth > 766) {
                window.scrollTo({
                    top: 230,
                    behavior: 'instant',
                });
            }
            if (!isTag || this.colorImgSwitch) {
                await this.updateVariantImage(this.product, variant);
            }
            const bundleInitial = this.getAttribute("data-bundle-initial") ? Number(this.getAttribute("data-bundle-initial")) : 0;
            if (bundleInitial && bundleInitial < 4) {
                return this.setAttribute("data-bundle-initial", bundleInitial + 1)
            }
            const isMobile = (document.documentElement.clientWidth || document.body.clientWidth) < 767;
            // 尺码是否变化了
            const sizeChange = event.detail.sizeChange;
            // 尺码变化不需要重新重加载banner
            if((isTag || sizeChange) && !this.colorImgSwitch){
                const filteredMediaIds = [];
                let shouldReload = false;
                this.product["media"].forEach(media=>{
                    var _a;
                    let matchMedia2 = variant["featured_media"] && media["id"] === variant["featured_media"]["id"];
                    if ((_a = media["alt"]) == null ? void 0 : _a.includes("#")) {
                        shouldReload = true;
                        if (!matchMedia2) {
                            const altParts = media["alt"].split("#")
                                , mediaGroupParts = altParts.pop().split("_");
                            this.product["options"].forEach(option=>{
                                if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
                                    if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                                        filteredMediaIds.push(media["id"])
                                    }
                                }
                            }
                            )
                        }
                    }
                });
                const currentlyFilteredIds = [...new Set(Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map(item=>parseInt(item.getAttribute("data-media-id"))))];
                if (currentlyFilteredIds.some(value=>!filteredMediaIds.includes(value)) && !sizeChange) { // 尺码变化不走重新渲染
                    const selectedMediaId = variant["featured_media"] ? variant["featured_media"]["id"] : this.product["media"].map(item=>item.id).filter(item=>!filteredMediaIds.includes(item))[0];
                    Array.from(this.querySelectorAll("[data-media-id]")).forEach(item=>{
                        item.classList.toggle("is-filtered", filteredMediaIds.includes(parseInt(item.getAttribute("data-media-id"))));
                        item.classList.toggle("is-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
                        item.classList.toggle("is-initial-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
                    });
                    this.mainCarousel.reload()
                } else {
                    if (!event.detail.variant["featured_media"] || this.selectedVariantMediaId === event.detail.variant["featured_media"]["id"]) {
                        return
                    }
                    this.mainCarousel.select(`[data-media-id="${event.detail.variant["featured_media"]["id"]}"]`)
                }
                this.selectedVariantMediaId = event.detail.variant["featured_media"] ? event.detail.variant["featured_media"]["id"] : null
            } else if (isMobile || !this.isNewProductSlider ? true : !event.detail.colorChange) {
                let selectedVariantMediaId = event.detail.variant["featured_media"] ? event.detail.variant["featured_media"]["id"] : null
                
                this.querySelectorAll('.product__media-item').forEach((item) => {
                    if (item.getAttribute('data-media-id') == selectedVariantMediaId) {
                        item.classList.add("is-initial-selected");
                        item.classList.add("is-selected");
                        // if (this.colorImgSwitch) {
                            // item.removeAttribute("aria-hidden");
                            // const index = parseInt(item.getAttribute('data-original-position'));
                            // item.closest('.flickity-slider').style.transform = `translateX(-${index * item.offsetWidth}px)`;
                            // this.mainCarousel.reload(`[data-media-id="${selectedVariantMediaId}"]`);
                        // }
                    } else {
                        item.classList.remove("is-initial-selected");
                        item.classList.remove("is-selected");
                        // if (this.colorImgSwitch) {
                        //     item.setAttribute("aria-hidden", "true");
                        // }
                    }
                });
                // if (this.colorImgSwitch) {
                //     this.querySelector('flickity-controls').querySelectorAll('button[data-product-slide-thumb]').forEach((item) => {
                //         if (item.getAttribute('data-media-id') == selectedVariantMediaId) {
                //             item.setAttribute("aria-current", "true");
                //         } else {
                //             item.removeAttribute("aria-current");
                //         }
                //     });
                //     this.querySelector('flickity-controls').querySelector('.product__thumbnail-list').scrollLeft = 0;
                // }
                const showFilldom = event.detail.colorChange && this.product.options.length > 2 && !this.colorImgSwitch && !this.styleAndColorImgSwitch ? true : event.detail.firstColorChange;
                // if (!this.colorImgSwitch) {
                this.mainCarousel.reload(`[data-media-id="${selectedVariantMediaId}"]`, showFilldom)
                // }
                // this.mainCarousel.select(`[data-media-id="${selectedVariantMediaId}"]`)
            }
            if (!this.colorImgSwitch && this.isNewProductSlider && (isTag || !event.detail.colorChange || this.product.options.length !== 2)) {
                this.newProductImgSlide(variant, event.detail);
            }
        }
        async updateVariantImage(productData, varianted) {
            var productSlide = this.querySelectorAll("[data-product-slide]");
            var productSlideThumb = this.querySelectorAll("[data-product-slide-thumb]");
            var variandId = getQueryString('variant') || this.getAttribute("data-media-variantId");
            var variant = varianted || {}
            var pivotOptionIndex = this.colorImgSwitch && productData?.variants?.[0]?.option3 ? 1 : 0;
            var optionNameMediaMap = {};
            var optionColorMediaMap = {};
            for (let i = 0; i < productData?.variants?.length; i++) {
                let v = productData.variants[i]
                if (v.featured_media) {
                    if (!optionNameMediaMap[v.options[pivotOptionIndex]]) {
                        optionNameMediaMap[v.options[pivotOptionIndex]] = v.featured_media.id;
                    }
                    if (!optionColorMediaMap[v.featured_media.id]) {
                        optionColorMediaMap[v.featured_media.id] = v.options[v.option3 ? 1 : 0];
                    }
                }
                if (!varianted && v.id == variandId) {
                    variant = v;
                }
            };
        
            if (variant && variant.featured_media) {
                const firstProductUrl = this.closest('.product').querySelector('input[data-product-url]')?.getAttribute('data-product-url');
                this.renderProductSlide(variant, productSlide, optionNameMediaMap, pivotOptionIndex, !!firstProductUrl, optionColorMediaMap)
                this.renderProductSlide(variant, productSlideThumb, optionNameMediaMap, pivotOptionIndex, !!firstProductUrl, optionColorMediaMap)
                let _this = this;
                if(!varianted && !this.closest('.product--featured') && !this.firstUpdate){
                    setTimeout(function(){
                        _this.mainCarousel.reload()
                    }, 500)
                }
            }
            this.firstUpdate = false;
        }
      
        renderProductSlide(variant, productSlide, optionNameMediaMap, pivotOptionIndex, isCombos=false, optionColorMediaMap) {
            var currentMediaOptionName = '';
            var currentMediaOptionColor = '';
            productSlide.forEach((item) => {
                let pId = item.getAttribute('data-media-id')
                if (item.getAttribute('data-variant-image-group')) {
                    currentMediaOptionName = item.getAttribute('data-variant-image-group')
                } else {
                    for (var optionName in optionNameMediaMap) {
                        if (pId == optionNameMediaMap[optionName]) {
                        currentMediaOptionName = optionName;
                        }
                    }
                    item.setAttribute('data-variant-image-group', currentMediaOptionName);
                }
                if (optionColorMediaMap[pId]) {
                    currentMediaOptionColor = optionColorMediaMap[pId];
                }
                item.setAttribute('data-variant-image-group-color', currentMediaOptionColor);
                if (this.styleAndColorImgSwitch ? 
                    currentMediaOptionColor === variant.options[variant.option3 ? 1 : 0] && currentMediaOptionName == variant.options[pivotOptionIndex] : 
                    (isCombos || currentMediaOptionName == variant.options[pivotOptionIndex] || pId == variant.featured_media.id)) {
                    item.classList.remove('is-filtered')
                } else {
                    item.classList.add('is-filtered')
                }
            });
        }
        async _onFlickityReady() {
            const flickityInstance = await this.mainCarousel.flickityInstance;
            if (["video", "external_video"].includes(flickityInstance.selectedElement.getAttribute("data-media-type")) && this.hasAttribute("autoplay-video")) {
                flickityInstance.selectedElement.firstElementChild.play()
            }
        }
        async _onFlickityChanged() {
            const flickityInstance = await this.mainCarousel.flickityInstance;
            flickityInstance.cells.forEach(item=>{
                if (["external_video", "video", "model"].includes(item.element?.getAttribute("data-media-type"))) {
                    item.element.firstElementChild.pause()
                }
            }
            )
        }
        async _onFlickitySettled() {
            const flickityInstance = await this.mainCarousel.flickityInstance
              , selectedSlide = flickityInstance.selectedElement;
            if (this.zoomButton) {
                this.zoomButton.hidden = selectedSlide.getAttribute("data-media-type") !== "image"
            }
            if (this.viewInSpaceElement) {
                this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"))
            }
            switch (selectedSlide.getAttribute("data-media-type")) {
            case "model":
                this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", selectedSlide.getAttribute("data-media-id"));
                selectedSlide.firstElementChild.play();
                break;
            case "external_video":
            case "video":
                if (this.hasAttribute("autoplay-video")) {
                    selectedSlide.firstElementChild.play()
                }
                break
            }
        }
    }
    ;
    window.customElements.define("product-media", ProductMedia);
    function formatMoney(cents, format="", unShowDecimal) {
        if (typeof cents === "string") {
            cents = cents.replace(".", "")
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
          , formatString = format || window.themeVariables.settings.moneyFormat;
        function defaultTo(value2, defaultValue) {
            return value2 == null || value2 !== value2 ? defaultValue : value2
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
                return 0
            }
            number = (number / 100).toFixed(precision);
            let parts = number.split(".")
              , dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands)
              , centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount
        }
        function decimalHandle(price) {
            return unShowDecimal && price.includes('.') ? price.split('.')[0] : price;
        }
        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ",", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
            return decimalHandle(formatString.replace(placeholderRegex, value))
        } else {
            return decimalHandle(formatString.replace(placeholderRegex, value))
        }
    }
    var ProductMeta = class extends HTMLElement {
        connectedCallback() {
            var _a;
            (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this))
            const mobileReviews = this.querySelector('.stamped-product-reviews-badge');
            if (mobileReviews) {
              const timer = setInterval(() => {
                  if (mobileReviews.querySelector('.stamped-badge')) {
                        mobileReviews.querySelector('.stamped-badge').removeAttribute('aria-label');
                        clearInterval(timer);
                        const numbersCon = mobileReviews.querySelector('.stamped-badge-caption');
                        const num = Number(numbersCon.getAttribute('data-reviews')).toLocaleString();
                        numbersCon.innerHTML = `<span>${num}</span><span style="display:none"> Reviews</span>`;
                  }
              }, 500);
            }
        }
        get priceClass() {
            return this.getAttribute("price-class") || ""
        }
        get unitPriceClass() {
            return this.getAttribute("unit-price-class") || ""
        }
        _onVariantChanged(event) {
            // console.log(event)
            const addToCartBtn = event.target.querySelector("#AddToCart");
            if (addToCartBtn && addToCartBtn.dataset.thisBundle) {
                console.log("this is bundle", event, event.target)
            } else {
                this._updatePrices(event.detail.variant);
                this._updateLabels(event.detail.variant)
            }
            this._updateSku(event.detail.variant)
        }
        _updateLabels(variant) {
            let productLabelList = this.querySelector("[data-product-label-list]");
            if (!productLabelList) {
                return
            }
            if (!variant) {
                productLabelList.innerHTML = ""
            } else {
                productLabelList.innerHTML = "";
                if (!variant["available"]) {
                    productLabelList.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`
                } else if (variant["compare_at_price"] > variant["price"]) {
                    let savings = "";
                    if (window.themeVariables.settings.discountMode === "percentage") {
                        savings = Math.round((variant["compare_at_price"] - variant["price"]) * 100 / variant["compare_at_price"])
                        var savingsNew = Math.floor(savings / 5) * 5
                        productLabelList.innerHTML = `<span class="label label--highlight">${savingsNew}% OFF</span>`
                    } else {
                        savings = formatMoney(variant["compare_at_price"] - variant["price"])
                        productLabelList.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace("@savings@", savings)}</span>`
                    }
                }
            }
        }
        _updatePrices(variant) {
            const bundle_products = window.bundleChildProducts;
            if(bundle_products?.length) return;

            let productPrices = this.querySelector("[data-product-price-list]");
            // const productMetaElement = productPrices.closest(".product-meta, .quick-buy-product");
            const productMetaElement = productPrices.closest(".product-meta");

            if (productMetaElement) {
                var dataPointsBox = productMetaElement.nextElementSibling?.querySelector(".product-form .pointsBox");
            }
            // }
            let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
            let unShowDecimal = !window.themeVariables.settings.showDecimalEnabled;
            if (!productPrices) {
                return
            }
            if (!variant) {
                productPrices.style.display = "none"
                if (dataPointsBox) {
                    dataPointsBox.style.display = "none"
                }
                const innerPointsBox = this.querySelector(".pointsBox");
                if (innerPointsBox) innerPointsBox.style.display = "none"

            } else {
                productPrices.innerHTML = "";
                if (dataPointsBox) {
                    dataPointsBox.innerHTML = "";
                    dataPointsBox.innerHTML += `<div style="width:100%;background-color: #fef7f6;padding: 5px;display:flex;justify-content: space-between;border-radius: 4px;"><span>Earn <strong>${ variant["price"] / 100 } Points</strong> with Shapellx Reward. </span><a style="text-decoration: underline;" href="https://www.shapellx.com/pages/rewards" aria-label="Join">Join Now</a></div>`
                }
                // 更新 product-meta 内部的积分显示（product-info 里 pointsBox 在 product-meta 内，随变体价格动态更新）
                const innerPointsBox = this.querySelector(".pointsBox");
                if (innerPointsBox) {
                    innerPointsBox.style.display = "";
                    const innerPointsValue = innerPointsBox.querySelector("#points-value, strong");
                    if (innerPointsValue) innerPointsValue.textContent = `${variant["price"] / 100} Points`;
                }
                if (variant["compare_at_price"] > variant["price"]) {
                    productPrices.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatMoney(variant["compare_at_price"], currencyFormat, unShowDecimal)}</span>`;
                    productPrices.innerHTML += `<span class="price price--highlight ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(variant["price"], currencyFormat, unShowDecimal)}</span>`;
                } else {
                    productPrices.innerHTML += `<span class="price ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(variant["price"], currencyFormat, unShowDecimal)}</span>`;
                }
                if (variant["unit_price_measurement"]) {
                    let referenceValue = "";
                    if (variant["unit_price_measurement"]["reference_value"] !== 1) {
                        referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`
                    }
                    productPrices.innerHTML += `
          <div class="price text--subdued ${this.unitPriceClass}">
            <div class="unit-price-measurement">
              <span class="unit-price-measurement__price">${formatMoney(variant["unit_price"])}</span>
              <span class="unit-price-measurement__separator">/</span>
              ${referenceValue}
              <span class="unit-price-measurement__reference-unit">${variant["unit_price_measurement"]["reference_unit"]}</span>
            </div>
          </div>
        `
                }
                productPrices.style.display = ""
            }
        }
        _updateSku(variant) {
            let productSku = this.querySelector("[data-product-sku-container]");
            if (!productSku) {
                return
            }
            let productSkuNumber = productSku.querySelector("[data-product-sku-number]");
            if (!variant || !variant["sku"]) {
                productSku.style.display = "none"
            } else {
                productSkuNumber.innerHTML = variant["sku"];
                productSku.style.display = ""
            }
        }
    }
    ;
    window.customElements.define("product-meta", ProductMeta);
    var QuickBuyDrawer = class extends DrawerContent {
        connectedCallback() {
            super.connectedCallback();
            this.delegate.on("variant:changed", this._onVariantChanged.bind(this))
        }
        async _load() {
            await super._load();
            this.imageElement = this.querySelector(".quick-buy-product__image");
            if (window.Shopify && window.Shopify.PaymentButton) {
                window.Shopify.PaymentButton.init()
            }
            this._executeInlineScripts();
        }
        _executeInlineScripts() {
            // 查找所有 script 标签并执行
            this.querySelectorAll('script').forEach((oldScript) => {
            const newScript = document.createElement('script');
            if (oldScript.src) {
                // 外部 script
                newScript.src = oldScript.src;
            } else {
                // 内联 script
                newScript.textContent = oldScript.textContent;
            }
            document.body.appendChild(newScript);
            oldScript.remove();
            });
        }
        _onVariantChanged(event) {
            const variant = event.detail.variant;
            if (variant) {
                Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach(link=>{
                    const url = new URL(link.href);
                    url.searchParams.set("variant", variant["id"]);
                    link.setAttribute("href", url.toString())
                }
                )
            }
            if (!this.imageElement || !variant || !variant["featured_media"]) {
                return
            }
            const featuredMedia = variant["featured_media"];
            if (featuredMedia["alt"]) {
                this.imageElement.setAttribute("alt", featuredMedia["alt"])
            }
            this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
            this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
            this.imageElement.setAttribute("src", getSizedMediaUrl(featuredMedia, "342x"));
            this.imageElement.setAttribute("srcset", getMediaSrcset(featuredMedia, [114, 228, 342]))
        }
    }
    ;
    window.customElements.define("quick-buy-drawer", QuickBuyDrawer);
    var QuickBuyPopover = class extends PopoverContent {
        connectedCallback() {
            super.connectedCallback();
            this.delegate.on("variant:changed", this._onVariantChanged.bind(this));
            this.delegate.on("variant:added", ()=>this.open = false)
        }
        async _load() {
            await super._load();
            this.imageElement = this.querySelector(".quick-buy-product__image")
        }
        _onVariantChanged(event) {
            const variant = event.detail.variant;
            if (variant) {
                Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach(link=>{
                    const url = new URL(link.href);
                    url.searchParams.set("variant", variant["id"]);
                    link.setAttribute("href", url.toString())
                }
                )
            }
            if (!this.imageElement || !variant || !variant["featured_media"]) {
                return
            }
            const featuredMedia = variant["featured_media"];
            if (featuredMedia["alt"]) {
                this.imageElement.setAttribute("alt", featuredMedia["alt"])
            }
            this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
            this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
            this.imageElement.setAttribute("src", getSizedMediaUrl(featuredMedia, "195x"));
            this.imageElement.setAttribute("srcset", getMediaSrcset(featuredMedia, [65, 130, 195]))
        }
    }
    ;
    window.customElements.define("quick-buy-popover", QuickBuyPopover);
    var StorePickup = class extends HTMLElement {
        connectedCallback() {
            var _a;
            (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this))
        }
        _onVariantChanged(event) {
            if (!event.detail.variant) {
                this.innerHTML = ""
            } else {
                this._renderForVariant(event.detail.variant["id"])
            }
        }
        async _renderForVariant(id) {
            const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${id}?section_id=store-availability`)
              , div = document.createElement("div");
            div.innerHTML = await response.text();
            this.innerHTML = div.firstElementChild.innerHTML.trim()
        }
    }
    ;
    window.customElements.define("store-pickup", StorePickup);
    var ProductVariants = class extends CustomHTMLElement {
        async connectedCallback() {
            this.masterSelector = document.getElementById(this.getAttribute("form-id")).id;
            this.optionSelectors = Array.from(this.querySelectorAll("[data-selector-type]"));
            if (!this.masterSelector) {
                console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
                return
            }
            this.firstColorChange = true;
            this.product = await ProductLoader.load(this.productHandle);
            this.delegate.on("change", '[name^="option"]', this._onOptionChanged.bind(this));
            this.masterSelector.addEventListener("change", this._onMasterSelectorChanged.bind(this));
            // this.delegate.on("change", ".color-swatch__radio", this._onColorSwatchChanged.bind(this));
            // this.delegate.on("change", ".block-swatch__radio-bundle", this.onSizeBundleChanged.bind(this));
            const productFormEle = this.closest('.product-form');
            if (productFormEle) {
                this.addToCartBtn = productFormEle.querySelector("#AddToCart");
                this.bundleVariantids = this.addToCartBtn.dataset.bundlevariantid;
                this._setBundleVariantId();
            }

            if (this.selectedVariant) {
                this.oldSize = this.selectedVariant.options?.[this.selectedVariant.options.length - 1]; // 上一次选择的尺码
                this.oldColor = this.selectedVariant.options?.[this.selectedVariant.options.length - 2]; // 上一次选择的颜色
                this.selectVariant(this.selectedVariant?.id || "")
                this._updateDisableSelectors();
            }
            // this.setBundleVariant();
            // 默认第一个尺码售罄时，自动切换到下一个有库存尺码
            const firstProduct = this.product["variants"][0];
            this.combosHtmlEles = []; // 保存combos的html
            this.isCombosPro = false; // 默认不是组合产品
            const data_555 = this.querySelector('[data-555="Size"]');
            if (data_555) {
                const sizesInput = data_555.querySelectorAll('input');
                let currSizeCheckedIndex = 0;
                sizesInput.forEach((item, index) => {
                    if (item.checked) {
                        currSizeCheckedIndex = index;
                    }
                });
                if ( currSizeCheckedIndex === 0 && !firstProduct.available && firstProduct.options.includes(sizesInput[0].value) ) {
                    const availableVariant = this.product.variants.find(v => v.available);
                    if (availableVariant) {
                        const matchSwatch = [...data_555.querySelectorAll('.block-swatch input')]
                        .find(input => availableVariant.options.includes(input.value));
                        matchSwatch?.closest('label')?.click();
                    }
                }
            }
            
            // const sizeModules = document.querySelectorAll('.block-swatch-list');
            // sizeModules.forEach(mod => {
            // mod.style.pointerEvents = 'auto';
            // mod.removeAttribute('data-disabled');
            // });
            // if(this.dataset.url){ // combos功能提前请求html缓存起来
            //     let allUrls=[];
            //     const combosAllUrl = this.querySelectorAll('.color-swatch-list .color-swatch  input');
            //     if(combosAllUrl.length>0){
            //         combosAllUrl.forEach(el=>{
            //             if(el.dataset.productUrl){
            //                 allUrls.push(el.dataset.productUrl);
            //             }
            //         })
            //     }
            //     if( allUrls.length>0 ){ // 只有组合产品才有地址
            //         const path = window.location.pathname;
            //         if (path === localStorage.getItem('pathname')) {
            //             const combosHtmlElesjson = localStorage.getItem('combosHtmlElesjson');
            //             // 使用缓存html，防止重复请求
            //             if (combosHtmlElesjson) {
            //                 this.combosHtmlEles = JSON.parse(combosHtmlElesjson);
            //                 return;
            //             }
            //         }
            //         const abortController = new AbortController();
            //         this.fetchSequentially(allUrls, abortController);
            //     }
            // }
        }
        async fetchSequentially (urls, abortController) { // 请求组合子产品的html
            for (const url of urls) {
                try {
                    const response = await fetch(url, { signal: abortController.signal });
                    const responseText = await response.text();
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const mainElement = html.querySelector('#main');
                    if (mainElement) {
                        this.combosHtmlEles.push(mainElement.outerHTML);
                    }
                } catch (error) {
                    if (error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                        break; // 如果用户中止，则停止后续请求
                    } else {
                        console.error(error);
                    }
                }
            }
            if(this.combosHtmlEles.length === urls.length){
                localStorage.setItem('combosHtmlElesjson', JSON.stringify(this.combosHtmlEles));
                localStorage.setItem('pathname', window.location.pathname);
            }
        }

        get selectedVariant() {
            return this._getVariantById(parseInt(this.masterSelector.value))
        }
        get productHandle() {
            return this.getAttribute("handle")
        }
        get hideSoldOutVariants() {
            return this.hasAttribute("hide-sold-out-variants")
        }
        get updateUrl() {
            return this.hasAttribute("update-url")
        }
        _onColorSwatchChanged(variant) {
            const bundleItem = this.closest("[data-bundle-item-wrapper]");
            if (!bundleItem)
                return;
            const checkedColorRadio = bundleItem.querySelector(".color-swatch__radio:checked");
            if (!checkedColorRadio)
                return;
            const colorLabelRadio = bundleItem.querySelector(".fake-product-selector-radio");
            const bgColor = checkedColorRadio.style.backgroundColor;
            const bgImage = variant?.featured_image?.src;
            colorLabelRadio.style.backgroundColor = bgColor;
            if (bgImage) {
                colorLabelRadio.style.backgroundImage = `url(${bgImage})`
            }
        }
        selectVariant(id) {
            var _a;
            let isRequestId = false;
            if (!this._isVariantSelectable(this._getVariantById(id))) {
                id = this._getFirstMatchingAvailableVariant()?.["id"]
                isRequestId = true;
            }
            if (((_a = this.selectedVariant) == null ? void 0 : _a.id) === id) {
                return
            }
            this.masterSelector.value = id;
            this.masterSelector.dispatchEvent(new Event("change",{
                bubbles: true
            }));
            if (this.updateUrl && history.replaceState) {
                runWhenIdle(() => {
                    const newUrl = new URL(window.location.href);
                    if (id) {
                    newUrl.searchParams.set("variant", id);
                    } else {
                    newUrl.searchParams.delete("variant");
                    }
                    window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
                });
            }
            this._updateDisableSelectors();
            this._onColorSwatchChanged(this.selectedVariant);
            if (!this.selectedVariant) {
                return;
            }
            const options = this.selectedVariant.options;
            // if(this.isCombosPro) return; // 组合产品不触发事件


            triggerEvent(this.masterSelector.form, "variant:changed", {
                variant: this.selectedVariant,
                productHandle: this.productHandle,
                sizeChange: this.bundleVariantids || isRequestId ? false : options?.[options.length - 1] !== this.oldSize,
                colorChange: this.bundleVariantids ? true : options?.[options.length - 2] !== this.oldColor,
                firstColorChange: this.firstColorChange,
            });
            const init_num = this.bundleVariantids ? 1 : 2;
            this.firstColorChange = options?.[options.length - init_num] !== this.oldColor ? false : this.firstColorChange; // 如果颜色变化了，则不再是第一次变化
            this.oldSize = options?.[options.length - 1];
            this.oldColor = options?.[options.length - init_num];
        }
        format_bundle_select_option(bundleVariants){ // 格式捆绑的变体值-重新组合
            const options = this._getSelectedOptionValues();
            let b_v_ids = [];
            
            // 处理第一个选项值（颜色），可能包含多个值（用 / 分隔）
            const firstOption = options[0] || '';
            const colorArray = firstOption.includes('/') ? firstOption.split('/').filter(e => e) : [firstOption];
            
            // 获取每个子产品的选项总数（包括颜色）
            const getProductTotalOptionCount = (product) => {
                // 通过第一个变体的 options 长度来判断总选项数
                if (product.variants && product.variants.length > 0) {
                    const firstVariant = product.variants[0];
                    return firstVariant.options ? firstVariant.options.length : 0;
                }
                return 0;
            };
            
            // 从 options 中提取非颜色选项值（从 index 1 开始）
            const nonColorOptions = options.slice(1);
            
            let optionIndex = 0; // 用于遍历 nonColorOptions
            let colorIndex = 0; // 用于遍历 colorArray
            
            // 遍历每个子产品
            bundleVariants.forEach((product, productIndex) => {
                const totalOptionCount = getProductTotalOptionCount(product);
                const productOptions = [];
                
                // 第一个选项总是颜色
                if (colorArray[colorIndex]) {
                    productOptions.push(colorArray[colorIndex]);
                    colorIndex++;
                } else if (colorArray.length > 0) {
                    // 如果颜色数组用完了，使用最后一个颜色
                    productOptions.push(colorArray[colorArray.length - 1]);
                }
                
                // 根据子产品的总选项数量，从 nonColorOptions 中分配剩余的值
                // 总选项数 - 1（减去颜色） = 需要分配的非颜色选项数
                const nonColorCount = totalOptionCount - 1;
                for (let i = 0; i < nonColorCount; i++) {
                    if (optionIndex < nonColorOptions.length) {
                        productOptions.push(nonColorOptions[optionIndex]);
                        optionIndex++;
                    }
                }
                
                b_v_ids.push(productOptions);
            });
            
            return b_v_ids;
        }
        format_bundle_select_option_same_pro(){// 处理同一商品捆绑
            const options = this._getSelectedOptionValues();
            const color_arr = options[0]?.split('/').filter(e=>e);
            const select_arr = color_arr.map(item=>{
                return [item, options[1]]
            })
            return select_arr;
        }
        debounce(func, wait) {
            let timeout;
            return function (...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }
        getWindowBundleProduct(){
            const bundleVariants = window.bundleChildProducts;
            if( !bundleVariants ) return {};

            const b_v_ids = bundleVariants.length === 1 ? this.format_bundle_select_option_same_pro() : this.format_bundle_select_option(bundleVariants);
            const bundleProductList = bundleVariants.length === b_v_ids.length? bundleVariants : b_v_ids.map( ()=>{
                return bundleVariants[0];
            })
            return { bundleProductList, b_v_ids };

        }
        _setBundleVariantId() {  // 设置捆绑子产品变体id、图片和价格

            const { bundleProductList, b_v_ids } = this.getWindowBundleProduct();
            if(!bundleProductList) return;
            const addBtn = this.closest('.product-form').querySelector("#AddToCart");
            if (!addBtn) return;
            const expectedCount = Array.isArray(b_v_ids) ? b_v_ids.length : 0;

            const matchedVariants = bundleProductList.map((item, index) => {
                // 检查 b_v_ids[index] 是否存在
                if(!b_v_ids[index] || !Array.isArray(b_v_ids[index]) || b_v_ids[index].length === 0) {
                    return null;
                }
                // 查找匹配的变体：所有选项值必须完全匹配（包括顺序）
                return item.variants.find(variant => {
                    // 排除 freegifts 和包含 '% off)' 的变体
                    if(variant.metafields?.secomapp?.freegifts) return false;
                    if(variant.title && variant.title.includes('% off)')) return false;
                    
                    // 确保选项数量和值都匹配
                    if(variant.options.length !== b_v_ids[index].length) return false;
                    
                    return variant.options.every((value, optIndex) => value === b_v_ids[index][optIndex]);
                }) || null;
            });

            const validMatchedVariants = matchedVariants.filter(Boolean);
            const hasFullMatch = expectedCount > 0 && validMatchedVariants.length === expectedCount;
            const variantIds = hasFullMatch ? validMatchedVariants.map(v => v.id) : [];
            console.log('set variantIds::',variantIds);
            addBtn.dataset.bundlevariantid = variantIds.join(',');
            addBtn.dataset.bundleMatchReady = hasFullMatch ? "1" : "0";
            if (!hasFullMatch) {
                console.warn('Bundle: Incomplete variant matching, block add to cart fallback', {
                    expectedCount,
                    matchedCount: validMatchedVariants.length,
                    b_v_ids
                });
            }
            const id_str = b_v_ids.map(item=>{
                return item.join(' / ')
            }).join(',');
            addBtn.dataset.bundlevariantstr = id_str;
            // ✅ 更新子产品图片
            const bundleimgEles = this.querySelectorAll('.bundle-product-img');
            validMatchedVariants.forEach((variant, index) => {
                if (bundleimgEles[index] && variant.featured_image?.src) {
                    bundleimgEles[index].src = variant.featured_image.src;
                }
            });
            this._updateBundleDisableSelectors(addBtn);

            // ✅ 获取子产品价格集合
            const variantPrices = hasFullMatch ? validMatchedVariants.map(v => parseFloat(v.price) / 100) : [];
            addBtn.dataset.bundleprices = variantPrices.join(',');
            if (!hasFullMatch) {
                addBtn.setAttribute("disabled", "disabled");
            } else if (addBtn.getAttribute("aria-busy") !== "true") {
                addBtn.removeAttribute("disabled");
            }
        }


        _onOptionChanged(event) {
            if (this.bundleVariantids) {
                this._setBundleVariantId();
            }
            var _a;
            const options = this._getSelectedOptionValues();
            const _v = this.product["variants"].find(variant=>{
                return variant["options"].every((value, index) => value === options[index]);
            })
            const currUrl = this.dataset.url;
            const selectObj = this.querySelector('input[name^="option"]:checked, select[name^="option"]');
            const selectUrl = selectObj?.dataset.productUrl;
            const valueIndex = selectObj?.dataset.valueIndex;
            const isquickBuy = this.closest('quick-buy-drawer');
            this.isCombosPro = !!selectUrl;
            if (selectUrl && !isquickBuy && currUrl != selectUrl) {
                const scrollToppx = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                const pxval = scrollToppx > 1300 ? 1300 : scrollToppx;
                HTMLUpdateUtility.viewTransition( document.querySelector('#main'), this.combosHtmlEles[valueIndex], pxval, selectUrl);
                return;
            }

            const id = (_a = _v) == null ? void 0 : _a.id;
            // if (!id) {
            //     return;
            // }
            this.selectVariant(id);
            if (this.bundleVariantids) {
                this.addToCartBtn.dataset.productvariant = id;
            }
            let addToCartButtonElement = this.parentNode.querySelector("[data-product-add-to-cart-button]");
            if (!addToCartButtonElement) {
                return
            }
            // let addToCartButtonText = "";
            // addToCartButtonElement.classList.remove("button--primary", "button--secondary", "button--ternary");
            // if (!_v) {
            //     addToCartButtonElement.setAttribute("disabled", "disabled");
            //     addToCartButtonElement.classList.add("button--ternary");
            //     addToCartButtonText = window.themeVariables.strings.productFormUnavailable
            // } else {
            //     if (_v["available"]) {
            //         addToCartButtonElement.removeAttribute("disabled");
            //         addToCartButtonElement.classList.add(addToCartButtonElement.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary");
            //         addToCartButtonText = addToCartButtonElement.getAttribute("data-button-content")
            //     } else {
            //         addToCartButtonElement.setAttribute("disabled", "disabled");
            //         addToCartButtonElement.classList.add("button--ternary");
            //         addToCartButtonText = window.themeVariables.strings.productFormSoldOut
            //     }
            // }
            // if (addToCartButtonElement.getAttribute("is") === "loader-button" && addToCartButtonElement.firstElementChild) {
            //     addToCartButtonElement.firstElementChild.innerHTML = addToCartButtonText
            // } else {
            //     addToCartButtonElement.innerHTML = addToCartButtonText
            // }
            // if (window.innerWidth < 1000) {
            //     document.querySelector('.product-sticky-form__form').querySelector('product-payment-container').querySelector('[data-product-add-to-cart-button]').classList.add('sticky-btn-show');
            //     document.querySelector('.product-sticky-form__form').querySelector('product-payment-container').querySelector('.hidden-lap-and-up').classList.add('sticky-btn-hidden');
            // }
        }
        
        _updateBundleDisableSelectors(addBtn){ // 捆绑销售-判断子产品所有变体选项是否禁用隐藏
            const { bundleProductList, b_v_ids } = this.getWindowBundleProduct();
            if(!bundleProductList) return;

            const bundleItems = this.querySelectorAll('.bundle-product-item');

            // 检查当前选中的变体组合是否可用，用于禁用加购按钮
            let disabledBTN = false;
            b_v_ids.forEach((selectArr, index) => {
                if(!selectArr || selectArr.length === 0) return;
                if(!bundleProductList[index] || !bundleProductList[index]["variants"]) return;
                
                // 查找匹配的变体（所有选项值都匹配，包括顺序）
                const variantItem = bundleProductList[index]["variants"].find(variant => {
                    // 排除 freegifts 和包含 '% off)' 的变体
                    if(variant.metafields?.secomapp?.freegifts) return false;
                    if(variant.title && variant.title.includes('% off)')) return false;
                    
                    // 确保选项数量和值都匹配
                    if(variant.options.length !== selectArr.length) return false;
                    
                    return variant.options.every((value, optIndex) => {
                        return selectArr[optIndex] === value;
                    });
                });
                
                if(variantItem && !variantItem.available){
                    disabledBTN = true;
                }
            })
            
            // 捆绑销售-判断是否禁用加购按钮
            let addToCartButtonText = "";
            const eleArr = [addBtn];
            const stickyBTN = this.closest('#main').querySelector('#StickyAddToCart');
            if(stickyBTN){
                eleArr.push(stickyBTN)
            }
            setTimeout(() => {
                eleArr.forEach( ele =>{
                    ele.classList.remove("button--primary", "button--secondary", "button--ternary");
                    if(disabledBTN){
                        ele.setAttribute("disabled", "disabled");
                        ele.classList.add("button--ternary");
                        addToCartButtonText = "SOLD OUT"
                    }else{
                        ele.removeAttribute("disabled");
                        ele.classList.add(ele.hasAttribute("data-use-primary") ? "button--primary" : "button--secondary");
                        addToCartButtonText = ele.getAttribute("data-button-content")
                    }
                    if (ele.getAttribute("is") === "loader-button" && ele.firstElementChild) {
                        ele.firstElementChild.innerHTML = addToCartButtonText
                    } else {
                        ele.innerHTML = addToCartButtonText
                    }
                })
            }, 100);

            const bundleVariants1 = window.bundleChildProducts;
            if(!bundleVariants1) return;
            if(bundleVariants1.length === 1){ // 捆绑销售-判断单个子产品所有变体选项是否禁用隐藏
                const sizeEles = this.optionSelectors[1].querySelectorAll('.block-swatch__radio');
                const colorvalue = this._getSelectedOptionValues()?.[0] || '';
                if(!colorvalue) return;
                const bundle_variants= bundleVariants1[0].variants;
                sizeEles.forEach(ele => {
                    const size_value = ele.value;
                    const cur_variant = bundle_variants.filter(variant=> colorvalue.indexOf(variant.option1) > -1 && variant.options.indexOf(size_value) > -1);
                    const is_disabled = !cur_variant.every(variant=>variant.available);
                    if(is_disabled){
                        ele.setAttribute("disabled", "disabled");
                        ele.closest('.block-swatch').classList.add("is-disabled");
                    }else{
                        ele.removeAttribute("disabled");
                        ele.closest('.block-swatch').classList.remove("is-disabled");
                    }

                });

                return;
            }

            // 遍历每个子产品，更新所有选项的禁用状态
            Array.from(bundleItems).forEach((ele, inx)=>{
                if(!b_v_ids[inx] || b_v_ids[inx].length === 0) return;
                if(!bundleProductList[inx] || !bundleProductList[inx]["variants"]) return;
                
                const product = bundleProductList[inx];
                const variants = product.variants.filter(variant => {
                    // 排除 freegifts 和包含 '% off)' 的变体
                    if(variant.metafields?.secomapp?.freegifts) return false;
                    if(variant.title && variant.title.includes('% off)')) return false;
                    return true;
                });
                
                // 获取所有选项选择器（每个选项都有自己的 block-swatch-list）
                const optionSelectors = ele.querySelectorAll('.block-swatch-list');
                
                // 为每个选项选择器处理
                optionSelectors.forEach((optionSelector, bundle_option_index) => {
                    // 获取当前选项的所有 input
                    const optionInputs = optionSelector.querySelectorAll('.block-swatch__radio');
                    if(optionInputs.length === 0) return;
                    
                    // 从第一个 input 的 name 中提取选项位置
                    const firstInputName = optionInputs[0].getAttribute('name');
                    const optionPositionMatch = firstInputName.match(/option_[^_]+_(\d+)_/);
                    if(!optionPositionMatch) return;
                    
                    const optionPosition = parseInt(optionPositionMatch[1]) - 1; // 转换为 0-based
                    
                    // 使用 bundle_option_index 判断是否是最后一个选项
                    const isLastOption = bundle_option_index === optionSelectors.length - 1;
                    
                    // 获取当前所有选中的选项值（按选项位置排序）
                    const getCurrentSelectedOptions = () => {
                        const selected = {};
                        ele.querySelectorAll('input[type="radio"][name^="option"]:checked').forEach(input => {
                            const nameMatch = input.getAttribute('name').match(/option_[^_]+_(\d+)_/);
                            if(nameMatch) {
                                const pos = parseInt(nameMatch[1]) - 1;
                                selected[pos] = input.value;
                            }
                        });
                        
                        // 如果第一个选项（Color）未选中，尝试从主产品获取并拆分
                        if(selected[0] === undefined) {
                            // 查找主产品的 product-variants 元素（不在 .product_bundle_cus-new 内）
                            const bundleContainer = ele.closest('.product_bundle_cus-new');
                            if(bundleContainer) {
                                const mainProductVariants = document.querySelector('.product-form product-variants');
                                if(mainProductVariants) {
                                    // 查找主产品的第一个选项（Color）的选中值
                                    // 主产品的 name 格式是 option_{handle}_{position}，没有 child_index
                                    const mainColorInputs = mainProductVariants.querySelectorAll('input[type="radio"][name^="option"]:checked');
                                    mainColorInputs.forEach(input => {
                                        const mainColorName = input.getAttribute('name');
                                        // 主产品的 name 格式是 option_{handle}_{position}，没有第三个下划线后的数字
                                        const mainColorMatch = mainColorName.match(/option_[^_]+_(\d+)(?:_|$)/);
                                        if(mainColorMatch && parseInt(mainColorMatch[1]) === 1) {
                                            const mainColorValue = input.value;
                                            // 如果颜色值包含 /，说明是多个子产品的颜色组合，需要拆分
                                            if(mainColorValue.includes('/')) {
                                                const colorArray = mainColorValue.split('/').filter(c => c.trim() !== '');
                                                // 根据当前子产品的索引 inx 获取对应的颜色值
                                                if(colorArray.length > inx) {
                                                    selected[0] = colorArray[inx].trim();
                                                }
                                            } else {
                                                // 如果只有一个颜色值，直接使用
                                                selected[0] = mainColorValue;
                                            }
                                        }
                                    });
                                }
                            }
                        }
                        
                        return selected;
                    };
                    
                    const currentSelected = getCurrentSelectedOptions();
                    
                    // 处理当前选项的每个值
                    if(isLastOption) {
                        optionInputs.forEach((optionInput) => {
                            const optionValue = optionInput.value;
                            const swatch = optionInput.closest('.block-swatch');
                            if(!swatch) return;
                            
                            // 构建测试选项数组：用当前选项值替换对应位置的值
                            const testOptions = [];
                            // 获取产品的最大选项数
                            const maxOptions = variants.length > 0 ? variants[0].options.length : 0;
                            
                            for(let i = 0; i < maxOptions; i++) {
                                if(i === optionPosition) {
                                    testOptions[i] = optionValue;
                                } else if(i < optionPosition && currentSelected[i] !== undefined) {
                                    // 对于前面的选项位置，使用已选中的值
                                    testOptions[i] = currentSelected[i];
                                } else {
                                    // 对于后面的选项位置或未选中的位置，设置为 null
                                    testOptions[i] = null;
                                }
                            }
                            
                            // 检查是否有匹配的变体
                            let hasAvailableVariant = false;
                            variants.forEach(variant => {
                                if(variant.options.every((value, index) => testOptions[index] === value) && variant.available) {
                                    hasAvailableVariant = true;
                                }
                            });
                            
                            // 更新禁用状态
                            if(hasAvailableVariant) {
                                swatch.classList.remove("is-disabled");
                                optionInput.removeAttribute("disabled");
                                swatch.querySelector('.block-swatch__item')?.classList.remove("block-swatch__item--disabled");
                            } else {
                                // 没有匹配的变体，或者匹配的变体不可用，禁用该选项值
                                swatch.classList.add("is-disabled");
                                optionInput.setAttribute("disabled", "disabled");
                                swatch.querySelector('.block-swatch__item')?.classList.add("block-swatch__item--disabled");
                            }
                        });
                    }
                    
                    // 检查当前选中的选项是否被隐藏，如果是则自动选择第一个可用的选项
                    const checkedInput = optionSelector.querySelector('.block-swatch__radio:checked');
                    if(checkedInput) {
                        const checkedSwatch = checkedInput.closest('.block-swatch');
                        if(checkedSwatch && (checkedSwatch.hasAttribute('hidden') || checkedInput.disabled)) {
                            // 当前选中的选项被隐藏或禁用，需要选择第一个可用的选项
                            const availableSwatches = Array.from(optionSelector.querySelectorAll('.block-swatch'))
                                .filter(swatch => !swatch.hasAttribute('hidden') && !swatch.querySelector('.block-swatch__radio')?.disabled);
                            if(availableSwatches.length > 0) {
                                const firstAvailableInput = availableSwatches[0].querySelector('.block-swatch__radio');
                                if(firstAvailableInput) {
                                    firstAvailableInput.checked = true;
                                    firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
                                }
                            }
                        }
                    } else {
                        // 如果没有选中的选项，选择第一个可用的选项
                        const availableSwatches = Array.from(optionSelector.querySelectorAll('.block-swatch'))
                            .filter(swatch => !swatch.hasAttribute('hidden') && !swatch.querySelector('.block-swatch__radio')?.disabled);
                        if(availableSwatches.length > 0) {
                            const firstAvailableInput = availableSwatches[0].querySelector('.block-swatch__radio');
                            if(firstAvailableInput) {
                                firstAvailableInput.checked = true;
                                firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }
                    }
                });
            })
        }
        _onMasterSelectorChanged() {
            var _a;
            const options = ((_a = this.selectedVariant) == null ? void 0 : _a.options) || [];
            if (options.length === 0) return;
            
            const thisHandle = this.getAttribute("handle");
            
            // 优化：一次性获取所有相关的 option 元素，避免多次 querySelector
            const optionElementsMap = new Map();
            for (let i = 0; i < options.length; i++) {
                const optionName = `option_${thisHandle}_${i + 1}`;
                // 先查找 select，再查找 input
                const select = this.querySelector(`select[name="${optionName}"]`);
                if (select) {
                    optionElementsMap.set(i, { element: select, type: 'SELECT' });
                } else {
                    // 对于 input，获取所有同名的 input 元素
                    const inputs = this.querySelectorAll(`input[name="${optionName}"]`);
                    if (inputs.length > 0) {
                        optionElementsMap.set(i, { elements: Array.from(inputs), type: 'INPUT' });
                    }
                }
            }
            
            // 批量更新 DOM，减少重排重绘
            const changeEvents = [];
            options.forEach((value, index) => {
                const optionData = optionElementsMap.get(index);
                if (!optionData) return;
                
                if (optionData.type === 'SELECT') {
                    const input = optionData.element;
                    if (input.value !== value) {
                        input.value = value;
                        changeEvents.push(input);
                    }
                } else if (optionData.type === 'INPUT') {
                    // 对于 radio/checkbox，需要找到匹配 value 的 input
                    const matchedInput = optionData.elements.find(el => el.value === value);
                    if (matchedInput && !matchedInput.checked) {
                        // 如果是 radio，先取消同组其他选项
                        if (matchedInput.type === 'radio') {
                            optionData.elements.forEach(el => {
                                if (el !== matchedInput && el.checked) {
                                    el.checked = false;
                                }
                            });
                        }
                        matchedInput.checked = true;
                        changeEvents.push(matchedInput);
                    }
                }
            });
            
            // 批量触发 change 事件
            if (changeEvents.length > 0) {
                changeEvents.forEach(input => {
                    input.dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                });
            }
        }
        _getVariantById(id) {
            return this.product["variants"].find(variant=>variant["id"] === id)
        }
        _getVariantFromOptions() {
            const options = this._getSelectedOptionValues();
            return this.product["variants"].find(variant=>{
                return variant["options"].every((value) => options.includes(value))
            })
        }
        _isVariantSelectable(variant) {
            if (!variant) {
                return false
            } else {
                return variant["available"] || !this.hideSoldOutVariants && !variant["available"]
            }
        }
        _getFirstMatchingAvailableVariant() {
            let options = this._getSelectedOptionValues()
              , matchedVariant = null
              , slicedCount = 0;
            do {
                options.pop();
                slicedCount += 1;
                matchedVariant = this.product["variants"].find(variant=>{
                    return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value,index)=>value === options[index])
                }
                )
            } while (!matchedVariant && options.length > 0);
            return matchedVariant
        }
        _getSelectedOptionValues() {
            const options = [];
            Array.from(this.querySelectorAll('input[name^="option"]:checked, select[name^="option"]')).forEach(option=>options.push(option.value));
            return options
        }
        applyClassToSelector = (selector,valueIndex,available,hasAtLeastOneCombination)=>{
            let selectorType = selector.getAttribute("data-selector-type")
                , cssSelector = "";
            switch (selectorType) {
            case "color":
                cssSelector = `.color-swatch:nth-child(${valueIndex + 1})`;
                break;
            case "variant-image":
                cssSelector = `.variant-swatch:nth-child(${valueIndex + 1})`;
                break;
            case "block":
                cssSelector = `.block-swatch:nth-child(${valueIndex + 1})`;
                break;
            case "dropdown":
                cssSelector = `.combo-box__option-item:nth-child(${valueIndex + 1})`;
                break
            }
            const element = selector.querySelector(cssSelector);
            if (!element) {
                console.warn(`Element not found for selector: ${cssSelector}`);
                return;
            }
            selector.querySelector(cssSelector).toggleAttribute("hidden", !hasAtLeastOneCombination);
            if (this.hideSoldOutVariants) {
                selector.querySelector(cssSelector).toggleAttribute("hidden", !available)
            } else {
                selector.querySelector(cssSelector).classList.toggle("is-disabled", !available)
            }
        }
        _updateDisableSelectors(unShowNotifydiv) {
            if(window.bundleChildProducts && window.bundleChildProducts.length > 0){
                return;
            }
            const selectedVariant = this.selectedVariant;
            if (selectedVariant?.available && document.getElementById("notifyDiv")) {
                document.getElementById("notifyDiv").innerHTML = ``;
            } else if (!unShowNotifydiv) {
                if(document.getElementById("notifyDiv")) {
                    document.getElementById("notifyDiv").innerHTML = `<a class="klaviyo-button klaviyo-bis-trigger" href="#" aria-label="Restocking now! Get notified first">Restocking now! Get notified first.</a>`;
                }
            }
            // if(selectedVariant?.available && document.getElementById("notifyDiv") && selectedVariant?.option3 == null  && this.product?.options.length > 2) {
            //     document.getElementById("notifyDiv").innerHTML = `<a class="klaviyo-button klaviyo-bis-trigger" href="#">Restocking now! Get notified first.</a>`;
            // }

            if (!selectedVariant) {
                return
            }

            if (this.optionSelectors && this.optionSelectors[0]) {
                const firstProductUrl = this.optionSelectors[0].querySelector('input[data-product-url]')?.getAttribute('data-product-url'); // 获取第一个产品的URL-组合功能gzg
                this.product["options"][0]["values"].forEach((value,valueIndex)=>{
               
                    const hasAtLeastOneCombination = this.product["variants"].some(variant=>variant["option1"] === value && variant)
                      , hasAvailableVariant = this.product["variants"].some(variant=>variant["option1"] === value && variant["available"]);
                    this.applyClassToSelector(this.optionSelectors[0], valueIndex, firstProductUrl || hasAvailableVariant, firstProductUrl || hasAtLeastOneCombination);
                    if (this.optionSelectors[1]) {
                        this.product["options"][1]["values"].forEach((value2,valueIndex2)=>{
                            const hasAtLeastOneCombination2 = this.product["variants"].some(variant=>variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant)
                              , hasAvailableVariant2 = this.product["variants"].some(variant=>variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
                            this.applyClassToSelector(this.optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
                            if (this.optionSelectors[2]) {
                                this.product["options"][2]["values"].forEach((value3,valueIndex3)=>{
                                    const hasAtLeastOneCombination3 = this.product["variants"].some(variant=>variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant)
                                      , hasAvailableVariant3 = this.product["variants"].some(variant=>variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
                                    this.applyClassToSelector(this.optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3)
                                }
                                )
                            }
                        }
                        )
                    }
                }
                )
            }
        }
    }
    ;
    window.customElements.define("product-variants", ProductVariants);
    var ProductItem = class extends CustomHTMLElement {
        connectedCallback() {
            this.primaryImageList = Array.from(this.querySelectorAll(".product-item__primary-image"));
            this.delegate.on("change", ".product-item-meta__swatch-list .color-swatch__radio", this._onColorSwatchChanged.bind(this));
            this.delegate.on("mouseenter", ".product-item-meta__swatch-list .color-swatch__item", this._onColorSwatchHovered.bind(this), true)
        }
        async _onColorSwatchChanged(event, target) {
            Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach(link=>{
                let url;
                if (link.tagName === "A") {
                    url = new URL(link.href)
                } else {
                    url = new URL(link.getAttribute("href"),`https://${window.themeVariables.routes.host}`)
                }
                url.searchParams.set("variant", target.getAttribute("data-variant-id"));
                link.setAttribute("href", url.toString())
            }
            );
            if (target.hasAttribute("data-variant-featured-media")) {
                const newImage = this.primaryImageList.find(image=>image.getAttribute("data-media-id") === target.getAttribute("data-variant-featured-media"));
                newImage.setAttribute("loading", "eager");
                const onImageLoaded = newImage.complete ? Promise.resolve() : new Promise(resolve=>newImage.onload = resolve);
                await onImageLoaded;
                newImage.removeAttribute("hidden");
                let properties = {};
                if (Array.from(newImage.parentElement.classList).some(item=>["aspect-ratio--short", "aspect-ratio--tall", "aspect-ratio--square"].includes(item))) {
                    properties = [{
                        clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
                        transform: "translate(calc(-50% - 20px), -50%)",
                        zIndex: 1,
                        offset: 0
                    }, {
                        clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
                        transform: "translate(calc(-50% - 20px), -50%)",
                        zIndex: 1,
                        offset: .3
                    }, {
                        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1,
                        offset: 1
                    }]
                } else {
                    properties = [{
                        clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
                        transform: "translateX(-20px)",
                        zIndex: 1,
                        offset: 0
                    }, {
                        clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
                        transform: "translateX(-20px)",
                        zIndex: 1,
                        offset: .3
                    }, {
                        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                        transform: "translateX(0px)",
                        zIndex: 1,
                        offset: 1
                    }]
                }
                await newImage.animate(properties, {
                    duration: 500,
                    easing: "ease-in-out"
                }).finished;
                this.primaryImageList.filter(image=>image.classList.contains("product-item__primary-image") && image !== newImage).forEach(image=>image.setAttribute("hidden", ""))
            }
        }
        _onColorSwatchHovered(event, target) {
            const input = target.previousElementSibling;
            if (input.hasAttribute("data-variant-featured-media")) {
                const newImage = this.primaryImageList.find(image=>image.getAttribute("data-media-id") === input.getAttribute("data-variant-featured-media"));
                newImage.setAttribute("loading", "eager")
            }
        }
    }
    ;
    window.customElements.define("product-item", ProductItem);
    var ProductFacet = class extends CustomHTMLElement {
        connectedCallback() {
            this.delegate.on("pagination:page-changed", this._rerender.bind(this));
            this.delegate.on("facet:criteria-changed", this._rerender.bind(this));
            this.delegate.on("facet:abort-loading", this._abort.bind(this))
        }
        async _rerender(event) {
            history.replaceState({}, "", event.detail.url);
            this._abort();
            this.showLoadingBar();
            const url = new URL(window.location);
            url.searchParams.set("section_id", this.getAttribute("section-id"));
            try {
                this.abortController = new AbortController;
                const response = await fetch(url.toString(), {
                    signal: this.abortController.signal
                });
                const responseAsText = await response.text();
                const fakeDiv = document.createElement("div");
                fakeDiv.innerHTML = responseAsText;
                this.querySelector("#facet-main").innerHTML = fakeDiv.querySelector("#facet-main").innerHTML;
                const activeFilterList = Array.from(fakeDiv.querySelectorAll(".product-facet__active-list"))
                  , toolbarItem = document.querySelector(".mobile-toolbar__item--filters");
                if (toolbarItem) {
                    toolbarItem.classList.toggle("has-filters", activeFilterList.length > 0)
                }
                const filtersTempDiv = fakeDiv.querySelector("#facet-filters");
                if (filtersTempDiv) {
                    const previousScrollTop = this.querySelector("#facet-filters .drawer__content").scrollTop;
                    Array.from(this.querySelectorAll("#facet-filters-form .collapsible-toggle")).forEach(filterToggle=>{
                        const filtersTempDivToggle = filtersTempDiv.querySelector(`[aria-controls="${filterToggle.getAttribute("aria-controls")}"]`)
                          , isExpanded = filterToggle.getAttribute("aria-expanded") === "true";
                        filtersTempDivToggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
                        filtersTempDivToggle.nextElementSibling.toggleAttribute("open", isExpanded);
                        filtersTempDivToggle.nextElementSibling.style.overflow = isExpanded ? "visible" : ""
                    }
                    );
                    this.querySelector("#facet-filters").innerHTML = filtersTempDiv.innerHTML;
                    this.querySelector("#facet-filters .drawer__content").scrollTop = previousScrollTop
                }
                const scrollTo = this.querySelector(".product-facet__meta-bar") || this.querySelector(".product-facet__product-list") || this.querySelector(".product-facet__main");
                requestAnimationFrame(()=>{
                    scrollTo.scrollIntoView({
                        block: "start",
                        behavior: "smooth"
                    })
                }
                );
                this.hideLoadingBar()
            } catch (e) {
                if (e.name === "AbortError") {
                    return
                }
            }
        }
        _abort() {
            if (this.abortController) {
                this.abortController.abort()
            }
        }
    }
    ;
    window.customElements.define("product-facet", ProductFacet);
    var FacetFilters = class extends DrawerContent {
        connectedCallback() {
            super.connectedCallback();
            this.delegate.on("change", '[name^="filter."]', this._onFilterChanged.bind(this));
            this.rootDelegate.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
            if (this.alwaysVisible) {
                this.matchMedia = window.matchMedia(window.themeVariables.breakpoints.pocket);
                this.matchMedia.addListener(this._adjustDrawer.bind(this));
                this._adjustDrawer(this.matchMedia)
            }
        }
        get alwaysVisible() {
            return this.hasAttribute("always-visible")
        }
        _onFiltersCleared(event, target) {
            event.preventDefault();
            triggerEvent(this, "facet:criteria-changed", {
                url: target.href
            })
        }
        _onFilterChanged() {
            const formData = new FormData(this.querySelector("#facet-filters-form"));
            const searchParamsAsString = new URLSearchParams(formData).toString();
            triggerEvent(this, "facet:criteria-changed", {
                url: `${window.location.pathname}?${searchParamsAsString}`
            })
        }
        _adjustDrawer(match) {
            this.classList.toggle("drawer", match.matches);
            this.classList.toggle("drawer--from-left", match.matches)
        }
    }
    ;
    window.customElements.define("facet-filters", FacetFilters);
    var SortByPopover = class extends PopoverContent {
        connectedCallback() {
            super.connectedCallback();
            this.delegate.on("change", '[name="sort_by"]', this._onSortChanged.bind(this))
        }
        _onSortChanged(event, target) {
            const currentUrl = new URL(location.href);
            currentUrl.searchParams.set("sort_by", target.value);
            currentUrl.searchParams.delete("page");
            this.open = false;
            this.dispatchEvent(new CustomEvent("facet:criteria-changed",{
                bubbles: true,
                detail: {
                    url: currentUrl.toString()
                }
            }))
        }
    }
    ;
    window.customElements.define("sort-by-popover", SortByPopover);
    var CartCount = class extends CustomHTMLElement {
        connectedCallback() {
            this.rootDelegate.on("cart:updated", event=>{
                // 捆绑销售-购物车数量处理-gzg
                const cartItems = event.detail.cart["items"];
                if(cartItems.some(item=>!!item.properties.__bundlechild)){
                    const uniqueCartItems = Array.from(
                        new Map(cartItems.map(item => [item.properties.__bundlechild, item])).values()
                    );
                    this.innerText = uniqueCartItems.length;
                }else{
                    this.innerText = event.detail.cart["item_count"]
                }
            })
        }
    }
    ;
    window.customElements.define("cart-count", CartCount);
    var MainCart = class extends CustomHTMLElement {
        connectedCallback() {
            this.rootDelegate.on("cart:updated", event=>{
                this._rerenderCart.bind(this)(event)
            }
            )
        }
        async _rerenderCart(event) {
            var productForm = new ProductForm;
            let cartContent = null
              , html = "";
            if (event.detail && event.detail["cart"] && event.detail["cart"]["sections"] && event.detail["cart"]["sections"]["main-cart"] && typeof event.detail["cart"]["sections"]["main-cart"] !== "undefined") {
                cartContent = event.detail["cart"];
                cartContent = productForm._correctCartCount(cartContent);
                html = event.detail["cart"]["sections"]["main-cart"]
            } else {
                const response = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${this.getAttribute("section")}`);
                html = await response.text();
                cartContent = response.json();
                cartContent = productForm._correctCartCount(cartContent)
            }
            let cart_items = event.detail["cart"]
            
            let total_price = 0
            let money = 0
            if(cart_items.currency && cart_items.total_price){
                total_price = cart_items.total_price/100
                money = changeCurrency(cart_items.currency, FreeGifts.money)
            }else{
                if(html.split('_colorboxCur') && html.split('_colorboxCur').length > 1){
                    let c_str = html.split('_colorboxCur')[1]
                    let currency = c_str.split(' ')[1]
                    money = changeCurrency(currency, FreeGifts.money)
                    if(c_str.split(' ')[0]){
                        total_price = c_str.split(' ')[0].replace(/[^0-9]/ig, "")/100
                    }
                }
            }

            if(total_price < money || !FreeGifts.isOpen){
                $(".main-cart-page").find(".colorbox-badge-wrapper").remove();
            }
          
            const doc = (new DOMParser).parseFromString(html, "text/html");
            html = doc.querySelector("main-cart");
            this.innerHTML = html.innerHTML;
            document.dispatchEvent(new CustomEvent("afterpay:reload",{
                bubbles: true,
                detail: {
                    cart: cartContent
                }
            }))
        }
    }
    ;
    window.customElements.define("main-cart", MainCart);
    var CartDrawer = class extends DrawerContent {
        connectedCallback() {
            super.connectedCallback();
            this.nextReplacementDelay = 0;
            this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this));
            this.addEventListener("variant:added", ()=>this.nextReplacementDelay = 600)
            this.giftAdd()
        }
        async _rerenderCart(event) {
            var _a;
            var productForm = new ProductForm;
            let cartContent = null
              , html = "";
            if (event.detail && event.detail["cart"] && event.detail["cart"]["sections"] && event.detail["cart"]["sections"]["mini-cart"] && typeof event.detail["cart"]["sections"]["mini-cart"] !== "undefined") {
                cartContent = event.detail["cart"];
                cartContent = productForm._correctCartCount(cartContent);
                html = event.detail["cart"]["sections"]["mini-cart"]
            } else {
                const response = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${this.getAttribute("section")}`);
                html = await response.text()
            }
            let cart_items = event.detail["cart"]

            const fakeDiv = document.createElement("div");
            fakeDiv.innerHTML = html;
            const { pathname } = window.location;
            let dc = fakeDiv.querySelectorAll('.drawer__content')
          
            let total_price = 0
            let money = 0
            if(cart_items.currency && cart_items.total_price){
                total_price = cart_items.total_price/100
                money = changeCurrency(cart_items.currency, FreeGifts.money)
            }else{
                if(html.split('_colorboxCur') && html.split('_colorboxCur').length > 1){
                    let c_str = html.split('_colorboxCur')[1]
                    let currency = c_str.split(' ')[1]
                    money = changeCurrency(currency, FreeGifts.money)
                    if(c_str.split(' ')[0]){
                        total_price = c_str.split(' ')[0].replace(/[^0-9]/ig, "")/100
                    }
                }
            }
            if(total_price < money || !FreeGifts.isOpen){
                if(dc && dc[0]){
                    let cw = dc[0].querySelectorAll('.colorbox-badge-wrapper')[0]
                    if(cw) {
                        dc[0].removeChild(cw)
                    }
                }
                $(".main-cart-page").find(".colorbox-badge-wrapper").remove();
            }

            const _this = this;
            setTimeout(async()=>{
                if(total_price < money || !FreeGifts.isOpen){
                    $(".main-cart-page").find(".colorbox-badge-wrapper").remove();
                }
                var _a2;
                const previousPosition = _this.querySelector(".drawer__content")?.scrollTop;
                if (cartContent && cartContent["item_count"] === 0) {
                    const animation = new CustomAnimation(new ParallelEffect(Array.from(_this.querySelectorAll(".drawer__content, .drawer__footer")).map(item=>{
                        return new CustomKeyframeEffect(item,{
                            opacity: [1, 0]
                        },{
                            duration: 250,
                            easing: "ease-in"
                        })
                    }
                    )));
                    animation.play();
                    await animation.finished
                }
                let cdr = fakeDiv.querySelector("cart-drawer")
                _this.innerHTML = cdr?cdr.innerHTML:'';

                if (cartContent && cartContent["item_count"] === 0) {
                    _this.querySelector(".drawer__content").animate({
                        opacity: [0, 1],
                        transform: ["translateY(40px)", "translateY(0)"]
                    }, {
                        duration: 450,
                        easing: "cubic-bezier(0.33, 1, 0.68, 1)"
                    })
                } else if (previousPosition) {
                    _this.querySelector(".drawer__content").scrollTop = previousPosition
                }
                if ((_a2 = event == null ? void 0 : event.detail) == null ? void 0 : _a2.openMiniCart) {
                    _this.clientWidth;
                    _this.open = true
                }
                this.giftAdd();
            }
            , ((_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.replacementDelay) || this.nextReplacementDelay);
            this.nextReplacementDelay = 0
        }
        giftAdd() {
            const addGiftBtn = this.querySelector('[giftBag-add-btn]');
            if (addGiftBtn) {
                addGiftBtn.addEventListener("click", () => {
                    const value = addGiftBtn.previousSibling.previousElementSibling.value
                    const item = [{
                        id: value,
                        quantity: 1
                    }];
                    const giftLodaing = addGiftBtn.closest('.line-item__content-wrapper').querySelector('.line-item__loader');
                    giftLodaing.hidden = false;
                    giftLodaing.firstElementChild.hidden = false;
                    giftLodaing.lastElementChild.hidden = true
                    handleAddToCart(item, () => {
                        giftLodaing.hidden = true;
                        giftLodaing.firstElementChild.hidden = true;
                        giftLodaing.lastElementChild.hidden = false;
                    }, true)
                });
            }
        }
        async attributeChangedCallback(name, oldValue, newValue) {
            super.attributeChangedCallback(name, oldValue, newValue);
            switch (name) {
            case "open":
                if (this.open) {
                    this.querySelector(".drawer__content").scrollTop = 0;
                    if (!MediaFeatures.prefersReducedMotion()) {
                        const lineItems = Array.from(this.querySelectorAll(".line-item"))
                          , recommendationsInner = this.querySelector(".mini-cart__recommendations-inner")
                          , bottomBar = this.querySelector(".drawer__footer")
                          , effects = [];
                        if (recommendationsInner && window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                            lineItems.push(recommendationsInner)
                        }
                        lineItems.forEach(item=>item.style.opacity = 0);
                        recommendationsInner ? recommendationsInner.style.opacity = 0 : null;
                        bottomBar ? bottomBar.style.opacity = 0 : null;
                        effects.push(new ParallelEffect(lineItems.map((item,index)=>{
                            return new CustomKeyframeEffect(item,{
                                opacity: [0, 1],
                                transform: ["translateX(40px)", "translateX(0)"]
                            },{
                                duration: 400,
                                delay: 400 + 120 * index - Math.min(2 * index * index, 120 * index),
                                easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                            })
                        }
                        )));
                        if (bottomBar) {
                            effects.push(new CustomKeyframeEffect(bottomBar,{
                                opacity: [0, 1],
                                transform: ["translateY(100%)", "translateY(0)"]
                            },{
                                duration: 300,
                                delay: 400,
                                easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                            }))
                        }
                        if (recommendationsInner && !window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                            effects.push(new CustomKeyframeEffect(recommendationsInner,{
                                opacity: [0, 1],
                                transform: ["translateX(100%)", "translateX(0)"]
                            },{
                                duration: 250,
                                delay: 400 + Math.max(120 * lineItems.length - 25 * lineItems.length, 25),
                                easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                            }))
                        }
                        let animation = new CustomAnimation(new ParallelEffect(effects));
                        animation.play()
                    }
                }
            }
        }
    }
    ;
    window.customElements.define("cart-drawer", CartDrawer);
    var _CartDrawerRecommendations = class extends HTMLElement {
        async connectedCallback() {
            if (!_CartDrawerRecommendations.recommendationsCache[this.productId]) {
                _CartDrawerRecommendations.recommendationsCache[this.productId] = fetch(`${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`)
            }
            const response = await _CartDrawerRecommendations.recommendationsCache[this.productId];
            const div = document.createElement("div");
            div.innerHTML = await response.clone().text();
            const productRecommendationsElement = div.querySelector("cart-drawer-recommendations");
            if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
                this.innerHTML = productRecommendationsElement.innerHTML
            } else {
                this.hidden = true
            }
        }
        get productId() {
            return this.getAttribute("product-id")
        }
        get sectionId() {
            return this.getAttribute("section-id")
        }
    }
    ;
    var CartDrawerRecommendations = _CartDrawerRecommendations;
    __publicField(CartDrawerRecommendations, "recommendationsCache", {});
    window.customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);
    var CartNote = class extends HTMLTextAreaElement {
        connectedCallback() {
            this.addEventListener("change", this._onNoteChanged.bind(this))
        }
        get ownedToggle() {
            return this.hasAttribute("aria-owns") ? document.getElementById(this.getAttribute("aria-owns")) : null
        }
        async _onNoteChanged() {
            if (this.ownedToggle) {
                this.ownedToggle.innerHTML = this.value === "" ? window.themeVariables.strings.cartAddOrderNote : window.themeVariables.strings.cartEditOrderNote
            }
            const response = await fetch(`${window.themeVariables.routes.cartUrl}/update.js`, {
                body: JSON.stringify({
                    note: this.value
                }),
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const cartContent = await response.json();
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated",{
                bubbles: true,
                detail: {
                    cart: cartContent,
                    cartNote: true
                }
            }))
        }
    }
    ;
    window.customElements.define("cart-note", CartNote, {
        extends: "textarea"
    });
    var FreeShippingBar = class extends HTMLElement {
        connectedCallback() {
            document.documentElement.addEventListener("cart:updated", this._onCartUpdated.bind(this))
        }
        get threshold() {
            return parseFloat(this.getAttribute("threshold"))
        }
        _onCartUpdated(event) {
            // setTimeout(()=>{
                this.style.setProperty("--progress", Math.min(parseFloat(event.detail["cart"]["total_price"]) / this.threshold, 1));
            // }, 1000)
        }
    }
    ;
    window.customElements.define("free-shipping-bar", FreeShippingBar);
    var LineItemQuantity = class extends CustomHTMLElement {
        connectedCallback() {
            this.delegate.on("click", "a", this._onQuantityLinkClicked.bind(this));
            this.delegate.on("change", "input", this._onQuantityChanged.bind(this))
        }
        _onQuantityLinkClicked(e, target) {
            e.preventDefault();
            this._updateFromLink(target.href)
        }
        _onQuantityChanged(event, target) {
            event.preventDefault();
            this._updateFromLink(`${window.themeVariables.routes.cartChangeUrl}?quantity=${target.value}&line=${target.getAttribute("data-line")}&id=${target.getAttribute("data-id")}&vartintids=${target.getAttribute("data-variants")}`)
        }
        async _updateFromLink(link) {
            const changeUrl = new URL(link,`https://${window.themeVariables.routes.host}`);
            const searchParams = changeUrl.searchParams;
            const line = searchParams.get("line");
            const id = searchParams.get("id");
            const vartintids = searchParams.get("vartintids");
            const quantity = parseInt(searchParams.get("quantity"));
            const bundleItems = searchParams.get("bundle_items") ? searchParams.get("bundle_items").split(";") : null;

            this.dispatchEvent(new CustomEvent("line-item-quantity:change:start",{
                bubbles: true,
                detail: {
                    newLineQuantity: quantity
                }
            }));
            let response
            if(vartintids?.indexOf(',') > -1){
                const ids = vartintids.split(',');
                const updates = {};
                ids.forEach(item=>{
                    if (item) {
                        updates[item] = quantity
                    }
                });
                await fetch(`${window.themeVariables.routes.cartUpdateUrl}.js`, {
                    body: JSON.stringify({
                        updates: updates
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
            }else{
                response = await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
                    body: JSON.stringify({
                        line: line,
                        id: id,
                        quantity: quantity,
                        sections: ["mini-cart", "main-cart"]
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                });
            }
            if (bundleItems) {
                const updates = {};
                bundleItems.forEach(item=>{
                    if (item) {
                        updates[item] = quantity
                    }
                }
                );
                await Shopify.getCart();
                response = await fetch(`${window.themeVariables.routes.cartUpdateUrl}.js`, {
                    body: JSON.stringify({
                        updates: updates
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
            }
            const productForm = new ProductForm;
            await Shopify.getCart();
            let cartContent = await response?.json(); 
            
            await fetch('/cart.js').then(async (scaRes) => {
                  cartContent = await scaRes.json();
             })

            cartContent = productForm._correctCartCount(cartContent);
            let total_price = cartContent.total_price/100
            let is_free = false;
            let free_id = ''
            cartContent.items.forEach((v, k)=>{
                if(Object.values(v.properties).length){
                    for(let o in v.properties){
                        if(o == '__free'){
                            is_free = true;
                            free_id = v.id
                        }
                    }
                }
            })
            let money = changeCurrency(cartContent.currency, FreeGifts.money)
            if(total_price >= money && !is_free){
                colorboxFun()
            }
            if(total_price < money && is_free){
                this._updateFromLink(`${window.themeVariables.routes.cartChangeUrl}?quantity=0&id=${free_id}`)
            }
            this.dispatchEvent(new CustomEvent("line-item-quantity:change:end",{
                bubbles: true,
                detail: {
                    cart: cartContent,
                    newLineQuantity: quantity
                }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated",{
                bubbles: true,
                detail: {
                    cart: cartContent,
                    variant: bundleItems ? Number(bundleItems[0]) : Number(id)
                }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{
                bubbles: true,
                detail: {
                    cart: cartContent,
                    replacementDelay: quantity === 0 ? 600 : 750
                }
            }))
        }
    }
    ;
    window.customElements.define("line-item-quantity", LineItemQuantity);
    var LineItem = class extends HTMLElement {
        connectedCallback() {
            this.lineItemLoader = this.querySelector(".line-item__loader");
            this.addEventListener("line-item-quantity:change:start", this._onQuantityStart.bind(this));
            this.addEventListener("line-item-quantity:change:end", this._onQuantityEnd.bind(this))
        }
        _onQuantityStart() {
            if (!this.lineItemLoader) {
                return
            }
            this.lineItemLoader.hidden = false;
            this.lineItemLoader.firstElementChild.hidden = false;
            this.lineItemLoader.lastElementChild.hidden = true
        }
        async _onQuantityEnd(event) {
            if (event.detail.cart["item_count"] === 0) {
                return
            }
            if (this.lineItemLoader) {
                await this.lineItemLoader.firstElementChild.animate({
                    opacity: [1, 0],
                    transform: ["translateY(0)", "translateY(-10px)"]
                }, 75).finished;
                this.lineItemLoader.firstElementChild.hidden = true;
                if (event.detail.newLineQuantity === 0) {
                    await this.animate({
                        opacity: [1, 0],
                        height: [`${this.clientHeight}px`, 0]
                    }, {
                        duration: 300,
                        easing: "ease"
                    }).finished;
                    this.remove()
                } else {
                    this.lineItemLoader.lastElementChild.hidden = false;
                    await this.lineItemLoader.lastElementChild.animate({
                        opacity: [0, 1],
                        transform: ["translateY(10px)", "translateY(0)"]
                    }, {
                        duration: 75,
                        endDelay: 300
                    }).finished;
                    this.lineItemLoader.hidden = true
                }
            }
        }
    }
    ;
    window.customElements.define("line-item", LineItem);
    var CartNotification = class extends CustomHTMLElement {
        connectedCallback() {
            this.rootDelegate.on("cart-notification:show", this._onShow.bind(this), !this.hasAttribute("global"));
            this.delegate.on("click", '[data-action="close"]', event=>{
                event.stopPropagation();
                this.hidden = true
            }
            );
            this.addEventListener("mouseenter", this.stopTimer.bind(this));
            this.addEventListener("mouseleave", this.startTimer.bind(this));
            window.addEventListener("pagehide", ()=>this.hidden = true)
        }
        set hidden(value) {
            if (!value) {
                this.startTimer()
            } else {
                this.stopTimer()
            }
            this.toggleAttribute("hidden", value)
        }
        get isInsideDrawer() {
            return this.classList.contains("cart-notification--drawer")
        }
        stopTimer() {
            clearTimeout(this._timeout)
        }
        startTimer() {
            this._timeout = setTimeout(()=>this.hidden = true, 3e3)
        }
        _onShow(event) {
            if (this.isInsideDrawer && !this.closest(".drawer").open) {
                return
            }
            if (this.hasAttribute("global") && event.detail.status === "success" && window.themeVariables.settings.cartType === "drawer") {
                return
            }
            event.stopPropagation();
            let closeButtonHtml = "";
            if (!this.isInsideDrawer) {
                closeButtonHtml = `
        <button class="cart-notification__close tap-area hidden-phone" data-action="close">
          <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
          <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
          </svg>
        </button>
      `
            }
            if (event.detail.status === "success") {
                this.classList.remove("cart-notification--error");
                this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>
              </svg>
              
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading hidden-phone">${window.themeVariables.strings.cartItemAdded}</span>
                <span class="cart-notification__heading heading hidden-tablet-and-up">${window.themeVariables.strings.cartItemAddedShort}</span>
                <a href="${window.themeVariables.routes.cartUrl}" class="cart-notification__view-cart link" aria-label="cart view">${window.themeVariables.strings.cartViewCart}</a>
              </div>
              
              ${closeButtonHtml}
            </div>
          </div>
        </div>
      `
            } else {
                this.classList.add("cart-notification--error");
                this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
              </svg>
              
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading">${event.detail.error}</span>
              </div>
              
              ${closeButtonHtml}
            </div>
          </div>
        </div>
      `
            }
            this.clientHeight;
            this.hidden = false
        }
    }
    ;
    window.customElements.define("cart-notification", CartNotification);
    var ShippingEstimator = class extends HTMLElement {
        connectedCallback() {
            this.submitButton = this.querySelector('[type="button"]');
            this.submitButton.addEventListener("click", this._estimateShipping.bind(this))
        }
        async _estimateShipping() {
            const zip = this.querySelector('[name="shipping-estimator[zip]"]').value
              , country = this.querySelector('[name="shipping-estimator[country]"]').value
              , province = this.querySelector('[name="shipping-estimator[province]"]').value;
            this.submitButton.setAttribute("aria-busy", "true");
            const prepareResponse = await fetch(`${window.themeVariables.routes.cartUrl}/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
                method: "POST"
            });
            if (prepareResponse.ok) {
                const shippingRates = await this._getAsyncShippingRates(zip, country, province);
                this._formatShippingRates(shippingRates)
            } else {
                const jsonError = await prepareResponse.json();
                this._formatError(jsonError)
            }
            this.submitButton.removeAttribute("aria-busy")
        }
        async _getAsyncShippingRates(zip, country, province) {
            const response = await fetch(`${window.themeVariables.routes.cartUrl}/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
            const responseAsText = await response.text();
            if (responseAsText === "null") {
                return this._getAsyncShippingRates(zip, country, province)
            } else {
                return JSON.parse(responseAsText)["shipping_rates"]
            }
        }
        _formatShippingRates(shippingRates) {
            var _a;
            (_a = this.querySelector(".shipping-estimator__results")) == null ? void 0 : _a.remove();
            let formattedShippingRates = "";
            shippingRates.forEach(shippingRate=>{
                formattedShippingRates += `<li>${shippingRate["presentment_name"]}: ${formatMoney(parseFloat(shippingRate["price"]) * 100)}</li>`
            }
            );
            const html = `
      <div class="shipping-estimator__results">
        <p>${shippingRates.length === 0 ? window.themeVariables.strings.shippingEstimatorNoResults : shippingRates.length === 1 ? window.themeVariables.strings.shippingEstimatorOneResult : window.themeVariables.strings.shippingEstimatorMultipleResults}</p>
        ${formattedShippingRates === "" ? "" : `<ul class="unordered-list">${formattedShippingRates}</ul>`}
      </div>
    `;
            this.insertAdjacentHTML("beforeend", html)
        }
        _formatError(errors) {
            var _a;
            (_a = this.querySelector(".shipping-estimator__results")) == null ? void 0 : _a.remove();
            let formattedShippingRates = "";
            Object.keys(errors).forEach(errorKey=>{
                formattedShippingRates += `<li>${errorKey} ${errors[errorKey]}</li>`
            }
            );
            const html = `
      <div class="shipping-estimator__results">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="unordered-list">${formattedShippingRates}</ul>
      </div>
    `;
            this.insertAdjacentHTML("beforeend", html)
        }
    }
    ;
    window.customElements.define("shipping-estimator", ShippingEstimator);
    var ReviewLink = class extends HTMLAnchorElement {
        constructor() {
            super();
            this.addEventListener("click", this._onClick.bind(this))
        }
        _onClick() {
            const shopifyReviewsElement = document.getElementById("shopify-product-reviews");
            if (!shopifyReviewsElement) {
                return
            }
            if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                shopifyReviewsElement.closest("collapsible-content").open = true
            } else {
                document.querySelector(`[aria-controls="${shopifyReviewsElement.closest(".product-tabs__tab-item-wrapper").id}"]`).click()
            }
        }
    }
    ;
    window.customElements.define("review-link", ReviewLink, {
        extends: "a"
    });
    var ProductStickyForm = class extends HTMLElement {
        connectedCallback() {
            var _a;
            (_a = document.getElementById(this.getAttribute("form-id"))) == null ? void 0 : _a.addEventListener("variant:changed", this._onVariantChanged.bind(this));
            this.imageElement = this.querySelector(".product-sticky-form__image");
            this.priceElement = this.querySelector(".product-sticky-form__price");
            this.unitPriceElement = this.querySelector(".product-sticky-form__unit-price");
            this._setupVisibilityObservers()
        }
        disconnectedCallback() {
            this.intersectionObserver.disconnect()
        }
        set hidden(value) {
            this.toggleAttribute("hidden", value);
            if (value) {
                document.documentElement.style.removeProperty("--cart-notification-offset")
            } else {
                document.documentElement.style.setProperty("--cart-notification-offset", `${this.clientHeight}px`)
            }
        }
        _onVariantChanged(event) {
            const variant = event.detail.variant
              , currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
            if (!variant) {
                return
            }
            if (this.priceElement) {
                this.priceElement.innerHTML = formatMoney(variant["price"], currencyFormat)
            }
            if (this.unitPriceElement) {
                this.unitPriceElement.style.display = variant["unit_price_measurement"] ? "block" : "none";
                if (variant["unit_price_measurement"]) {
                    let referenceValue = "";
                    if (variant["unit_price_measurement"]["reference_value"] !== 1) {
                        referenceValue = `<span class="unit-price-measurement__reference-value">${variant["unit_price_measurement"]["reference_value"]}</span>`
                    }
                    this.unitPriceElement.innerHTML = `
          <div class="unit-price-measurement">
            <span class="unit-price-measurement__price">${formatMoney(variant["unit_price"])}</span>
            <span class="unit-price-measurement__separator">/</span>
            ${referenceValue}
            <span class="unit-price-measurement__reference-unit">${variant["unit_price_measurement"]["reference_unit"]}</span>
          </div>
        `
                }
            }
            if (!this.imageElement || !variant || !variant["featured_media"]) {
                return
            }
            const featuredMedia = variant["featured_media"];
            if (featuredMedia["alt"]) {
                this.imageElement.setAttribute("alt", featuredMedia["alt"])
            }
            this.imageElement.setAttribute("width", featuredMedia["preview_image"]["width"]);
            this.imageElement.setAttribute("height", featuredMedia["preview_image"]["height"]);
            this.imageElement.setAttribute("src", getSizedMediaUrl(featuredMedia, "165x"));
            this.imageElement.setAttribute("srcset", getMediaSrcset(featuredMedia, [55, 110, 165]))
        }
        _setupVisibilityObservers() {
            const paymentContainerElement = document.getElementById("MainPaymentContainer")
              , footerElement = document.querySelector(".shopify-section--footer")
              , stickyHeaderOffset = getStickyHeaderOffset();
            this._isFooterVisible = this._isPaymentContainerPassed = false;
            this.intersectionObserver = new IntersectionObserver(entries=>{
                entries.forEach(entry=>{
                    if (entry.target === footerElement) {
                        this._isFooterVisible = entry.intersectionRatio > 0
                    }
                    if (entry.target === paymentContainerElement) {
                        const boundingRect = paymentContainerElement.getBoundingClientRect();
                        this._isPaymentContainerPassed = entry.intersectionRatio === 0 && boundingRect.top + boundingRect.height <= stickyHeaderOffset
                    }
                }
                );
                if (window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                    this.hidden = !this._isPaymentContainerPassed || this._isFooterVisible
                } else {
                    this.hidden = !this._isPaymentContainerPassed
                }
            }
            ,{
                rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px`
            });
            this.intersectionObserver.observe(paymentContainerElement);
            this.intersectionObserver.observe(footerElement)
        }
    }
    ;
    window.customElements.define("product-sticky-form", ProductStickyForm);
    
    var ProductBundler = class extends HTMLElement {
        connectedCallback(){
            // if ( this.querySelector('css-slider') ) {
            //     this.querySelector('css-slider').addEventListener('ready', ()=>{
            //         this.init();
            //     })
            // } else {
            this.init();
            // }
        }
        _correctCartCount(cartContent) {
            let cartCount = cartContent.item_count;
            cartContent?.items?.forEach(item=>{
                if (item.properties && item.properties["__bundle"] && item.properties["__bundle"]?.rule === "bundle" && !item.properties["__bundle"].set) {
                    cartCount -= item.quantity
                }
            }
            );
            cartContent.item_count = cartCount;
            return cartContent
        }
        init(){
            this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];
            this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);
            this._bundleMin = parseInt(this.dataset.minimum);
            this.querySelectorAll('[data-product-add-to-cart-button]').forEach(elm=>{
                elm.addEventListener('click', e=>{
                    e.preventDefault();
                    const product = e.target.closest('product-item');
                    const id = product.querySelector('.shopify-product-form').querySelector('input[name="id"]').value;
                    const variant = JSON.parse(product.querySelector('[type="application/json"]').textContent).find(variant=>{
                        return variant["id"] == id;
                    })
                    this.addToBundle(variant, product);
                    this.classList.add('opened');
                });
            });
            this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm=>{
                elm.addEventListener('click', e=>{
                    this.clearSlot(e.target.closest('[data-js-bundler-product]'));
                });
            });
            this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e=>{
                if ( window.innerWidth < 768 ) {
                    this.classList.toggle('opened');
                }
            });
            this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e=>{
                if ( ! this.findEmptySlot() ) {
                    let items = [];
                    this.bundleProducts.map(elm=>{
                    if ( elm.dataset.id ) {
                        if ( ! items.find(item => {
                        if ( item.id == elm.dataset.id ) {
                            item.quantity++;
                            return true;
                        }
                        }) ) {
                        items.push({
                            id: elm.dataset.id,
                            quantity: 1
                        })
                        }
                    }
                    })
                    if ( items.length > 0 ) {
                        const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
                        submitButton.classList.add('working');
                        fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
                            body: JSON.stringify({'items': items}),
                            method: "POST",
                            credentials: "same-origin",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(async (response) => {
                            const responseJson = await response.json();
                            if (response.ok) {
                                this.dispatchEvent(new CustomEvent("variant:added",{
                                    bubbles: true,
                                    detail: {
                                        variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
                                    }
                                }));
                                fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async response2=>{  
                                    await Shopify.getCart();
                                    let cartContent = await response2.json();
                                    await fetch('/cart.js').then(async scaRes => {
                                    cartContent = await scaRes.json();
                                    })
                                    let money = changeCurrency(cartContent.currency, FreeGifts.money)
                                    let total_price = cartContent.total_price/100
                                    let hasFree = false
                                    cartContent.items.forEach((v, k)=>{
                                        if(Object.values(v.properties).length){
                                            for(let o in v.properties){
                                                if(o == '__free'){
                                                    hasFree = true;
                                                }
                                            }
                                        }
                                    })
                                    if(total_price >= money && !hasFree){
                                        colorboxFun()
                                    }
                                    cartContent = this._correctCartCount(cartContent);
                                    document.documentElement.dispatchEvent(new CustomEvent("cart:updated",{
                                        bubbles: true,
                                        detail: {
                                            cart: cartContent,
                                            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0].id : responseJson.id
                                        }
                                    }))
                                }
                                );
                                const groupDiscountPopup = document.querySelector(".group-discount-popup");
                                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{
                                    bubbles: true,
                                    detail: {
                                        cart: responseJson,
                                        openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null && (!groupDiscountPopup || groupDiscountPopup.classList.value.search("active") < 0)
                                    }
                                }))
                                this.querySelectorAll('[data-js-bundler-product]').forEach(elm=>{
                                    this.clearSlot(elm);
                                });
                                this.classList.remove('opened');
                            }
                            submitButton.classList.remove('working');
                            this.dispatchEvent(new CustomEvent("cart-notification:show",{
                                bubbles: true,
                                cancelable: true,
                                detail: {
                                    status: response.ok ? "success" : "error",
                                    error: responseJson["description"] || ""
                                }
                            }))
                        })
                    }
                }
            });
        }
      
        findEmptySlot() {
            return this.bundleProducts.find(elm=>{
                return elm.classList.contains('bundler-product--empty')
            });
        }
          
        clearSlot(slot) {
            if ( this.bundleProducts.length > this._bundleMin ) {
                this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1)
                slot.remove();
            } else {
                slot.product.classList.remove('product-item--bundled');
                slot.dataset.id = "";
                slot.product = null;
                slot.classList.add('bundler-product--empty');
                slot.querySelector('[data-js-bundler-product-text]').innerHTML = '';
                slot.querySelector('[data-js-bundler-product-image]').innerHTML = '';
            }
            if ( this.findEmptySlot() ) {
                this.classList.remove('bundler-full');
            }
            this.reorderSlots();
        }
      
        reorderSlots() {
            let ei = 0,
                fi = -100;
            this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i)=>{
                if ( elm.classList.contains('bundler-product--empty') ) {
                    elm.style.order = ei++;
                } else {
                    elm.style.order = fi++;
                }
            });
        }
      
        createSlot(){
            const newSlot = this._bundleTemplate.cloneNode(true);
            newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e=>{
                this.clearSlot(e.target.closest('[data-js-bundler-product]'));
            });
            this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
            this.bundleProducts.push(newSlot);
        }
      
        addToBundle(variant, product) {
            let slot = this.findEmptySlot();
            const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;
            if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
                this.createSlot();
                slot = this.findEmptySlot();
            } 
            if ( slot ) { 
                slot.classList.remove('bundler-product--empty');
                slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
                    <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
                    <span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>
                `;
                slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
                    <img src="${this.getResizedImageSrc(imageSrc, 60)}"
                    srcset="
                        ${this.getResizedImageSrc(imageSrc, 60)} 60w,
                        ${this.getResizedImageSrc(imageSrc, 120)} 120w,
                        ${this.getResizedImageSrc(imageSrc, 180)} 180w
                    "
                    alt="product image"
                    sizes="60px"
                    height="600" width="350"
                    />
                `;
                if ( this.hasAttribute('data-limit-bundles') ) {
                    product.classList.add('product-item--bundled');
                }
                slot.product = product;
                slot.dataset.id = product.querySelector('input[name="id"]').value;
            } else {
                // when bundle is full, show message
            }
            if ( ! this.findEmptySlot() ) {
                this.classList.add('bundler-full');
            }
        }
        getResizedImageSrc(src, size, crop='center') {
            return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
        }
    };
    window.customElements.define("product-bundler", ProductBundler);
    
    var ProductsSet = class extends HTMLElement {
        connectedCallback(){
            this.initSet();
            this.checkSet();
            this.querySelector('[data-js-add-set-to-cart]' ).addEventListener('click', e=>{
                let items = [];
                Object.keys(this.set).map(key=>{
                if ( this.set[key] !== null ) {
                    items.push({
                    id: this.set[key],
                    quantity: 1
                    })
                }
                });
                if ( items.length > 0 ) {
                    const submitButton = this.querySelector('[data-js-add-set-to-cart]');
                    submitButton.classList.add('working');
                    handleAddToCart(items, () => {
                        submitButton.classList.remove('working');
                        this.returnToDefaultSate();
                    })
                }
            });
        }
        initSet(){
            this.set = {};
            this.querySelectorAll('product-variants').forEach(elm=>{
                const btn = elm.parentNode.querySelector('[data-product-add-to-cart-button]');
                const setBtnStyle = (id) => {
                    console.log(elm.dataset.id)
                    if ( id ) {
                        this.set[elm.dataset.id] = id;
                        elm.closest('product-item').classList.add('selected');
                        if (btn.classList.contains('disabled')) {
                            btn.classList.remove('disabled');
                        }
                    } else {
                        this.set[elm.dataset.id] = null;
                        if (!btn.classList.contains('disabled')) {
                            btn.classList.add('disabled');
                        }
                    }
                    this.checkSet();
                }
                if ( ! elm.hasAttribute('data-has-variants') && ! elm.hasAttribute('data-unavailable') ) {
                    this.set[elm.dataset.id] = elm.parentNode.querySelector('input[name="id"]').value;
                } else {
                    this.set[elm.dataset.id] = null;
                    // setBtnStyle(elm.parentNode.querySelector('input[name="id"]').value);
                    elm.delegate.on("change", '[name^="option"]', e => {
                        let variant = elm._getVariantFromOptions();
                        setBtnStyle(variant?.id);
                    })
                }
            });
        }
      
        checkSet() {
            let setFull = true;
            Object.keys(this.set).map(key=>{
                if ( this.set[key] === null ) {
                    setFull = false;
                }
            })
            if ( setFull && this.classList.contains('products-set--empty' ) ) {
                this.classList.remove('products-set--empty');
                this.querySelector('[data-js-add-set-to-cart-text]').textContent = 'Add all to cart';
            } else if ( !setFull && !this.classList.contains('products-set--empty' ) ) {
                this.classList.add('products-set--empty');
            }
            return setFull;
        }
      
        returnToDefaultSate(){
            this.querySelectorAll('product-variants').forEach(elm=>{
                elm.querySelectorAll('input').forEach(input=>{
                    input.checked = false;
                })
                elm.querySelectorAll('select').forEach(select=>{
                    select.selectedIndex = 0;
                })
                if ( ! ( ! elm.hasAttribute('data-has-variants') && ! elm.hasAttribute('data-unavailable') ) ) {
                    elm.currentVariant = undefined;
                    elm.parentNode.querySelector('[data-product-add-to-cart-button]').classList.add('disabled');
                } 
            });
            this.querySelectorAll('product-item').forEach(elm=>{
                elm.classList.remove('selected');
            });
            this.initSet();
            this.checkSet();
            this.querySelector('[data-js-add-set-to-cart-text]').textContent = 'Choose products first';
        }
    }
    window.customElements.define("products-set", ProductsSet);
    $(document).on('click', '#colorbox .close-box', function () {
        $.colorbox.close();
        return false;
    })
    $(document).on('click', '.colorbox-open-box', function () {
        colorboxFun()
    })

    
    var SECOMFREE = {};
    SECOMFREE.setCookie = function (e, t, o = 1, r, i) {
        var n = new Date;
        n.setTime(n.getTime() + 24 * o * 60 * 60 * 1000);
        var a = "expires=" + n.toGMTString();
        document.cookie = e + "=" + t + ";" + a + (i ? ";path=" + i : ";path=/")
    }
    SECOMFREE.deleteCookie = function (e, t) {
        document.cookie = e + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; " + (t ? ";path=" + t : ";path=/")
    }
    SECOMFREE.getCookie = function (e) {
        for (var t = e + "=", o = document.cookie.split(";"), r = 0; r < o.length; r++) {
            for (var i = o[r]; " " == i.charAt(0);) i = i.substring(1);
            if (0 == i.indexOf(t)) return i.substring(t.length, i.length)
        }
        return ""
    }
    var loadQuickBuyContent = function loadQuickBuyContent(href) {
      activeQuickBuyRequest = $.get(href, function (data) {

        var $productSection = $('<div>').append($(data).find('.product.product--thumbnails-left').clone());

        //Prepare the html
        $productSection.find('[data-cc-animate]').removeAttr('data-cc-animate');
        $productSection.find('.service-box').remove();
        $productSection.find('.product-meta__aside').remove();
        $productSection.find('.product__zoom-button').remove();
        $productSection.find('.product__media-nav').remove();
        $productSection.find('.trustedsite-trustmark').remove();
        $productSection.find('.product-form__inventory-wrapper').remove();
        $productSection.find('.product-notice').remove();
        $productSection.find('.notifyDiv').remove();
        $productSection.find('.stamped-product-reviews-badge').parent().remove();
        $productSection.find('product-meta.product-meta.only-m').remove();
        $productSection.find('.product__info product-meta.product-meta').removeClass('only-pc');
        $productSection.find('.input-addcat').css({"align-items": "center"}).append(`<div class="close-box">NO THANKS</div>`);
        $productSection.find('.input-addcat .product-form__buy-buttons').css({"width": "70%", "margin-left": "0"})
        $productSection.find('.product-meta__title').html('').append(`
            <span>CONGRATULATIONS!</span>
            <p>You've just unlocked a <span>FREE</span> Best-Selling Shaper!</p>
            <p>Hurry up! Limited stock.</p>
            <p>Free gift is not eligible for return or exchange.</p>
        `);

        var $form = $('<div class="quickbuy-form quickbuy-form--overlay">' + $productSection.html() + '</div>');

        // ensure ids and labels match up
        $form.find('label[for]').each(function () {
            $(this).attr('for', $(this).attr('for') + '-qb');
        });

        $form.find(':input[id]').each(function () {
            $(this).attr('id', $(this).attr('id') + '-qb');
        });

        var $quickbuyContainer = $('.quickbuy-container');
        $form.find('.product-form .product-form__quantity').remove();
        $quickbuyContainer.html($form);
        $('body').removeClass('product-added-to-cart');

        $form.hide().fadeIn(300, function () {
        $('.quickbuy-form.placeholder').remove();
        $form.removeClass('quickbuy-form--overlay');
        $.colorbox.resize();
        });

        $(document).trigger('cc:component:load', ['accordion', $('.quickbuy-container')[0]]);

        activeQuickBuyRequest = null;
      });
    };

    function colorboxFun(){
        // if(!FreeGifts.isOpen){
        //     return;
        // }
        // $.colorbox({
        //     minWidth: '200', maxWidth: '100%', maxHeight: '96%',
        //     closeButton: false,
        //     preloading: false,
        //     open: true,
        //     speed: 200,
        //     html: [
        //     '<div class="action-icons">',
        //     '<a href="#" class="close-box action-icon" aria-label="Close">' + FreeGifts.icons.close + '</a>',
        //     '</div>', 
        //     '<div class="quickbuy-container">',
        //     '<div class="quickbuy-form placeholder">',
        //     '<span class="loading-spinner"></span>',
        //     '</div>',
        //     '</div>'].
        //     join(''),
        //     onComplete: function onComplete() {
        //         loadQuickBuyContent(FreeGifts.freegifts);
        //         $("body").css({"overflow": "hidden"})
        //     },
        //     onCleanup: function onCleanup() {
        //         $("body").css({"overflow": "visible"})
        //     } 
        // });
    }
    // let money = changeCurrency(Shopify.cartItems?.currency, FreeGifts.money)
    // if(Shopify.cart_total_price < money || !FreeGifts.isOpen){
    //     $(".colorbox-badge-wrapper").remove()
    // }

    (()=>{
        new InputBindingManager
    }
    )();
    // (() => {
    //     // 商详页刷新获取组合商品信息
    //     try {
    //         const combosHtmlElesjson = localStorage.getItem('combosHtmlElesjson');
    //         const savedPath = localStorage.getItem('pathname');
    //         const currentPath = window.location.pathname;
    //         if (!Shopify?.current_product || !combosHtmlElesjson || currentPath !== savedPath) return;
    //         const eles = JSON.parse(combosHtmlElesjson);
    //         if (!Array.isArray(eles) || eles.length === 0) return;
    //         // 获取目标元素
    //         const mainEl = document.querySelector('#main');
    //         if (!mainEl) return;
    //         // 更新 DOM
    //         HTMLUpdateUtility.viewTransition(mainEl, eles[0], [], [], 0);
    //     } catch (error) {
    //         console.error('组合商品加载失败:', error);
    //     }
    // })();

    (()=>{
        if (Shopify.designMode) {
            document.addEventListener("shopify:section:load", ()=>{
                if (window.SPR) {
                    window.SPR.initDomEls();
                    window.SPR.loadProducts()
                }
            }
            )
        }
        window.SPRCallbacks = {
            onFormSuccess: (event,info)=>{
                document.getElementById(`form_${info.id}`).classList.add("spr-form--success")
            }
        }
    }
    )();
    (()=>{
        let previousClientWidth = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth;
        let setViewportProperty = ()=>{
            const clientWidth = window.visualViewport ? window.visualViewport.width : document.documentElement.clientWidth
              , clientHeight = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;
            if (clientWidth === previousClientWidth) {
                return
            }
            requestAnimationFrame(()=>{
                document.documentElement.style.setProperty("--window-height", clientHeight + "px");
                previousClientWidth = clientWidth
            }
            )
        }
        ;
        setViewportProperty();
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", setViewportProperty)
        } else {
            window.addEventListener("resize", setViewportProperty)
        }
    }
    )();
    (()=>{
        let documentDelegate = new main_default(document.body);
        documentDelegate.on("change", 'input:not([type="checkbox"]):not([type="radio"]), textarea', (event,target)=>{
            target.classList.toggle("is-filled", target.value !== "")
        }
        );
        documentDelegate.on("change", "select", (event,target)=>{
            target.parentNode.classList.toggle("is-filled", target.value !== "")
        }
        )
    }
    )();
    (()=>{
        document.querySelectorAll(".rte table").forEach(table=>{
            table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + "</div>"
        }
        );
        document.querySelectorAll(".rte iframe").forEach(iframe=>{
            if (iframe.src.indexOf("youtube") !== -1 || iframe.src.indexOf("youtu.be") !== -1 || iframe.src.indexOf("vimeo") !== -1) {
                iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + "</div>"
            }
        }
        )
    }
    )();
    (()=>{
        let documentDelegate = new main_default(document.documentElement);
        documentDelegate.on("click", "[data-smooth-scroll]", (event,target)=>{
            const elementToScroll = document.querySelector(target.getAttribute("href"));
            if (elementToScroll) {
                event.preventDefault();
                elementToScroll.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                })
            }
        }
        )
    }
    )();
    (()=>{
        document.addEventListener("keyup", function(event) {
            if (event.key === "Tab") {
                document.body.classList.remove("no-focus-outline");
                document.body.classList.add("focus-outline")
            }
        })
    }
    )()
    // 点击顶部轮播消息
    $(document).on('click', 'announcement-bar .tap-area', function () {
        setTimeout(() => {
            const promo_message = $('.announcement-bar__item').not('[hidden]').find('.announcement-bar__message div')[0].outerText
            const test = window.location.pathname;
            const index = test.lastIndexOf("\/");
            const page_category = test.slice(1,index) || 'Home'
            const page_name = test.substring(index + 1,test.length) || 'Home'
            window.dataLayer.push({
                "event": "top_promo_click",
                "promo_message": promo_message,
                "page_name": page_name,
                "page_category":page_category
            })
        }, 200);
    })
    // 点击一级导航栏pc端
    $(document).on('click', '.header__linklist-item', function () {
        const linkTitle = $(this).attr('data-item-title')
        window.dataLayer.push({
            "event": "first_navi_click",
            "first_navi_category":linkTitle
        })
    })
    // 点击一级导航栏移动端
    $(document).on('click', '.mobile-nav__item__first > .mobile-nav__link', function () {
        const linkTitle = $(this).attr('data-item-title')
        console.log(linkTitle,'linkTitle')
        window.dataLayer.push({
            "event": "first_navi_click",
            "first_navi_category":linkTitle
        })
    })
    // 点击pc端、移动端搜索
    $(document).on('click', 'store-header .hx-search', function () {
        window.dataLayer.push({
            "event": "first_navi_click",
            "first_navi_category": 'Search Bar'
        })
    })
    // 点击pc端账户中心
    $(document).on('click', '.header__secondary-links .hx-accout', function () {
        window.dataLayer.push({
            "event": "first_navi_click",
            "first_navi_category": 'Account'
        })
    })
    // 点击移动端账户中心
    $(document).on('click', '.header__secondary-links .account-item', function () {
        window.dataLayer.push({
            "event": "first_navi_click",
            "first_navi_category": 'Account'
        })
    })
    // 点击pc端、移动端购物车弹窗
    $(document).on('click', 'store-header .hx-shpping-bag', function () {
        window.dataLayer.push({
            "event": "first_navi_click",
            "first_navi_category": 'Shopping Bag'
        })
    })
    // 点击移动端购物车弹窗
    // $(document).on('click', '.store-header .hx-shpping-bag', function () {
    //     window.dataLayer.push({
    //         "event": "first_navi_click",
    //         "first_navi_category": 'Shopping Bag'
    //     })
    // })
    // 点击二级导航栏pc端
    $(document).on('click', '.mega-menu__inner .mega-menu__title', function () {
        const linkTitle = $(this).parents('.header__linklist-item').attr('data-item-title')
        const secondTitle = $(this)[0].innerText
        window.dataLayer.push({
            "event": "second_navi_click",
            "first_navi_category": linkTitle,
            "second_navi_category": secondTitle
        })
    })
    // 点击三级导航栏
    $(document).on('click', '.mega-menu__inner .linklist__item .link--faded', function () {
        const linkTitle = $(this).parents('.header__linklist-item').attr('data-item-title')
        const secondTitle = $(this)[0].innerText
        window.dataLayer.push({
            "event": "second_navi_click",
            "first_navi_category": linkTitle,
            "second_navi_category": secondTitle
        })
    })
    // 点击二、三级导航栏移动端
    $(document).on('click', '.collapsible .mobile-nav__link', function () {
        const linkTitle = $(this).parents('.mobile-nav__item__first').find('.first-nav').attr('data-item-title')
        const secondTitle = $(this)[0].innerText
        window.dataLayer.push({
            "event": "second_navi_click",
            "first_navi_category": linkTitle,
            "second_navi_category": secondTitle
        })
    })
    // 点击横幅
    $(document).on('click', '.slideshow__slide-list .content-box .button-wrapper a', function () {
        const link_destination = $(this).attr('href')
        const banner_name = $(this).parents('.content-box').find('.heading--large span')[0].innerText
        const test = window.location.pathname;
        const index = test.lastIndexOf("\/");
        const page_category = test.slice(1,index) || 'Home'
        const page_name = test.substring(index + 1,test.length) || 'Home'
        window.dataLayer.push({
            "event": "banner_interaction",
            "banner_name": banner_name,
            "link_destination":link_destination,
            "page_name":page_name,
            "page_category":page_category
        })
    })
    // 点击Welcome to Shapellx Rewards横幅
    $(document).on('click', '.image-with-text__wrapper .button-wrapper a', function () {
        const link_destination = $(this).attr('href')
        const banner_name = $(this).parents('.image-with-text__content-list').find('h3 span')[0].innerText
        const test = window.location.pathname;
        const index = test.lastIndexOf("\/");
        const page_category = test.slice(1,index) || 'Home'
        const page_name = test.substring(index + 1,test.length) || 'Home'
        window.dataLayer.push({
            "event": "banner_interaction",
            "banner_name": banner_name,
            "link_destination":link_destination,
            "page_name":page_name,
            "page_category":page_category
        })
    })
    // 点击首页以及Shop by Category 的横幅元素
    $(document).on('click', '.list-collections__item-list .list-collections__item', function () {
        const link_destination = $(this).attr('href')
        const collection_name = $(this).find('.list-collections__item-info p')[0].innerText
        const banner_name = $(this).parents('.shopify-section--collection-list').find('header .heading')[0].innerText
        const test = window.location.pathname;
        const index = test.lastIndexOf("\/");
        const page_category = test.slice(1,index) || 'Home'
        const page_name = test.substring(index + 1,test.length) || 'Home'
        // alert(1)
        window.dataLayer.push({
            "event": "collection_banner_interaction",
            "banner_name": banner_name,
            "link_destination": link_destination,
            "collection_name": collection_name,
            "page_name": page_name,
            "page_category": page_category
        })
    })
    // 点击下载App
    $(document).on('click', '.sx-down-icon a', function () {
        const app_platform = $(this).attr('data-down')
        // alert(app_platform)
        window.dataLayer.push({
            "event": "click_to_download_app",
            "app_platform": app_platform
        })
    })
    // 点击底部导航栏
    $(document).on('click', 'footer a', function (e) {
        // console.log(e.target.innerText,'element.classList')
        const footer_category = $(this)[0].innerText
        // alert(footer_category)
        window.dataLayer.push({
            "event": "footer_interaction",
            "footer_category": footer_category,
            })
    })
    // 点击聊天插件
    $(document).on('click', '#tidio-chat', function () {
        // alert(22)
        // alert(footer_category)
        window.dataLayer.push({
            "event": "live_chat_started"
            })
    })
    // 点击搜索按钮
    // $(document).on('input propertychange', '.drawer__header .predictive-search__input', function () {
    //     const inputValue = hxTerm
    //     const test = window.location.pathname;
    //     const index = test.lastIndexOf("\/");
    //     const page_category = test.slice(1,index) || 'Home'
    //     const page_name = test.substring(index + 1,test.length) || 'Home'
    //     console.log(inputValue,'556666')
    //     window.dataLayer.push({
    //         "event": "search_intent",
    //         "page_name": page_name,
    //         "page_category": page_category,
    //         "search_query":"$search_query"
    //         })
    // })
    // 点击发送邮件
    $(document).on('click', '.kl-private-reset-css-Xuajs1', function () {
        // alert(22)
        // alert(footer_category)
        window.dataLayer.push({
            "event": "subscription_submission"
            })
    })
    // 提交评论
    $(document).on('click', '#stamped-button-submit', function () {
        const productName = $('#stamped-main-widget').attr('data-name')
        // alert(productName)
        window.dataLayer.push({
            "event": "addReviews",
            "product_name": productName
        })
    })
    // 点击用户分享
    $(document).on('click', '.product-meta__aside .product-meta__share-button-item', function () {
        const product_name = $('.product-meta__title')[0].innerText
        const social_platform = $(this).attr('data-name')
        const test = window.location.pathname;
        const index = test.lastIndexOf("\/");
        const page_name = test.substring(index + 1,test.length) || 'Home'
        window.dataLayer.push({
            "event": "social_sharing",
            "product_name": product_name,
            "social_platform": social_platform,
            "page_name": page_name
        })
    })
    // 联系我们页面
    $(document).on('click', '.contact #contact_form .form__submit', function () {
        window.dataLayer.push({
            "event": "contact_request_submission"
        })
    })
}
)();
